
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("9urSO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0563f92abb938a7c$export$2e2bcd8739ae039);

var $9XZeF = parcelRequire("9XZeF");

var $2n2bS = parcelRequire("2n2bS");

var $68iI4 = parcelRequire("68iI4");

var $b46ZL = parcelRequire("b46ZL");

var $38NkP = parcelRequire("38NkP");
const $0563f92abb938a7c$var$selector = (0, $2n2bS.createSelector)((0, $68iI4.getFabricEmojiUrl), (0, $b46ZL.getAccountId), (fabricEmojiUrl, accountId)=>({
        fabricEmojiUrl: fabricEmojiUrl,
        accountId: accountId
    }));
var $0563f92abb938a7c$export$2e2bcd8739ae039 = (0, $9XZeF.connect)($0563f92abb938a7c$var$selector, {})((0, $38NkP.default));

});
parcelRegister("38NkP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5dc9fc9b24289dc$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $luz1X = parcelRequire("luz1X");

var $9mazR = parcelRequire("9mazR");

var $34z0Z = parcelRequire("34z0Z");

var $1R6m9 = parcelRequire("1R6m9");
var $2VioL = parcelRequire("2VioL");
var $j9zIQ = parcelRequire("j9zIQ");

var $fcCIH = parcelRequire("fcCIH");

var $iz9xD = parcelRequire("iz9xD");
parcelRequire("9S95g");
var $4JZoY = parcelRequire("4JZoY");

var $k9yxi = parcelRequire("k9yxi");
parcelRequire("N8W8m");
var $dYfmc = parcelRequire("dYfmc");
parcelRequire("9mqCJ");
var $5dH3u = parcelRequire("5dH3u");

var $3TJLC = parcelRequire("3TJLC");

var $japzk = parcelRequire("japzk");

var $gucSL = parcelRequire("gucSL");

var $ekmCa = parcelRequire("ekmCa");

var $1My2J = parcelRequire("1My2J");

var $f7AYl = parcelRequire("f7AYl");

var $3UXic = parcelRequire("3UXic");
const $a5dc9fc9b24289dc$var$autoformattingProvider = new (0, $1R6m9.PortalAutoformattingProvider)();
const $a5dc9fc9b24289dc$var$smartCardClient = new (0, $2VioL.PortalCardClient)();
class $a5dc9fc9b24289dc$export$62defb9a02d4952c extends $fc4bM.Component {
    static #_ = this.defaultProps = {
        LoadingComponent: ()=>null
    };
    componentDidMount() {
        this.props.shouldFocus && this.focusOnEditor();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.shouldFocus && this.props.shouldFocus) this.focusOnEditor();
    }
    render() {
        const { editorType: editorType, mediaContext: mediaContext } = this.props;
        const editor = mediaContext ? this.renderEditorWithMediaContext(mediaContext) : this.renderEditor(this.props.customMediaOptions);
        return /*#__PURE__*/ $fc4bM.createElement((0, $4JZoY.default), {
            type: editorType
        }, editor);
    }
    constructor(...args){
        super(...args), this.cardProvider = new (0, $j9zIQ.PortalCardProviderNew)(), this.transformer = new (0, $f7AYl.JSONTransformer)(), this.editorActions = undefined, this.mentionProvider = this.props.accountId ? Promise.resolve((0, $dYfmc.getMentionProvider)(this.props.accountId, this.props.requestKey, this.props.fieldConfigs)) : undefined, this.focusOnEditor = ()=>{
            //we need to use the setTimeout here, otherwise focusing on the editor immediately will cause the caret to flash
            //50ms seem like our magic number, but it might varies on browsers
            setTimeout(()=>{
                this.editorActions && this.editorActions.focus();
            }, 50);
        }, this.onSave = (editorView, actions)=>{
            const { onSave: onSave } = this.props;
            if (onSave) onSave(this.transformer.encode(editorView.state.doc), actions);
        }, this.renderEditorWithMediaContext = (mediaContext)=>{
            const { portalId: portalId, requestId: requestId } = mediaContext;
            return /*#__PURE__*/ $fc4bM.createElement((0, $5dH3u.WithUploadCredentials), {
                portalId: portalId,
                requestId: requestId
            }, (provider)=>this.renderEditorWithMediaProvider(provider));
        }, this.renderEditorWithMediaProvider = (mediaProvider)=>{
            const mediaOptions = {
                provider: mediaProvider,
                allowMediaSingle: true
            };
            return this.renderEditor(mediaOptions);
        }, this.internalOnChange = (editorView)=>{
            const { onChange: onChange } = this.props;
            if (onChange) onChange(this.transformer.encode(editorView.state.doc));
        }, this.renderEditor = (mediaOptions)=>{
            const renderFunction = (actions)=>this.internalRenderEditor(actions, mediaOptions);
            return /*#__PURE__*/ $fc4bM.createElement((0, $1My2J.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $ekmCa.default), {
                render: renderFunction
            }));
        }, this.internalOnCancel = ()=>{
            if (this.editorActions) {
                var _this$props$onCancel, _this$props;
                (_this$props$onCancel = (_this$props = this.props).onCancel) === null || _this$props$onCancel === void 0 || _this$props$onCancel.call(_this$props, this.editorActions);
            }
        }, this.internalOnSave = (editorView)=>{
            if (this.editorActions) this.onSave(editorView, this.editorActions);
        }, this.internalRenderEditor = (actions, mediaOptions)=>{
            const { placeholderWhenCollapsed: placeholderWhenCollapsed, isExpanded: isExpanded, expandEditor: expandEditor, placeholderWhenExpanded: placeholderWhenExpanded, onCancel: onCancel, disabled: disabled, isEmojiEnabled: isEmojiEnabled, defaultValue: defaultValue, fabricEmojiUrl: fabricEmojiUrl, onSave: onSave, ariaLabel: ariaLabel, ariaDescribedby: ariaDescribedby, customSecondaryToolbar: customSecondaryToolbar } = this.props;
            const internalOnCancel = onCancel === undefined ? undefined : ()=>this.internalOnCancel();
            const internalOnSave = onSave === undefined ? undefined : (editorView)=>this.internalOnSave(editorView);
            this.editorActions = actions;
            if (this.props.onInternalRender) this.props.onInternalRender(this.editorActions);
            const tableConfig = {
                allowColumnResizing: true,
                allowControls: true,
                allowHeaderRow: true,
                allowHeaderColumn: true,
                allowNumberColumn: true
            };
            return /*#__PURE__*/ $fc4bM.createElement($a5dc9fc9b24289dc$var$EditorWrapper, null, /*#__PURE__*/ $fc4bM.createElement((0, $k9yxi.MediaWrapper), {
                mediaOptions: mediaOptions
            }, /*#__PURE__*/ $fc4bM.createElement((0, $3UXic.SmartCardProvider), {
                client: $a5dc9fc9b24289dc$var$smartCardClient
            }, /*#__PURE__*/ $fc4bM.createElement((0, $japzk.default), {
                placeholder: placeholderWhenCollapsed,
                isExpanded: isExpanded,
                onFocus: expandEditor
            }, /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
                data: {
                    attributes: {
                        mediaSource: 'inline'
                    }
                }
            }, /*#__PURE__*/ $fc4bM.createElement((0, $gucSL.default), {
                allowAnalyticsGASV3: true,
                defaultValue: defaultValue,
                appearance: "comment",
                placeholder: placeholderWhenExpanded,
                assistiveLabel: ariaLabel,
                assistiveDescribedBy: ariaDescribedby,
                onSave: internalOnSave,
                onCancel: internalOnCancel,
                onChange: this.internalOnChange,
                allowTextColor: true,
                allowRule: true,
                allowPanel: true,
                allowTables: tableConfig,
                allowDate: false,
                UNSAFE_cards: {
                    provider: Promise.resolve(this.cardProvider)
                },
                autoformattingProvider: Promise.resolve($a5dc9fc9b24289dc$var$autoformattingProvider),
                emojiProvider: (0, $34z0Z.getEmojiProvider)(isEmojiEnabled, fabricEmojiUrl),
                media: mediaOptions,
                disabled: disabled,
                waitForMediaUpload: true,
                mentionProvider: this.mentionProvider,
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                popupsBoundariesElement: document.documentElement
            })), customSecondaryToolbar === null || customSecondaryToolbar === void 0 ? void 0 : customSecondaryToolbar(this.editorActions))))));
        };
    }
}
var $a5dc9fc9b24289dc$export$2e2bcd8739ae039 = (0, $iz9xD.withBrowserMetricSubmitter)((0, $9mazR.BrowserMetricViewName).COMMENT_EDITOR_VIEW, (0, $fcCIH.default)($a5dc9fc9b24289dc$export$62defb9a02d4952c));
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a5dc9fc9b24289dc$var$EditorWrapper = /*#__PURE__*/ (0, $luz1X.default).div.withConfig({
    componentId: "sc-slb8ra-0"
})`.akEditor{.less-margin .ProseMirror{margin:${"var(--ds-space-150, 12px)"};padding:0 ${"var(--ds-space-025, 2px)"} ${"var(--ds-space-025, 2px)"};}}`;

});
parcelRegister("34z0Z", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $6adac619ab619d32$export$8210f5f78c0bcf27);

var $3NFpe = parcelRequire("3NFpe");

var $8PRsU = parcelRequire("8PRsU");

var $7wx9B = parcelRequire("7wx9B");
const $6adac619ab619d32$export$8210f5f78c0bcf27 = (0, $8PRsU.default)((isEmojiEnabled, fabricEmojiUrl)=>{
    if (isEmojiEnabled && fabricEmojiUrl) {
        const emojiResource = new (0, $3NFpe.default)({
            providers: [
                {
                    url: `${fabricEmojiUrl}/emoji/standard`
                },
                {
                    url: `${fabricEmojiUrl}/emoji/atlassian`
                }
            ],
            allowUpload: false
        });
        return emojiResource.fetchEmojiProvider().then(()=>Promise.resolve(emojiResource)).catch((e)=>{
            (0, $7wx9B.reportError)(e);
            return Promise.reject(e);
        });
    }
    return undefined;
});

});

parcelRegister("2VioL", function(module, exports) {
$parcel$export(module.exports, "PortalCardClient", () => $f21d4487d9f3e172$export$f9fc5c7aa80e3e65);

var $jrhh7 = parcelRequire("jrhh7");

var $gioQl = parcelRequire("gioQl");

var $60uht = parcelRequire("60uht");
class $f21d4487d9f3e172$export$f9fc5c7aa80e3e65 extends (0, $jrhh7.default) {
    async fetchData(url) {
        const issueKey = (0, $gioQl.parseIssueKeyFromUrl)(url);
        if (issueKey === null) // This doesn't look like Jira URL, so let's use native resolver
        return super.fetchData(url);
        // Suppressing existing violation. Please fix this.
        return (0, $60uht.getRequestSmartCardData)(issueKey).then(// eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (response)=>this.createResolveResponse(issueKey, response));
    }
    prefetchData() {
        return Promise.resolve(undefined);
    }
    constructor(...args){
        super(...args), /* eslint-disable  @typescript-eslint/no-explicit-any */ this.createResolveResponse = (issueKey, response)=>{
            return {
                meta: {
                    visibility: 'restricted',
                    access: 'granted',
                    auth: [],
                    definitionId: 'jira-native-resolve'
                },
                data: {
                    '@context': {
                        '@vocab': 'https://www.w3.org/ns/activitystreams#',
                        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                        schema: 'http://schema.org/'
                    },
                    '@type': [
                        'atlassian:Task',
                        'Object'
                    ],
                    name: `${issueKey}: ${response.summary}`,
                    tag: {
                        name: response.status,
                        appearance: 'default'
                    },
                    url: response.url,
                    taskType: {
                        '@type': [
                            'Object',
                            'atlassian:TaskType'
                        ],
                        '@id': 'https://www.atlassian.com/#JiraCustomTaskType',
                        name: response.requestType.name
                    },
                    icon: {
                        '@type': 'Image',
                        url: response.requestType.iconUrl
                    },
                    generator: {
                        '@type': 'Application',
                        '@id': 'https://www.atlassian.com/#Jira',
                        name: 'Jira'
                    }
                }
            };
        };
    }
}

});
parcelRegister("60uht", function(module, exports) {
$parcel$export(module.exports, "canViewRequest", () => $00bbded62223e62f$export$fcf9cdaf6dacff17);
$parcel$export(module.exports, "getRequestSmartCardData", () => $00bbded62223e62f$export$7c3f0476ba399805);

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $00bbded62223e62f$export$fcf9cdaf6dacff17 = (requestKey, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard/canviewrequest`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.canViewRequest;
    }).toPromise().catch((e)=>Promise.reject(e));
};
const $00bbded62223e62f$export$7c3f0476ba399805 = (requestKey, context = (0, $diqlM.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return ajaxResponse.response;
    }).toPromise().catch((e)=>Promise.reject(e));
};

});


parcelRegister("iz9xD", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricProvider", () => $4adc9527768fe01b$export$650dc360d03e8221);
$parcel$export(module.exports, "withBrowserMetricSubmitter", () => $4adc9527768fe01b$export$1eeea2e4542f98cf);

var $fc4bM = parcelRequire("fc4bM");

var $aZfc9 = parcelRequire("aZfc9");

var $lvRbB = parcelRequire("lvRbB");
const $4adc9527768fe01b$var$context = /*#__PURE__*/ $fc4bM.createContext({
    updateRendered: ()=>null
});
const $4adc9527768fe01b$var$allComponentRendered = (renderedList)=>{
    return Object.values(renderedList).every(Boolean);
};
const $4adc9527768fe01b$var$getInitialState = (requiredComponent)=>{
    return requiredComponent.reduce((acc, componentKey)=>{
        acc[componentKey] = false;
        return acc;
    }, {});
};
const $4adc9527768fe01b$export$650dc360d03e8221 = ({ requiredComponents: requiredComponents, additionalAttributes: additionalAttributes, children: children })=>{
    const [renderedComponents, setRenderedComponents] = $fc4bM.useState($4adc9527768fe01b$var$getInitialState(requiredComponents));
    const updateRendered = $fc4bM.useCallback((componentName)=>{
        if (!renderedComponents[componentName]) setRenderedComponents((state)=>({
                ...state,
                [componentName]: true
            }));
    }, [
        renderedComponents
    ]);
    const content = $4adc9527768fe01b$var$allComponentRendered(renderedComponents) ? /*#__PURE__*/ $fc4bM.createElement((0, $lvRbB.FireScreenEventOnMount), {
        customData: additionalAttributes
    }) : null;
    return /*#__PURE__*/ $fc4bM.createElement($4adc9527768fe01b$var$context.Provider, {
        value: {
            updateRendered: updateRendered
        }
    }, content, children);
};
const $4adc9527768fe01b$export$d3284227ea46da67 = ({ componentName: componentName })=>{
    const { updateRendered: updateRendered } = $fc4bM.useContext($4adc9527768fe01b$var$context);
    $fc4bM.useEffect(()=>{
        (0, $aZfc9.perfMark)(`rendered.${componentName}`);
        updateRendered(componentName);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4adc9527768fe01b$export$1eeea2e4542f98cf = (componentName, WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>{
        return /*#__PURE__*/ $fc4bM.createElement($fc4bM.Fragment, null, /*#__PURE__*/ $fc4bM.createElement($4adc9527768fe01b$export$d3284227ea46da67, {
            componentName: componentName
        }), /*#__PURE__*/ $fc4bM.createElement(WrappedComponent, props));
    };

});

parcelRegister("9S95g", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("4JZoY")).default);

var $4JZoY = parcelRequire("4JZoY");

});
parcelRegister("4JZoY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab0da67ea812dc5f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $iya1I = parcelRequire("iya1I");

var $fcCIH = parcelRequire("fcCIH");

var $dtvmL = parcelRequire("dtvmL");

var $jiGAb = parcelRequire("jiGAb");
const $ab0da67ea812dc5f$export$2a39522663534d6 = (0, $fcCIH.default)(({ type: type, intl: intl })=>/*#__PURE__*/ $fc4bM.createElement((0, $dtvmL.default), {
        appearance: "error"
    }, intl.formatMessage($ab0da67ea812dc5f$var$typeToMessage(type))));
const $ab0da67ea812dc5f$var$typeToMessage = (type)=>{
    if (type === 'field') return (0, $jiGAb.default).failedToRenderField;
    if (type === 'comment') return (0, $jiGAb.default).failedToRenderComment;
    if (type === 'comment-editor') return (0, $jiGAb.default).failedToRenderCommentEditor;
    return (0, $jiGAb.default).unknownError;
};
const $ab0da67ea812dc5f$var$ErrorBoundaryMessage = ({ type: type, children: children })=>{
    const renderError = $fc4bM.useCallback(()=>/*#__PURE__*/ $fc4bM.createElement($ab0da67ea812dc5f$export$2a39522663534d6, {
            type: type
        }), [
        type
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $iya1I.default), {
        renderError: renderError
    }, children);
};
var $ab0da67ea812dc5f$export$2e2bcd8739ae039 = $ab0da67ea812dc5f$var$ErrorBoundaryMessage;

});
parcelRegister("jiGAb", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c35420e7352714c$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
var $8c35420e7352714c$export$2e2bcd8739ae039 = (0, $8p5Cv.defineMessages)({
    unknownError: {
        id: 'error.boundary.title',
        defaultMessage: 'An unknown error occurred.',
        description: 'Title for an error box saying that something went wrong'
    },
    failedToRenderField: {
        id: 'error.boundary.failed.to.render.field',
        defaultMessage: "We couldn't display this field.",
        description: 'Title for an error box saying that something went wrong while rendering a field'
    },
    failedToRenderComment: {
        id: 'error.boundary.failed.to.render.comment',
        defaultMessage: "We couldn't display this comment.",
        description: 'Title for an error box saying that something went wrong while rendering a comment'
    },
    failedToRenderCommentEditor: {
        id: 'error.boundary.failed.to.render.rich.text.editor',
        defaultMessage: "We couldn't display the comment editor.",
        description: 'Title for an error box saying that something went wrong while rendering the comment editor'
    }
});

});



parcelRegister("N8W8m", function(module, exports) {
$parcel$export(module.exports, "getMentionProvider", () => (parcelRequire("dYfmc")).getMentionProvider);

var $dYfmc = parcelRequire("dYfmc");

});
parcelRegister("dYfmc", function(module, exports) {
$parcel$export(module.exports, "getMentionProvider", () => $b6f0139427151311$export$6742408d91365687);

var $9mazR = parcelRequire("9mazR");

var $aYMdQ = parcelRequire("aYMdQ");

var $j0UZh = parcelRequire("j0UZh");

var $keYO2 = parcelRequire("keYO2");

var $bJna2 = parcelRequire("bJna2");
const $b6f0139427151311$export$6742408d91365687 = (loggedInUserAccountId, requestKey, fieldConfigs)=>new $b6f0139427151311$var$MentionProviderSelector(loggedInUserAccountId, requestKey, fieldConfigs);
class $b6f0139427151311$var$MentionProviderSelector extends (0, $bJna2.AbstractMentionResource) {
    constructor(loggedInAccountId, issueKey, fieldConfigs){
        super(), this.isFiltering = (query)=>{
            var _this$activeSearches;
            return (_this$activeSearches = this.activeSearches) === null || _this$activeSearches === void 0 ? void 0 : _this$activeSearches.has(query);
        }, this.filter = (query)=>{
            return this.debouncedFilter(query);
        }, this.notifyListeners = (mentionResult, duration)=>{
            this._notifyListeners(mentionResult, {
                duration: duration
            });
        }, this.notifyAllResultsListeners = (mentionResult)=>{
            this._notifyListeners(mentionResult);
        }, this.notifyErrorListeners = (error)=>{
            this._notifyErrorListeners(error);
        }, this.debouncedFilter = (0, $aYMdQ.debounce)((query = '')=>{
            const currentSearchTime = Date.now();
            return this.search(query).then((mentionResult)=>{
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this.notifyListeners(mentionResult, Date.now() - currentSearchTime);
                }
                this.notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, $aYMdQ.isNil)(query) && query.length > 0) this.activeSearches.delete(query);
                this.notifyErrorListeners(e);
            });
        }, (0, $9mazR.USER_TYPING_DEBOUNCE_TIME)), this.shouldHighlightMention = (mention)=>mention.id === this.loggedInAccountId, this.search = (query = '')=>{
            this.activeSearches.add(query);
            if (this.issueKey) return (0, $j0UZh.fetchUsersJsonWithIssueKey)(this.issueKey, query).mergeMap((users)=>users).reduce((allMentions, mention)=>[
                    ...allMentions,
                    mention
                ], []).map((mentions)=>({
                    mentions: mentions,
                    query: query
                })).toPromise();
            if (this.fieldConfigs) return (0, $keYO2.searchUser)({
                query: query,
                ...this.fieldConfigs
            }).map((response)=>response.map((user)=>({
                        id: user.id,
                        name: user.displayName,
                        avatarUrl: user.avatar
                    }))).mergeMap((users)=>users).reduce((allMentions, mention)=>[
                    ...allMentions,
                    mention
                ], []).map((mentions)=>({
                    mentions: mentions,
                    query: query
                })).toPromise();
            return Promise.resolve({
                query: query,
                mentions: []
            });
        };
        if (issueKey) this.issueKey = issueKey;
        if (fieldConfigs) this.fieldConfigs = fieldConfigs;
        this.loggedInAccountId = loggedInAccountId;
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
    }
}
var $b6f0139427151311$export$2e2bcd8739ae039 = $b6f0139427151311$var$MentionProviderSelector;

});
parcelRegister("j0UZh", function(module, exports) {
$parcel$export(module.exports, "fetchUsersJsonWithIssueKey", () => $8d5c55428341aede$export$f36aebb8caf83a59);

var $4Q7yw = parcelRequire("4Q7yw");

var $bTjsX = parcelRequire("bTjsX");

var $diqlM = parcelRequire("diqlM");
const $8d5c55428341aede$export$f36aebb8caf83a59 = (issueKey, query, context = (0, $diqlM.contextPath))=>{
    const headers = {
        Accept: 'application/json'
    };
    const uri = `${context}/rest/servicedesk/1/customer/mention/${issueKey}/search?q=${query}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $bTjsX.get)(uri, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $4Q7yw.Observable).throw(e);
    });
};

});

parcelRegister("bJna2", function(module, exports) {
$parcel$export(module.exports, "AbstractMentionResource", () => $bbb6568c945561ad$export$8576ba1ed2760927);

var $7tDOu = parcelRequire("7tDOu");

var $bgx11 = parcelRequire("bgx11");
const $bbb6568c945561ad$var$MAX_NOTIFIED_ITEMS = 20;
class $bbb6568c945561ad$export$8576ba1ed2760927 extends (0, $bgx11.AbstractResource) {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $7tDOu.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $bbb6568c945561ad$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $7tDOu.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $7tDOu.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $bbb6568c945561ad$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $7tDOu.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $7tDOu.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $7tDOu.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $7tDOu.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}

});
parcelRegister("7tDOu", function(module, exports) {
$parcel$export(module.exports, "default", () => $71972e94bdb97bb2$export$2e2bcd8739ae039);
let $71972e94bdb97bb2$var$debugEnabled = false;
let $71972e94bdb97bb2$var$stacktracesEnabled = false;
function $71972e94bdb97bb2$export$748ada60eaf985cc(enable) {
    $71972e94bdb97bb2$var$debugEnabled = enable;
}
function $71972e94bdb97bb2$export$4f7017086af31c25(enable) {
    $71972e94bdb97bb2$var$stacktracesEnabled = enable;
}
function $71972e94bdb97bb2$export$2a858f450a2f66d() {
    if ($71972e94bdb97bb2$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $71972e94bdb97bb2$export$2e2bcd8739ae039(msg, ...args) {
    if ($71972e94bdb97bb2$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("bgx11", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $48aaad3bada0763a$export$4529f10aed0950d4);
class $48aaad3bada0763a$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}

});




parcelRegister("9mqCJ", function(module, exports) {
$parcel$export(module.exports, "WithUploadCredentials", () => (parcelRequire("5dH3u")).WithUploadCredentials);

var $5dH3u = parcelRequire("5dH3u");

});
parcelRegister("5dH3u", function(module, exports) {
$parcel$export(module.exports, "WithUploadCredentials", () => $e710b3fe440e29f3$export$3e1efba3d85149ea);

var $fc4bM = parcelRequire("fc4bM");

var $cD8ok = parcelRequire("cD8ok");

var $k2M4v = parcelRequire("k2M4v");
const $e710b3fe440e29f3$var$credentialsAreValid = (credentials)=>{
    // We check that the credentials exist and they won't expire within the next 15 seconds to ensure they won't expire during the upload (most likely)
    const fifteenSecondsAfterNow = new Date().getTime() + 15000;
    return credentials.expiryEpoch > fifteenSecondsAfterNow;
};
const $e710b3fe440e29f3$export$3e1efba3d85149ea = ({ portalId: portalId, requestId: requestId, children: children })=>{
    const credentialsRef = $fc4bM.useRef(null);
    const lastFetchedPortalIdRef = $fc4bM.useRef(portalId);
    const lastFetchedRequestIdRef = $fc4bM.useRef(requestId);
    const getCredentials = $fc4bM.useCallback(async ()=>{
        // If we haven't fetched credentials or they're no longer valid, update them
        if (!credentialsRef.current || !$e710b3fe440e29f3$var$credentialsAreValid(credentialsRef.current) || lastFetchedPortalIdRef.current !== portalId || lastFetchedRequestIdRef.current !== requestId) {
            lastFetchedPortalIdRef.current = portalId;
            lastFetchedRequestIdRef.current = requestId;
            if ((0, $k2M4v.default).checkGate('request_create_inline_attachment') && !requestId) {
                credentialsRef.current = await (0, $cD8ok.getCredentialsForMediaRequest)(portalId);
                return credentialsRef.current;
            }
            // Request Id can be undefined but with removal of request_create_inline_attachment type casting can be removed
            credentialsRef.current = await (0, $cD8ok.getUploadCredentialsForRequest)(portalId, requestId);
        }
        return credentialsRef.current;
    }, [
        portalId,
        requestId
    ]);
    const getMediaProvider = $fc4bM.useCallback(async ()=>{
        const authProvider = async ()=>{
            const latestCredentials = await getCredentials();
            return {
                clientId: latestCredentials.clientId,
                token: latestCredentials.token,
                baseUrl: latestCredentials.endpointUrl
            };
        };
        const credentials = await getCredentials();
        return {
            uploadParams: {
                collection: credentials.targetCollection
            },
            viewMediaClientConfig: {
                authProvider: authProvider,
                useSha256ForUploads: true
            },
            uploadMediaClientConfig: {
                authProvider: authProvider,
                useSha256ForUploads: true
            }
        };
    }, [
        getCredentials
    ]);
    const mediaProviderPromise = $fc4bM.useMemo(()=>getMediaProvider(), [
        getMediaProvider
    ]);
    return children(mediaProviderPromise);
};

});


parcelRegister("japzk", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb10c83b748e0ca8$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dEZg5 = parcelRequire("dEZg5");

var $bdy4X = parcelRequire("bdy4X");
class $eb10c83b748e0ca8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidUpdate() {
        if (this.props.isExpanded && (this.editorComponent || this.functionalEditor) && (!this.previouslyExpanded || this.previouslyExpanded === undefined)) {
            var _this$props$onExpand, _this$props;
            (_this$props$onExpand = (_this$props = this.props).onExpand) === null || _this$props$onExpand === void 0 || _this$props$onExpand.call(_this$props);
        }
        this.previouslyExpanded = this.props.isExpanded;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render() {
        const child = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.only(this.props.children);
        this.functionalEditor = typeof child.type === 'function';
        if (!this.props.isExpanded) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bdy4X.IntlProviderIfMissingWrapper), {
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dEZg5.default), {
                onFocus: this.props.onFocus,
                text: this.props.placeholder,
                label: this.props.assistiveLabel
            })
        });
        // Let's avoid ref logic for functional Editor
        if (this.functionalEditor) return child;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).cloneElement(child, {
            ref: (editorComponent)=>this.handleEditorRef(editorComponent, child.ref)
        });
    }
    constructor(...args){
        super(...args), this.handleEditorRef = (editorRef, editorRefCallback)=>{
            if (editorRefCallback && typeof editorRefCallback === 'function') editorRefCallback(editorRef);
            this.editorComponent = editorRef;
        };
    }
}

});
parcelRegister("dEZg5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f430d14506d5f2a0$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $4KV4B = parcelRequire("4KV4B");

var $dYuCP = parcelRequire("dYuCP");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $f430d14506d5f2a0$var$ChromeCollapsed extends (0, $fc4bM.PureComponent) {
    render() {
        const placeholder = this.props.text || this.props.intl.formatMessage((0, $dYuCP.messages).chromeCollapsedPlaceholder);
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4KV4B.ChromeCollapsed), {
            "data-testid": "chrome-collapsed",
            ref: this.handleInputRef,
            onFocus: this.focusHandler,
            placeholder: placeholder,
            "aria-label": this.props.label
        });
    }
    constructor(...args){
        super(...args), this.focusHandler = (evt)=>{
            /**
     * We need this magic for FireFox.
     * The reason we need it is, when, in FireFox, we have focus inside input,
     * and then we remove that input and move focus to another place programmatically,
     * for whatever reason UP/DOWN arrows don't work until you blur and focus editor manually.
     */ if (this.input) this.input.blur();
            if (this.props.onFocus) this.props.onFocus(evt);
        }, this.handleInputRef = (ref)=>{
            this.input = ref;
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $f430d14506d5f2a0$var$_default_1 = (0, $fcCIH.default)($f430d14506d5f2a0$var$ChromeCollapsed);
var $f430d14506d5f2a0$export$2e2bcd8739ae039 = $f430d14506d5f2a0$var$_default_1;

});
parcelRegister("4KV4B", function(module, exports) {
$parcel$export(module.exports, "ChromeCollapsed", () => $194e0a75240926fa$export$1b6afa3fb0a76636);
/* ChromeCollapsed.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $194e0a75240926fa$var$inputCompiledStyles = {
    root: "_19it19hj _2rkofajl _bfhk1j9a _vchhusvi _4t3i1ylp _19bvv47k _ca0qutpp _n3tdutpp _1wyboxwj _1bsb1osq _k48pi7a9 _vwz41aog _1dyzdjp5 _syaz1rpy _4cvxrsbi _irr3l4ek _d0al1kdv"
};
const $194e0a75240926fa$export$1b6afa3fb0a76636 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(// eslint-disable-next-line react/jsx-props-no-spreading
({ ...rest }, ref)=>/*#__PURE__*/ (0, $3LM7S.jsx)("input", {
        ref: ref,
        ...rest,
        className: (0, $2R2iS.default)([
            $194e0a75240926fa$var$inputCompiledStyles.root
        ])
    }));

});

parcelRegister("dYuCP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $258cfef184963c8a$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $258cfef184963c8a$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    chromeCollapsedPlaceholder: {
        id: 'fabric.editor.chromeCollapsedPlaceholder',
        defaultMessage: "Type something\u2026",
        description: 'placeholder for an input where users insert text'
    }
});

});



parcelRegister("gucSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $2df4a51d1a625783$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $hyPto = parcelRequire("hyPto");

var $3e8zT = parcelRequire("3e8zT");

var $fqyOH = parcelRequire("fqyOH");
const $2df4a51d1a625783$var$ComposableEditorWrapper = ({ props: props, initialPluginConfiguration: initialPluginConfiguration })=>{
    const preset = (0, $3e8zT.default)({
        props: props,
        initialPluginConfiguration: initialPluginConfiguration
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hyPto.ComposableEditor), {
        preset: preset,
        ...props
    });
};
class $2df4a51d1a625783$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static #_ = this.defaultProps = {
        appearance: 'comment',
        disabled: false,
        extensionHandlers: {},
        allowHelpDialog: true,
        quickInsert: true
    };
    constructor(props){
        super(props);
        (0, $fqyOH.default)(props);
    }
    render() {
        return /*#__PURE__*/ (0, $3LM7S.jsx)($2df4a51d1a625783$var$ComposableEditorWrapper, {
            props: this.props,
            initialPluginConfiguration: this.props.initialPluginConfiguration
        });
    }
}

});
parcelRegister("fqyOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $25911633e59f2e75$export$2e2bcd8739ae039);
function $25911633e59f2e75$export$2e2bcd8739ae039(props) {
    return;
}

});


parcelRegister("ekmCa", function(module, exports) {
$parcel$export(module.exports, "default", () => $740a94456835bc31$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $52fgM = parcelRequire("52fgM");
class $740a94456835bc31$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    constructor(props){
        super(props);
    }
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $3LM7S.jsx)($740a94456835bc31$var$WithEditorActionsNew, {
            ...this.props
        });
    }
}
function $740a94456835bc31$var$WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $52fgM.EditorContext));
    return /*#__PURE__*/ (0, $3LM7S.jsx)($740a94456835bc31$var$WithEditorActionsInner, {
        render: render,
        editorActions: context === null || context === void 0 ? void 0 : context.editorActions
    });
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $740a94456835bc31$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}

});



parcelRegister("cmq2M", function(module, exports) {
$parcel$export(module.exports, "getATLContextDomain", () => $42f334af43432dee$export$b5ce351acdc48c2a);

var $8pF96 = parcelRequire("8pF96");

var $2ljJn = parcelRequire("2ljJn");

var $96xWg = parcelRequire("96xWg");

var $3p1RY = parcelRequire("3p1RY");

var $uG5kX = parcelRequire("uG5kX");

var $g305r = parcelRequire("g305r");
function $42f334af43432dee$var$isValidDomainKey(domainKey) {
    if (!(0, $uG5kX.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $42f334af43432dee$export$b5ce351acdc48c2a(domain, environment) {
    var _domainMap$perimeter;
    // Validate this is a valid domain
    if (!$42f334af43432dee$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $uG5kX.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? (0, $g305r._getEnvironmentFromDomain)();
    // Second priority, return if there is a full domain override
    const override = (0, $96xWg.fullDomainOverride)[domain];
    if (override) {
        var _override$perimeter;
        return(// Exact match preferred
        ((_override$perimeter = override[perimeter]) === null || _override$perimeter === void 0 ? void 0 : _override$perimeter[env]) ?? override[0, $8pF96.COMMERCIAL][0, $8pF96.PRODUCTION] // Fallback to mandatory commercial production
        );
    }
    // Third priority, join the subdomain
    const tld = ((_domainMap$perimeter = (0, $2ljJn.domainMap)[perimeter]) === null || _domainMap$perimeter === void 0 ? void 0 : _domainMap$perimeter[env]) ?? (0, $2ljJn.domainMap)[0, $8pF96.COMMERCIAL][0, $8pF96.PRODUCTION];
    const subdomain = (0, $3p1RY.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}

});
parcelRegister("2ljJn", function(module, exports) {
$parcel$export(module.exports, "domainMap", () => $a090c3b87322000d$export$6836b090dbaa813a);

var $8pF96 = parcelRequire("8pF96");
const $a090c3b87322000d$export$6836b090dbaa813a = {
    [(0, $8pF96.COMMERCIAL)]: {
        [(0, $8pF96.STAGING)]: 'stg.atlassian.com',
        [(0, $8pF96.PRODUCTION)]: 'atlassian.com'
    },
    [(0, $8pF96.FEDRAMP_FEDEX)]: {
        [(0, $8pF96.STAGING)]: 'atlassian-fex.com'
    },
    [(0, $8pF96.FEDRAMP_MODERATE)]: {
        [(0, $8pF96.STAGING)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $8pF96.PRODUCTION)]: 'atlassian-us-gov-mod.com'
    }
};

});

parcelRegister("96xWg", function(module, exports) {
$parcel$export(module.exports, "fullDomainOverride", () => $4efbe0a8300be888$export$4723232b625f823e);

var $8pF96 = parcelRequire("8pF96");
const $4efbe0a8300be888$export$4723232b625f823e = {
    analytics: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'start.atlassian.com',
            [(0, $8pF96.STAGING)]: 'start.stg.atlassian.com'
        },
        [(0, $8pF96.FEDRAMP_MODERATE)]: {
            [(0, $8pF96.PRODUCTION)]: 'start.atlassian-us-gov-mod.com',
            [(0, $8pF96.STAGING)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'id.atlassian.com',
            [(0, $8pF96.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $8pF96.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $8pF96.FEDRAMP_MODERATE)]: {
            [(0, $8pF96.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $8pF96.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $8pF96.COMMERCIAL)]: {
            [(0, $8pF96.PRODUCTION)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("3p1RY", function(module, exports) {
$parcel$export(module.exports, "subdomainOverride", () => $1dcd620ce6a08ff8$export$c6ab20d0ac4d06b2);
const $1dcd620ce6a08ff8$export$c6ab20d0ac4d06b2 = {};

});

parcelRegister("uG5kX", function(module, exports) {
$parcel$export(module.exports, "AllowedDomains", () => $7b4a453ea5fad464$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $7b4a453ea5fad464$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});

parcelRegister("g305r", function(module, exports) {
$parcel$export(module.exports, "_getEnvironmentFromDomain", () => $b1604e980ae6bc87$export$509d18a5fd824839);

var $8pF96 = parcelRequire("8pF96");
function $b1604e980ae6bc87$export$509d18a5fd824839() {
    var _globalThis$location;
    const hostname = (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $8pF96.PRODUCTION),
        (0, $8pF96.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $8pF96.STAGING),
        (0, $8pF96.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $8pF96.STAGING),
        (0, $8pF96.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $8pF96.STAGING),
        (0, $8pF96.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $8pF96.PRODUCTION),
        (0, $8pF96.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $8pF96.STAGING),
        (0, $8pF96.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $8pF96.STAGING),
        (0, $8pF96.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, $8pF96.PRODUCTION),
        (0, $8pF96.COMMERCIAL)
    ];
}

});


parcelRegister("7LU44", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $ed77e1d538193c2d$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $ed77e1d538193c2d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}

});

parcelRegister("8Rwzm", function(module, exports) {
$parcel$export(module.exports, "isolatedCloudDomain", () => $55515f7f923dfb1e$export$80638ee198476daf);

var $iPUNO = parcelRequire("iPUNO");
function $55515f7f923dfb1e$export$80638ee198476daf() {
    if (typeof document === 'undefined') {
        var _globalThis$location;
        return (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
    }
    const atlCtxCookieValues = (0, $iPUNO.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}

});

parcelRegister("he1O7", function(module, exports) {
$parcel$export(module.exports, "useIsReducedMotion", () => $caa2960ab26af164$export$c537e63161742ce3);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $1EkOZ = parcelRequire("1EkOZ");

var $kUMs0 = parcelRequire("kUMs0");
const $caa2960ab26af164$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $fc4bM.useState)((0, $kUMs0.isReducedMotion));
    (0, $fc4bM.useEffect)(()=>{
        if (!(0, $1EkOZ.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $6Zi52.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};

});

parcelRegister("iIA9h", function(module, exports) {
$parcel$export(module.exports, "extractClosestEdge", () => $80e6be375a30e62e$export$945a571f3b658bf);

var $iPjXN = parcelRequire("iPjXN");
function $80e6be375a30e62e$export$945a571f3b658bf(userData) {
    return userData[0, $iPjXN.uniqueKey] ?? null;
}

});
parcelRegister("iPjXN", function(module, exports) {
$parcel$export(module.exports, "uniqueKey", () => $c2b0eb55321e13ad$export$4032e2468b38573b);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $ar7hH = parcelRequire("ar7hH");

var $iIA9h = parcelRequire("iIA9h");
const $c2b0eb55321e13ad$export$4032e2468b38573b = Symbol('closestEdge');

});
parcelRegister("ar7hH", function(module, exports) {
$parcel$export(module.exports, "attachClosestEdge", () => $6a92918e336a6c81$export$f0cafff222395e89);

var $iPjXN = parcelRequire("iPjXN");
const $6a92918e336a6c81$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
function $6a92918e336a6c81$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    var _entries$sort$;
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $6a92918e336a6c81$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = ((_entries$sort$ = entries.sort((a, b)=>a.value - b.value)[0]) === null || _entries$sort$ === void 0 ? void 0 : _entries$sort$.edge) ?? null;
    return {
        ...userData,
        [(0, $iPjXN.uniqueKey)]: addClosestEdge
    };
}

});



parcelRegister("4iuuQ", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => $661175deb5453ae9$export$453c0582481cc59d);

var $6Zi52 = parcelRequire("6Zi52");

var $lOA9P = parcelRequire("lOA9P");
function $661175deb5453ae9$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $661175deb5453ae9$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $661175deb5453ae9$var$start() {
    $661175deb5453ae9$var$cleanup();
    $661175deb5453ae9$var$unbindEvents = (0, $6Zi52.bindAll)(window, [
        {
            type: 'dragover',
            listener: $661175deb5453ae9$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $661175deb5453ae9$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $661175deb5453ae9$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $661175deb5453ae9$var$cleanup
        },
        ...(0, $lOA9P.getBindingsForBrokenDrags)({
            onDragEnd: $661175deb5453ae9$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $661175deb5453ae9$var$cleanup() {
    var _unbindEvents;
    (_unbindEvents = $661175deb5453ae9$var$unbindEvents) === null || _unbindEvents === void 0 || _unbindEvents();
    $661175deb5453ae9$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $661175deb5453ae9$var$stop() {
    var _window$event;
    /**
   * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
   * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
   * ("drop" events caused by dropping over a drop target)
   * `preventUnhandled()` causes every element to become a drop target (according to the browser)
   *
   * To opt out of the default behaviour for a `"drop"` event, we need to make sure
   * that we cancel it.
   *
   * The `"drop"` event listener in core is in the `capture` phase, so people calling
   * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
   * file before it has the chance to cancel the event.
   *
   * Being sneaky and using the `window.event` global to sniff out the current event
   */ if (((_window$event = window.event) === null || _window$event === void 0 ? void 0 : _window$event.type) === 'drop') {
        var _window$event2;
        (_window$event2 = window.event) === null || _window$event2 === void 0 || _window$event2.preventDefault();
    }
    $661175deb5453ae9$var$cleanup();
}
const $661175deb5453ae9$export$453c0582481cc59d = {
    start: $661175deb5453ae9$var$start,
    stop: $661175deb5453ae9$var$stop
};

});

parcelRegister("5rum3", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => $1793c761a8d896b2$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $1793c761a8d896b2$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $1793c761a8d896b2$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $1793c761a8d896b2$var$tinyTransparentImage) nativeSetDragImage($1793c761a8d896b2$var$tinyTransparentImage, 0, 0);
}

});

parcelRegister("eyUAX", function(module, exports) {
$parcel$export(module.exports, "codeBlockButtonMessages", () => $1fe81ce5d4d5e843$export$74e304339778e94d);

var $8p5Cv = parcelRequire("8p5Cv");
const $1fe81ce5d4d5e843$export$74e304339778e94d = (0, $8p5Cv.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copyCodeSnippetToClipboard: {
        id: 'editor-common.messages.codeBlockButton.copyCodeSnippetToClipboard',
        defaultMessage: 'Copy code text',
        description: 'Copy the code text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Label for a toolbar button in the code block that enables line wrapping so long lines of code wrap to the next line instead of overflowing.'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Label for a toolbar button in the code block that disables line wrapping so long lines of code extend horizontally without breaking.'
    },
    wrapCodeLabel: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCode',
        defaultMessage: 'Wrap code',
        description: 'Tooltip for a code block toolbar button that turns on line wrapping. This is shown when code is not wrapped.'
    },
    unwrapCodeLabel: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCode',
        defaultMessage: 'Unwrap code',
        description: 'Tooltip for a code block toolbar button that turns off line wrapping. This is shown when code is wrapped.'
    },
    showLineNumbersLabel: {
        id: 'fabric.editor.codeBlockLineNumbersButton.showLineNumbers',
        defaultMessage: 'Show line numbers',
        description: 'Tooltip for a code block toolbar button that shows line numbers. This is shown when line numbers are hidden.'
    },
    hideLineNumbersLabel: {
        id: 'fabric.editor.codeBlockLineNumbersButton.hideLineNumbers',
        defaultMessage: 'Hide line numbers',
        description: 'Tooltip for a code block toolbar button that hides line numbers. This is shown when line numbers are visible.'
    },
    formatCode: {
        id: 'fabric.editor.codeBlockFormatButton.formatCode',
        defaultMessage: 'Format code',
        description: 'Tooltip for a code block toolbar button that formats code block content.'
    },
    formatCodeUnavailable: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeUnavailable',
        defaultMessage: 'Formatting not available for this language',
        description: 'Tooltip for a disabled code block toolbar button when formatting is not available for the selected language.'
    },
    formatCodeFailed: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeFailed',
        defaultMessage: 'Code formatting failed',
        description: 'Title for an error flag shown when code formatting fails.'
    },
    formatCodeFailedDescription: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeFailedDescription',
        defaultMessage: 'Review the content or change the selected language.',
        description: 'Description for an error flag shown when code formatting fails for a selected language.'
    },
    formatCodeFailedAutoDetectedDescription: {
        id: 'fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription',
        defaultMessage: 'Review the content or select a specific language.',
        description: 'Description for an error flag shown when code formatting fails for an automatically detected language.'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    },
    detectLanguage: {
        id: 'fabric.editor.codeBlock.detectLanguage',
        defaultMessage: 'Detect language',
        description: 'Option in the code block language picker that clears the selected language so the editor can detect it automatically.'
    },
    detectedLanguage: {
        id: 'fabric.editor.codeBlock.detectedLanguage',
        defaultMessage: '{language} (detected)',
        description: 'Label in the code block language picker trigger when the editor detected the code language. The language placeholder is the detected language name, such as JavaScript.'
    },
    noneDetected: {
        id: 'fabric.editor.codeBlock.noneDetected',
        defaultMessage: '(None detected)',
        description: 'Label in the code block language picker trigger when the editor could not detect a code language.'
    },
    recentlyUsed: {
        id: 'fabric.editor.codeBlock.recentlyUsed',
        defaultMessage: 'Recently used',
        description: 'Section heading for recently used languages in the code block language picker.'
    },
    all: {
        id: 'fabric.editor.codeBlock.all',
        defaultMessage: 'All',
        description: 'Section heading for all languages in the code block language picker.'
    },
    downloadCodeBlock: {
        id: 'fabric.editor.codeBlockDownloadButton.downloadCodeBlock',
        defaultMessage: 'Download',
        description: 'Download the content of the code block as a file'
    }
});

});

parcelRegister("eGgZF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e792daab030bd512da02c59fc29db1c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02c21979e5a1a191$var$_react = $02c21979e5a1a191$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $02c21979e5a1a191$var$_iconNew = $02c21979e5a1a191$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $02c21979e5a1a191$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/copy
 * Usage guidance:
 * Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02c21979e5a1a191$var$CopyIcon = (props)=>/*#__PURE__*/ $02c21979e5a1a191$var$_react.default.createElement($02c21979e5a1a191$var$_iconNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$02c21979e5a1a191$var$CopyIcon.displayName = 'CopyIcon';
var $02c21979e5a1a191$var$_default = module.exports.default = $02c21979e5a1a191$var$CopyIcon;

});

parcelRegister("7Q4q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb536940475a84529fdd1d2bdcae7e65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b50d199cd16978a$var$_react = $5b50d199cd16978a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5b50d199cd16978a$var$_iconNew = $5b50d199cd16978a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5b50d199cd16978a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextWrap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-wrap
 * Usage guidance:
 * Reserved for wrapping text so it spans multiple lines.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b50d199cd16978a$var$TextWrapIcon = (props)=>/*#__PURE__*/ $5b50d199cd16978a$var$_react.default.createElement($5b50d199cd16978a$var$_iconNew.default, Object.assign({
        name: "TextWrapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.375 5H0V3.5h13.375A2.625 2.625 0 0 1 16 6.125v2.75a2.625 2.625 0 0 1-2.625 2.625H9.561l1.72 1.72-1.061 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L9.56 10h3.815c.621 0 1.125-.504 1.125-1.125v-2.75C14.5 5.504 13.996 5 13.375 5M5 11.5H0V10h5z" clip-rule="evenodd"/>`
    }, props));
$5b50d199cd16978a$var$TextWrapIcon.displayName = 'TextWrapIcon';
var $5b50d199cd16978a$var$_default = module.exports.default = $5b50d199cd16978a$var$TextWrapIcon;

});

parcelRegister("lKQLW", function(module, exports) {
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $4f35fe8fe88b457a$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages
const $4f35fe8fe88b457a$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];

});

parcelRegister("c5TKa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59407a4d31ae5eb9aed1a8c4f5bc83e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ce1312d3fdbee54$var$_react = $8ce1312d3fdbee54$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $8ce1312d3fdbee54$var$_iconNew = $8ce1312d3fdbee54$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $8ce1312d3fdbee54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/checkbox-checked
 * Usage guidance:
 * Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ce1312d3fdbee54$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $8ce1312d3fdbee54$var$_react.default.createElement($8ce1312d3fdbee54$var$_iconNew.default, Object.assign({
        name: "CheckboxCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$8ce1312d3fdbee54$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $8ce1312d3fdbee54$var$_default = module.exports.default = $8ce1312d3fdbee54$var$CheckboxCheckedIcon;

});

parcelRegister("8Pw71", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4fb5985ea59ca2817ccd54e91e2500f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66dbfefc907ba452$var$_react = $66dbfefc907ba452$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $66dbfefc907ba452$var$_iconNew = $66dbfefc907ba452$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $66dbfefc907ba452$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/decision
 * Usage guidance:
 * Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66dbfefc907ba452$var$DecisionIcon = (props)=>/*#__PURE__*/ $66dbfefc907ba452$var$_react.default.createElement($66dbfefc907ba452$var$_iconNew.default, Object.assign({
        name: "DecisionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$66dbfefc907ba452$var$DecisionIcon.displayName = 'DecisionIcon';
var $66dbfefc907ba452$var$_default = module.exports.default = $66dbfefc907ba452$var$DecisionIcon;

});

parcelRegister("gR9lL", function(module, exports) {
$parcel$export(module.exports, "timestampToUTCDate", () => $72cb4245c1a399db$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $72cb4245c1a399db$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $72cb4245c1a399db$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $72cb4245c1a399db$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $72cb4245c1a399db$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $72cb4245c1a399db$export$fbc04a9e57b04a80);

var $cZp3K = parcelRequire("cZp3K");

var $htC8i = parcelRequire("htC8i");
var $72cb4245c1a399db$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($72cb4245c1a399db$var$FORMATS || {});
const $72cb4245c1a399db$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $72cb4245c1a399db$export$6297728405c48562 = (timeZone)=>{
    const today = new Date(Date.now());
    if (timeZone) {
        var _parts$find, _parts$find2, _parts$find3;
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).formatToParts(today);
        const year = Number((_parts$find = parts.find((p)=>p.type === 'year')) === null || _parts$find === void 0 ? void 0 : _parts$find.value);
        const month = Number((_parts$find2 = parts.find((p)=>p.type === 'month')) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value) - 1;
        const day = Number((_parts$find3 = parts.find((p)=>p.type === 'day')) === null || _parts$find3 === void 0 ? void 0 : _parts$find3.value);
        return Date.UTC(year, month, day).toString();
    }
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $72cb4245c1a399db$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $72cb4245c1a399db$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $72cb4245c1a399db$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $72cb4245c1a399db$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $72cb4245c1a399db$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$72cb4245c1a399db$var$addLeadingZero(date.getUTCMonth() + 1)}-${$72cb4245c1a399db$var$addLeadingZero(date.getUTCDate())}`;
};
const $72cb4245c1a399db$export$e6cc7bfc6e0e363e = (timestamp, timeZone)=>{
    return (0, $htC8i.default)(new Date(Number(timestamp)), new Date(Number($72cb4245c1a399db$export$6297728405c48562(timeZone))));
};
const $72cb4245c1a399db$export$fbc04a9e57b04a80 = (timestamp, intl, timeZone)=>{
    const curDate = new Date(Number($72cb4245c1a399db$export$6297728405c48562(timeZone)));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $cZp3K.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $72cb4245c1a399db$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $72cb4245c1a399db$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});
parcelRegister("htC8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb92b978c805c8bf$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $cb92b978c805c8bf$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3mokv.default)(2, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var dateToCompare = (0, $a3cTc.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});


parcelRegister("la1HY", function(module, exports) {
$parcel$export(module.exports, "Status", () => $0c1d4b43a12f83f4$export$96e9906d6d93a972);
/* Status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $azARG = parcelRequire("azARG");

var $9wELi = parcelRequire("9wELi");

var $9A9uV = parcelRequire("9A9uV");

var $l0KkI = parcelRequire("l0KkI");

var $bMFDy = parcelRequire("bMFDy");
const $0c1d4b43a12f83f4$var$MAX_WIDTH = 200;
/**
 * This is to account for a bug in android chromium and should be removed
 * when the editor fixes its focus handling with respect to Status.
 *
 * See DSP-7701 for additional context.
 */ const $0c1d4b43a12f83f4$var$inlineBlockStyles = null;
// Bound the Lozenge to its parent while keeping short statuses content-sized.
const $0c1d4b43a12f83f4$var$constrainedToParentStyles = null;
// eg. Version/4.0 Chrome/95.0.4638.50
const $0c1d4b43a12f83f4$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $0c1d4b43a12f83f4$var$StatusInternal extends (0, $fc4bM.PureComponent) {
    static #_ = this.displayName = 'StatusInternal';
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold, isConstrainedToParent: isConstrainedToParent } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = (0, $bMFDy.getLozengeAppearance)(color);
        // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $fc4bM.createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $2R2iS.default)([
                $0c1d4b43a12f83f4$var$isAndroidChromium && "_d0dzdf4r _1k0l7vkz _1frxnkob",
                isConstrainedToParent && "_1e0c1o8l _p12f1osq",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": (0, $bMFDy.normalizeColor)(color),
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $fc4bM.createElement((0, $9wELi.default), {
            appearance: appearance,
            maxWidth: $0c1d4b43a12f83f4$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args), this.hoverStartTime = 0, this.handleMouseEnter = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleMouseLeave = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $l0KkI.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        }, this.handleKeyDown = (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        }, this.handleFocus = (_e)=>{
            this.hoverStartTime = Date.now();
        }, this.handleBlur = (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $l0KkI.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        };
    }
}
const $0c1d4b43a12f83f4$export$96e9906d6d93a972 = (0, $azARG.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $9A9uV.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $9A9uV.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($0c1d4b43a12f83f4$var$StatusInternal);

});
parcelRegister("9A9uV", function(module, exports) {
$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $b588b6aeb862bd4c$export$aa98853957f9f5aa);
const $b588b6aeb862bd4c$export$d821aa4c8afb384e = 'fabric-elements';
const $b588b6aeb862bd4c$var$packageName = undefined;
const $b588b6aeb862bd4c$var$packageVersion = undefined;
const $b588b6aeb862bd4c$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $b588b6aeb862bd4c$var$packageName;
        statusPayload.attributes.packageVersion = $b588b6aeb862bd4c$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($b588b6aeb862bd4c$export$d821aa4c8afb384e);
        return event;
    };

});

parcelRegister("l0KkI", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_HOVER_DELAY", () => $19ebbaade4c3b6f4$export$7452d7062a4d0634);
const $19ebbaade4c3b6f4$export$7452d7062a4d0634 = 1000;

});

parcelRegister("bMFDy", function(module, exports) {
$parcel$export(module.exports, "SWATCH_ICON_COLOR", () => $28cb35206dd79001$export$692279d423b4caab);
$parcel$export(module.exports, "COLORS", () => $28cb35206dd79001$export$56d196d2844d1ca1);
$parcel$export(module.exports, "PICKER_SWATCHES", () => $28cb35206dd79001$export$d42d7c94d7629c23);
$parcel$export(module.exports, "normalizeColor", () => $28cb35206dd79001$export$4cde5df63f53f473);
$parcel$export(module.exports, "getColorLabelKey", () => $28cb35206dd79001$export$4bc90a066e1dabc3);
$parcel$export(module.exports, "isSwatchSelected", () => $28cb35206dd79001$export$13752f03fbf881b8);
$parcel$export(module.exports, "getLozengeAppearance", () => $28cb35206dd79001$export$4d9e331cafeacb9d);

var $bKWnN = parcelRequire("bKWnN");
const $28cb35206dd79001$export$c6adb6b4e776f0d5 = [
    'neutral',
    'purple',
    'blue',
    'red',
    'yellow',
    'green'
];
const $28cb35206dd79001$export$ccac7cd631a2cc0f = [
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime — named `green` renders identically
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange — named `yellow` renders identically
    '#FDD0EC' // Magenta
];
const $28cb35206dd79001$export$acfdfc8c64e6747 = 'neutral';
const $28cb35206dd79001$export$645e10b5a408e986 = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $28cb35206dd79001$export$692279d423b4caab = "var(--ds-icon, #292A2E)";
const $28cb35206dd79001$export$56d196d2844d1ca1 = {
    neutral: {
        appearance: 'neutral',
        labelKey: 'neutralColor',
        swatch: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            borderColor: "var(--ds-border, #0B120E24)"
        }
    },
    blue: {
        appearance: 'accent-blue',
        labelKey: 'blueColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
            borderColor: "var(--ds-border-accent-blue-subtle, #8FB8F6)"
        }
    },
    '#B3F5FF': {
        appearance: 'accent-teal',
        labelKey: 'tealColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            borderColor: "var(--ds-border-accent-teal-subtle, #9DD9EE)"
        }
    },
    '#ABF5D1': {
        appearance: 'accent-green',
        labelKey: 'greenColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            borderColor: "var(--ds-border-accent-green-subtle, #7EE2B8)"
        }
    },
    '#D3F1A7': {
        appearance: 'accent-lime',
        labelKey: 'limeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            borderColor: "var(--ds-border-accent-lime-subtle, #B3DF72)"
        }
    },
    '#FFF0B3': {
        appearance: 'accent-yellow',
        labelKey: 'yellowColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderColor: "var(--ds-border-accent-yellow-subtle, #EED12B)"
        }
    },
    '#FCE4A6': {
        appearance: 'accent-orange',
        labelKey: 'orangeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
            borderColor: "var(--ds-border-accent-orange-subtle, #FBC828)"
        }
    },
    red: {
        appearance: 'accent-red',
        labelKey: 'redColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            borderColor: "var(--ds-border-accent-red-subtle, #FD9891)"
        }
    },
    '#FDD0EC': {
        appearance: 'accent-magenta',
        labelKey: 'magentaColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            borderColor: "var(--ds-border-accent-magenta-subtle, #F797D2)"
        }
    },
    purple: {
        appearance: 'accent-purple',
        labelKey: 'purpleColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
            borderColor: "var(--ds-border-accent-purple-subtle, #D8A0F7)"
        }
    },
    yellow: {
        appearance: 'accent-orange',
        labelKey: 'yellowColor'
    },
    green: {
        appearance: 'accent-lime',
        labelKey: 'greenColor'
    }
};
const $28cb35206dd79001$export$d42d7c94d7629c23 = [
    'neutral',
    // Gray
    'blue',
    // Blue
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange
    'red',
    // Red
    '#FDD0EC',
    // Magenta
    'purple' // Purple
];
const $28cb35206dd79001$export$ee5a21461d1db57c = (color)=>$28cb35206dd79001$export$c6adb6b4e776f0d5.includes(color);
const $28cb35206dd79001$export$4cde5df63f53f473 = (color)=>color.startsWith('#') ? color.toUpperCase() : color;
const $28cb35206dd79001$var$specFor = (color)=>$28cb35206dd79001$export$56d196d2844d1ca1[$28cb35206dd79001$export$4cde5df63f53f473(color)];
const $28cb35206dd79001$export$4bc90a066e1dabc3 = (color)=>{
    var _specFor;
    return ((_specFor = $28cb35206dd79001$var$specFor(color)) === null || _specFor === void 0 ? void 0 : _specFor.labelKey) ?? 'neutralColor';
};
const $28cb35206dd79001$export$13752f03fbf881b8 = (swatchValue, selectedColor)=>{
    var _specFor2, _specFor3;
    if (!selectedColor) return false;
    if ($28cb35206dd79001$export$4cde5df63f53f473(swatchValue) === $28cb35206dd79001$export$4cde5df63f53f473(selectedColor)) return true;
    // A swatch also counts as selected when it renders the same hue under a different
    // id — legacy named `green`/`yellow` share the Lime/Orange swatches. Unknown values
    // have no spec, so they never collide on the neutral fallback.
    const swatchAppearance = (_specFor2 = $28cb35206dd79001$var$specFor(swatchValue)) === null || _specFor2 === void 0 ? void 0 : _specFor2.appearance;
    return swatchAppearance !== undefined && swatchAppearance === ((_specFor3 = $28cb35206dd79001$var$specFor(selectedColor)) === null || _specFor3 === void 0 ? void 0 : _specFor3.appearance);
};
const $28cb35206dd79001$export$4d9e331cafeacb9d = (color)=>{
    var _specFor4;
    const isUpdateStatusColorsEnabled = (0, $bKWnN.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $bKWnN.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    // Named colours are recoloured only by the experiment, so they must never reach the
    // hex mapping below.
    if ($28cb35206dd79001$export$ee5a21461d1db57c(color)) return isUpdateStatusColorsEnabled ? $28cb35206dd79001$export$56d196d2844d1ca1[color].appearance : $28cb35206dd79001$export$645e10b5a408e986[color];
    return ((_specFor4 = $28cb35206dd79001$var$specFor(color)) === null || _specFor4 === void 0 ? void 0 : _specFor4.appearance) ?? $28cb35206dd79001$export$acfdfc8c64e6747;
};

});


parcelRegister("5zVEm", function(module, exports) {
$parcel$export(module.exports, "getEmojiCustomFallback", () => $705338ffacadaef1$export$e6e9c38db7e6b0b1);

var $l2hEq = parcelRequire("l2hEq");
function $705338ffacadaef1$export$e6e9c38db7e6b0b1(fallbackText) {
    return (0, $l2hEq.isSingleEmoji)(fallbackText) ? undefined : '\uFFFD';
}

});
parcelRegister("l2hEq", function(module, exports) {
$parcel$export(module.exports, "isSingleEmoji", () => $31515046e61ae605$export$1d677781db73ff20);
const $31515046e61ae605$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
/^(\p{Emoji_Presentation}(?:[\u{1F3FB}-\u{1F3FF}])?|\p{Extended_Pictographic}\u{FE0F}(?:[\u{1F3FB}-\u{1F3FF}])?(?:\u{200D}\p{Extended_Pictographic}\u{FE0F}?(?:[\u{1F3FB}-\u{1F3FF}])?)*|\p{Extended_Pictographic}\u{FE0F}?(?:[\u{1F3FB}-\u{1F3FF}])?(?:\u{200D}\p{Extended_Pictographic}\u{FE0F}?(?:[\u{1F3FB}-\u{1F3FF}])?)+|\p{Regional_Indicator}\p{Regional_Indicator})$/u;
function $31515046e61ae605$export$1d677781db73ff20(fallbackText) {
    return $31515046e61ae605$var$SINGLE_EMOJI_REGEX.test(fallbackText ?? '');
}

});


parcelRegister("aPkX7", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b512c2d24bc30633$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $b512c2d24bc30633$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    emojiNodeLabel: {
        id: 'fabric.emoji.label',
        defaultMessage: 'Emoji',
        description: 'Label to indicate emoji node to Screen reader users'
    }
});

});

parcelRegister("fmMZL", function(module, exports) {
$parcel$export(module.exports, "PanelErrorIcon", () => $8281ebf1fce73045$export$76fa6c311f4e2871);
/* PanelErrorIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $8281ebf1fce73045$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $8281ebf1fce73045$var$PanelErrorGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $8281ebf1fce73045$export$76fa6c311f4e2871 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($8281ebf1fce73045$var$PanelErrorGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("lz2BK", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => $6c54d736888275a2$export$2187dc2d495c3efc);
/* PanelInfoIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $6c54d736888275a2$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $6c54d736888275a2$var$PanelInfoGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $6c54d736888275a2$export$2187dc2d495c3efc = ({ label: label })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($6c54d736888275a2$var$PanelInfoGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("B1m44", function(module, exports) {
$parcel$export(module.exports, "PanelNoteIcon", () => $ec4e153710a77acd$export$d4f894f0c3f0db6);
/* PanelNoteIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $ec4e153710a77acd$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $ec4e153710a77acd$var$PanelNoteGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $ec4e153710a77acd$export$d4f894f0c3f0db6 = (props)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($ec4e153710a77acd$var$PanelNoteGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("iMsff", function(module, exports) {
$parcel$export(module.exports, "PanelSuccessIcon", () => $1366185d36d19c0c$export$a5a5162e21242c3c);
/* PanelSuccessIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $1366185d36d19c0c$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $1366185d36d19c0c$var$PanelSuccessGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $1366185d36d19c0c$export$a5a5162e21242c3c = ({ label: label })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($1366185d36d19c0c$var$PanelSuccessGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("bJxrg", function(module, exports) {
$parcel$export(module.exports, "PanelWarningIcon", () => $d3a8de769f34f49f$export$246c5468186717b7);
/* PanelWarningIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $d3a8de769f34f49f$var$iconStyles = null;
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $d3a8de769f34f49f$var$PanelWarningGlyph = ({ role: role })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $d3a8de769f34f49f$export$246c5468186717b7 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($d3a8de769f34f49f$var$PanelWarningGlyph, {
            role: "presentation"
        })
    });
};

});

parcelRegister("bkrww", function(module, exports) {
$parcel$export(module.exports, "PanelSharedCssClassName", () => $72894c44c4ad356a$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $72894c44c4ad356a$export$8099afddf1b1be78);

var $39FD9 = parcelRequire("39FD9");

var $5j2ZG = parcelRequire("5j2ZG");
const $72894c44c4ad356a$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $72894c44c4ad356a$var$prefix = 'ak-editor-panel';
const $72894c44c4ad356a$export$6dd740b6c888e050 = {
    prefix: $72894c44c4ad356a$var$prefix,
    content: `${$72894c44c4ad356a$var$prefix}__content`,
    icon: `${$72894c44c4ad356a$var$prefix}__icon`,
    noIcon: `${$72894c44c4ad356a$var$prefix}__no-icon`
};
const $72894c44c4ad356a$export$b0ee08fae091706a = {
    infoPanel: `.${$72894c44c4ad356a$var$prefix}[data-panel-type=${(0, $39FD9.PanelType).INFO}]`,
    notePanel: `.${$72894c44c4ad356a$var$prefix}[data-panel-type=${(0, $39FD9.PanelType).NOTE}]`,
    warningPanel: `.${$72894c44c4ad356a$var$prefix}[data-panel-type=${(0, $39FD9.PanelType).WARNING}]`,
    errorPanel: `.${$72894c44c4ad356a$var$prefix}[data-panel-type=${(0, $39FD9.PanelType).ERROR}]`,
    successPanel: `.${$72894c44c4ad356a$var$prefix}[data-panel-type=${(0, $39FD9.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[data-testid="popup-wrapper"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $72894c44c4ad356a$export$8099afddf1b1be78 = (panelType)=>$72894c44c4ad356a$var$lightPanelColors[panelType] || 'none';
const $72894c44c4ad356a$export$dd3f0fd482ae7ccc = (panelType)=>(0, $5j2ZG.hexToEditorBackgroundPaletteColor)($72894c44c4ad356a$var$lightPanelColors[panelType]) || 'none';

});

parcelRegister("8ejPi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::544012b3ed4fc4d2fd72613d04239f83>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5fdf02a727f833b1$var$_react = $5fdf02a727f833b1$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5fdf02a727f833b1$var$_iconNew = $5fdf02a727f833b1$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5fdf02a727f833b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji
 * Usage guidance:
 * Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5fdf02a727f833b1$var$EmojiIcon = (props)=>/*#__PURE__*/ $5fdf02a727f833b1$var$_react.default.createElement($5fdf02a727f833b1$var$_iconNew.default, Object.assign({
        name: "EmojiIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$5fdf02a727f833b1$var$EmojiIcon.displayName = 'EmojiIcon';
var $5fdf02a727f833b1$var$_default = module.exports.default = $5fdf02a727f833b1$var$EmojiIcon;

});

parcelRegister("444k0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a7325677fe98dd4eea44aa4b991818a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f5ae3590e7c0acd$var$_react = $2f5ae3590e7c0acd$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $2f5ae3590e7c0acd$var$_iconNew = $2f5ae3590e7c0acd$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $2f5ae3590e7c0acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lightbulb
 * Usage guidance:
 * Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2f5ae3590e7c0acd$var$LightbulbIcon = (props)=>/*#__PURE__*/ $2f5ae3590e7c0acd$var$_react.default.createElement($2f5ae3590e7c0acd$var$_iconNew.default, Object.assign({
        name: "LightbulbIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$2f5ae3590e7c0acd$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $2f5ae3590e7c0acd$var$_default = module.exports.default = $2f5ae3590e7c0acd$var$LightbulbIcon;

});

parcelRegister("eF4g8", function(module, exports) {
$parcel$export(module.exports, "default", () => $67d6892e5f4ef107$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jyPR0 = parcelRequire("jyPR0");

var $014x6 = parcelRequire("014x6");

var $dRkX9 = parcelRequire("dRkX9");

var $lPAO5 = parcelRequire("lPAO5");

var $Z7HhL = parcelRequire("Z7HhL");

var $8q9HG = parcelRequire("8q9HG");

var $8KDbX = parcelRequire("8KDbX");

var $8xoR5 = parcelRequire("8xoR5");
function $67d6892e5f4ef107$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = (size === null || size === void 0 ? void 0 : size.widthType) === 'pixel';
    let mediaSingleWidth = (size === null || size === void 0 ? void 0 : size.width) || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $8KDbX.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    // Preserve the absolute height before it is scaled below, so we can fall back to it if the
    // pixel-width computation yields a non-finite value (e.g. editorWidth/lineLength is 0 or
    // undefined in some host renderers such as Jira issue view).
    const absoluteHeight = height;
    if (mediaSingleWidth) {
        const pxWidth = (0, $8q9HG.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size === null || size === void 0 ? void 0 : size.widthType, (0, $Z7HhL.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $014x6.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $014x6.DEFAULT_EMBED_CARD_WIDTH) - (0, $014x6.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined && !Number.isFinite(height / width * 100)) // The aspect-ratio (padding-bottom) trick collapses to 0 when the ratio is non-finite,
    // which happens when the resolved pixel width is 0/NaN (e.g. editorWidth/lineLength is
    // unavailable in the host renderer). Fall back to the embed's absolute height so the box
    // keeps a usable height instead of collapsing.
    // For embedCard nodes the `height` prop is the iframe height only; the normal ratio path
    // adds 32px for the embed header (see `calc(... + 32px)` below), so add it here too to
    // avoid clipping the header.
    mediaWrapperHeight = Number.isFinite(absoluteHeight) ? absoluteHeight + (nodeType === 'embedCard' ? 32 : 0) : undefined;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $8xoR5.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $dRkX9.fg)('media-perf-uplift-mutation-fix')
        }),
        "data-layout": layout,
        "data-width": mediaSingleWidth,
        "data-width-type": (size === null || size === void 0 ? void 0 : size.widthType) || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $lPAO5.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $8xoR5.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("jyPR0", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("Z7HhL", function(module, exports) {
$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $45bb31f110e4acbc$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $45bb31f110e4acbc$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $45bb31f110e4acbc$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $45bb31f110e4acbc$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $45bb31f110e4acbc$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $45bb31f110e4acbc$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $45bb31f110e4acbc$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $45bb31f110e4acbc$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $45bb31f110e4acbc$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $45bb31f110e4acbc$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $45bb31f110e4acbc$export$b4b560efd3c61856);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $45bb31f110e4acbc$export$5937600f4cc784f0 = 24;
const $45bb31f110e4acbc$export$71d660e8ca5b8f73 = 320;
const $45bb31f110e4acbc$export$cd11d7d46412c89b = 3;
const $45bb31f110e4acbc$export$71482734bb54ac3 = 10;
const $45bb31f110e4acbc$export$fd2b09475ada41cc = 12;
const $45bb31f110e4acbc$export$8c5ac0b0c62a3d21 = 8;
const $45bb31f110e4acbc$export$68d0abe4f03863fb = $45bb31f110e4acbc$export$fd2b09475ada41cc * 2;
const $45bb31f110e4acbc$export$d722b7527b1834a8 = 250;
const $45bb31f110e4acbc$export$da894f7669b4e67c = 200;
const $45bb31f110e4acbc$export$e13825c38da2ce1 = 100;
var $45bb31f110e4acbc$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $45bb31f110e4acbc$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $45bb31f110e4acbc$export$4d41d008e9cd4f34 = 0.5;
const $45bb31f110e4acbc$export$b4b560efd3c61856 = 'caption-placeholder';

});

parcelRegister("8q9HG", function(module, exports) {
$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $699d76b400bc3234$export$a6f4ec2edd25b07e);
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $699d76b400bc3234$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}

});

parcelRegister("8KDbX", function(module, exports) {
$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $30cd5725281eefd1$export$7cd5aab2c4f1fb1e);

var $2i9nW = parcelRequire("2i9nW");
const $30cd5725281eefd1$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $2i9nW.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};

});
parcelRegister("2i9nW", function(module, exports) {
$parcel$export(module.exports, "wrappedLayouts", () => $90f245d847d5b77b$export$405baca3d8bc263d);
const $90f245d847d5b77b$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];

});


parcelRegister("8xoR5", function(module, exports) {
$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $ec856b76e60ef1a1$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $ec856b76e60ef1a1$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $ec856b76e60ef1a1$export$e18e95249d813157);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");

var $7Elcn = parcelRequire("7Elcn");

var $9JwwP = parcelRequire("9JwwP");

var $9iZX2 = parcelRequire("9iZX2");

var $kH6X9 = parcelRequire("kH6X9");
function $ec856b76e60ef1a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $ec856b76e60ef1a1$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $ec856b76e60ef1a1$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $014x6.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $014x6.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $014x6.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $ec856b76e60ef1a1$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $014x6.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $014x6.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $014x6.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $ec856b76e60ef1a1$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $9JwwP.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $9JwwP.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $9JwwP.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $ec856b76e60ef1a1$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $ec856b76e60ef1a1$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $ec856b76e60ef1a1$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $9JwwP.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $9JwwP.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $ec856b76e60ef1a1$var$getWidthIfFullWidthMode(width, containerWidth) : $ec856b76e60ef1a1$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $ec856b76e60ef1a1$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $ec856b76e60ef1a1$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $ec856b76e60ef1a1$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $ec856b76e60ef1a1$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $ec856b76e60ef1a1$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $ec856b76e60ef1a1$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $kH6X9.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $9iZX2.calcResizedWidth)(layout, width || 0, containerWidth) : $ec856b76e60ef1a1$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $ec856b76e60ef1a1$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $jctmk.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $ec856b76e60ef1a1$var$_ref2, " ", isInRenderer ? $ec856b76e60ef1a1$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $7Elcn.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $ec856b76e60ef1a1$var$float(layout), ";margin:", $ec856b76e60ef1a1$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $7Elcn.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $ec856b76e60ef1a1$var$isImageAligned(layout), ";");
};
const $ec856b76e60ef1a1$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $jctmk.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $ec856b76e60ef1a1$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $jctmk.css)("position:relative;", $ec856b76e60ef1a1$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $ec856b76e60ef1a1$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $ec856b76e60ef1a1$export$9e3fd9f6215dd7b6(rest)
    }, children);
$ec856b76e60ef1a1$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $ec856b76e60ef1a1$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    const borderRadius = "var(--ds-radius-large, 8px)";
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};

});
parcelRegister("7Elcn", function(module, exports) {
$parcel$export(module.exports, "nonWrappedLayouts", () => $20a70dec39e5a319$export$607795ead6e50626);
const $20a70dec39e5a319$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];

});

parcelRegister("9iZX2", function(module, exports) {
$parcel$export(module.exports, "calcResizedWidth", () => $61ea364bb3e0e1ca$export$d48e8f24f681763e);

var $9JwwP = parcelRequire("9JwwP");
function $61ea364bb3e0e1ca$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $9JwwP.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $9JwwP.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}

});

parcelRegister("kH6X9", function(module, exports) {
$parcel$export(module.exports, "roundToClosestEvenPxValue", () => $97864435ce3e2933$export$c832331b07480714);
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $97864435ce3e2933$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}

});



parcelRegister("l2xrI", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => $8432ac0bd92f5ee9$export$52d889c66db0f96e);

var $c8sLM = parcelRequire("c8sLM");

var $9bmoJ = parcelRequire("9bmoJ");

var $ypesA = parcelRequire("ypesA");

var $gwsTK = parcelRequire("gwsTK");

var $gYlcm = parcelRequire("gYlcm");
/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $8432ac0bd92f5ee9$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $8432ac0bd92f5ee9$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $8432ac0bd92f5ee9$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $gYlcm.supportsPopover)()) // eslint-disable-next-line @atlaskit/design-system/no-native-popover-or-dialog -- paints the drag preview above the page; it never takes Escape or closes on an outside press
    container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $gYlcm.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $gwsTK.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $ypesA.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $gYlcm.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
   * Some frameworks (eg `react`) don't render into the container until the next microtask.
   * - This will run before the browser takes it's picture of the element
   * - This will run before the animation frame that removes `container`.
   * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
     * **Problem**
     * On `Safari@17.1` if a drag preview element has some opacity,
     * Safari will include elements behind the drag preview element
     * in the drag preview.
     * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
     *
     * **Fix**
     * We push the drag preview so it is _almost_ completely offscreen so that
     * there won't be any elements behind the drag preview element.
     * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
     *
     * Using `-0.0001` so that any potential "see through" on the drag preview element
     * is effectively invisible 👻
     *
     * **Unsuccessful alternatives**
     * Setting a background color (eg "white") on the `container`
     * → Wrecks the opacity of the drag preview element
     *
     * Adding a parent element of the `container` with a background color (eg "white")
     * → Wrecks the opacity of the drag preview element
     */ /**
     * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
     * We can remove it in a future release
     */ if ((0, $9bmoJ.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage === null || nativeSetDragImage === void 0 || nativeSetDragImage(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount === null || unmount === void 0 || unmount();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $c8sLM.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});

parcelRegister("a7qOm", function(module, exports) {
$parcel$export(module.exports, "Card", () => $821a5c5c2c962e83$export$60332b2344f7fe41);

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");
var $8MaoS = parcelRequire("8MaoS");

var $613oU = parcelRequire("613oU");

var $azARG = parcelRequire("azARG");

var $9JzR9 = parcelRequire("9JzR9");

var $jOIHu = parcelRequire("jOIHu");
class $821a5c5c2c962e83$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jOIHu.CardWithURLRenderer), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
            locale: "en"
        }, content);
    }
}
const $821a5c5c2c962e83$export$60332b2344f7fe41 = (0, $613oU.default)((0, $9JzR9.context))((0, $azARG.default)()((0, $fcCIH.default)($821a5c5c2c962e83$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("jOIHu", function(module, exports) {
$parcel$export(module.exports, "CardWithURLRenderer", () => $3f42fb98731a919a$export$e00a7788e30dc998);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $eUgRu = parcelRequire("eUgRu");

var $dRkX9 = parcelRequire("dRkX9");

var $fVrlX = parcelRequire("fVrlX");

var $gvrpl = parcelRequire("gvrpl");

var $k7o0P = parcelRequire("k7o0P");

var $cXmqe = parcelRequire("cXmqe");

var $lH8yY = parcelRequire("lH8yY");

var $7iXOL = parcelRequire("7iXOL");

var $dPag5 = parcelRequire("dPag5");

var $c2F9z = parcelRequire("c2F9z");

var $792wf = parcelRequire("792wf");

const $3f42fb98731a919a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(0, $dPag5.importWithRetry)(()=>(parcelRequire("hYHPm"))));
function $3f42fb98731a919a$export$e00a7788e30dc998(props) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $fc4bM.useState)(()=>props.id ? props.id : (0, $eUgRu.default)());
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $lH8yY.clearMarks)(id);
            (0, $7iXOL.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, disablePreviewPanel: disablePreviewPanel } = props;
    const isFlexibleUi = (0, $c2F9z.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $cXmqe.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $fc4bM.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $k7o0P.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $gvrpl.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $gvrpl.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(FallbackComponent, null);
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring complete response.
    // Override appearance to 'block' for all FlexibleCards when FG is enabled.
    const effectiveAppearance = isFlexibleUi && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : appearance;
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: effectiveAppearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt,
        disablePreviewPanel: disablePreviewPanel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $792wf.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($3f42fb98731a919a$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}

});
parcelRegister("lH8yY", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $cb47748cb35de8d9$export$1a717feb4df1a945);

var $bvUI5 = parcelRequire("bvUI5");
const $cb47748cb35de8d9$export$1a717feb4df1a945 = (id)=>{
    if (0, $bvUI5.hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};

});

parcelRegister("7iXOL", function(module, exports) {
$parcel$export(module.exports, "clearMeasures", () => $635889be82902164$export$de42547d395c8271);

var $bvUI5 = parcelRequire("bvUI5");
const $635889be82902164$export$de42547d395c8271 = (id)=>{
    if (0, $bvUI5.hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};

});

parcelRegister("dPag5", function(module, exports) {
$parcel$export(module.exports, "importWithRetry", () => $dae49cb5131c25e0$export$aacbf48ace518c5a);

var $97DZ1 = parcelRequire("97DZ1");
const $dae49cb5131c25e0$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await (0, $97DZ1.sleep)(interval);
            return $dae49cb5131c25e0$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};

});
parcelRegister("97DZ1", function(module, exports) {
$parcel$export(module.exports, "sleep", () => $8529f0a3ffa2b1aa$export$e772c8ff12451969);
const $8529f0a3ffa2b1aa$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};

});


parcelRegister("hYHPm", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("2a74T"),
    $9dnsd("hzmzP"),
    $9dnsd("gGeD6"),
    $9dnsd("1zkIL"),
    $9dnsd("77JWw"),
    $9dnsd("hlj0q"),
    $9dnsd("hrLwj"),
    $9dnsd("dWlHb"),
    $9dnsd("9RLh6"),
    $9dnsd("sRQkh"),
    $9dnsd("cvO2I"),
    $9dnsd("6ljna"),
    $9dnsd("82a9R"),
    $9dnsd("ekETX"),
    $9dnsd("17rqg"),
    $9dnsd("ftCwL"),
    $9dnsd("b11yl"),
    $9dnsd("h05a5"),
    $9dnsd("4SQTv"),
    $9dnsd("5umLE"),
    $9dnsd("jJc2p"),
    $9dnsd("8QEJW"),
    $9dnsd("huUVD"),
    $9dnsd("67Pud"),
    $9dnsd("6umKv")
]).then(()=>parcelRequire('lRLzU'));

});



parcelRegister("7cjzH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd047031fc1ab3dc653f8f0d4a9b3992>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53d8d687b8884704$var$_react = $53d8d687b8884704$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $53d8d687b8884704$var$_iconNew = $53d8d687b8884704$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $53d8d687b8884704$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-generative-text-summary
 * Usage guidance:
 * Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53d8d687b8884704$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $53d8d687b8884704$var$_react.default.createElement($53d8d687b8884704$var$_iconNew.default, Object.assign({
        name: "AiGenerativeTextSummaryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 12.5V14H1v-1.5zm3.5-5.25v1.5H1v-1.5zM15 2v1.5H1V2zm-2.5 7a.75.75 0 0 1 .71.49l.61 1.69 1.69.62a.75.75 0 0 1 .49.7l-.01.12a.75.75 0 0 1-.48.59l-1.69.61-.61 1.69a.75.75 0 0 1-.59.48l-.12.01a.75.75 0 0 1-.7-.49l-.61-1.69-1.69-.61a.75.75 0 0 1-.48-.59L9 12.5a.75.75 0 0 1 .49-.7l1.69-.61.62-1.69a.75.75 0 0 1 .59-.48z"/>`
    }, props));
$53d8d687b8884704$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $53d8d687b8884704$var$_default = module.exports.default = $53d8d687b8884704$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("j3PNU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c19cab1662745293e5bf052395df909>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de067b54ecbceaea$var$_react = $de067b54ecbceaea$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $de067b54ecbceaea$var$_iconNew = $de067b54ecbceaea$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $de067b54ecbceaea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RovoChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/rovo-chat
 * Usage guidance:
 * Reserved for branded Rovo chat experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de067b54ecbceaea$var$RovoChatIcon = (props)=>/*#__PURE__*/ $de067b54ecbceaea$var$_react.default.createElement($de067b54ecbceaea$var$_iconNew.default, Object.assign({
        name: "RovoChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 3.125A2.625 2.625 0 0 1 2.625.5H8V2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125V8.5H16v2.875A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25z"/><path fill="currentcolor" d="M12.616.509a.75.75 0 0 1 .59.484l.613 1.687 1.688.615A.75.75 0 0 1 16 4l-.009.116a.75.75 0 0 1-.484.59l-1.688.613-.614 1.688a.75.75 0 0 1-.589.484L12.5 7.5a.75.75 0 0 1-.705-.493l-.615-1.688-1.687-.614a.75.75 0 0 1-.484-.589L9 4a.75.75 0 0 1 .493-.705l1.687-.615.615-1.687a.75.75 0 0 1 .589-.484L12.5.5z"/>`
    }, props));
$de067b54ecbceaea$var$RovoChatIcon.displayName = 'RovoChatIcon';
var $de067b54ecbceaea$var$_default = module.exports.default = $de067b54ecbceaea$var$RovoChatIcon;

});

parcelRegister("k678R", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $d87843d23950d8cc$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4ebbb5ba469a9ff5e91d5204f2f881d>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $b3n1a = parcelRequire("b3n1a");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d87843d23950d8cc$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $d87843d23950d8cc$export$e23ae35269442b4f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $b3n1a.IconWrapper), {
        svg: $d87843d23950d8cc$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("knCQo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4cbed98e1315ed66b53561d54056b7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed641645cc688ffc$var$_react = $ed641645cc688ffc$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ed641645cc688ffc$var$_iconNew = $ed641645cc688ffc$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ed641645cc688ffc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/automation
 * Usage guidance:
 * Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed641645cc688ffc$var$AutomationIcon = (props)=>/*#__PURE__*/ $ed641645cc688ffc$var$_react.default.createElement($ed641645cc688ffc$var$_iconNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$ed641645cc688ffc$var$AutomationIcon.displayName = 'AutomationIcon';
var $ed641645cc688ffc$var$_default = module.exports.default = $ed641645cc688ffc$var$AutomationIcon;

});

parcelRegister("5uAqu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60d7e5eb448902fa99721011ff901f9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ffc02940e7944fc$var$_react = $3ffc02940e7944fc$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $3ffc02940e7944fc$var$_iconNew = $3ffc02940e7944fc$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $3ffc02940e7944fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-diagonal
 * Usage guidance:
 * Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ffc02940e7944fc$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $3ffc02940e7944fc$var$_react.default.createElement($3ffc02940e7944fc$var$_iconNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$3ffc02940e7944fc$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $3ffc02940e7944fc$var$_default = module.exports.default = $3ffc02940e7944fc$var$GrowDiagonalIcon;

});

parcelRegister("4seZv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a7f4603a3394939adafb491e3ee704e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e567d69f95d776$var$_react = $33e567d69f95d776$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $33e567d69f95d776$var$_iconNew = $33e567d69f95d776$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $33e567d69f95d776$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/panel-right
 * Usage guidance:
 * Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e567d69f95d776$var$PanelRightIcon = (props)=>/*#__PURE__*/ $33e567d69f95d776$var$_react.default.createElement($33e567d69f95d776$var$_iconNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.25 4a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-6.5A.75.75 0 0 1 8.75 4z"/><path fill="currentcolor" fill-rule="evenodd" d="M14 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$33e567d69f95d776$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $33e567d69f95d776$var$_default = module.exports.default = $33e567d69f95d776$var$PanelRightIcon;

});

parcelRegister("bcRo2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $828a3a29660c4c44$var$_react = $828a3a29660c4c44$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $828a3a29660c4c44$var$_iconNew = $828a3a29660c4c44$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $828a3a29660c4c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $828a3a29660c4c44$var$ClockIcon = (props)=>/*#__PURE__*/ $828a3a29660c4c44$var$_react.default.createElement($828a3a29660c4c44$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$828a3a29660c4c44$var$ClockIcon.displayName = 'ClockIcon';
var $828a3a29660c4c44$var$_default = module.exports.default = $828a3a29660c4c44$var$ClockIcon;

});

parcelRegister("gTn0u", function(module, exports) {
$parcel$export(module.exports, "getCurrentSiteCloudId", () => $6274677668c554b3$export$143af22820ae9de);

var $jysiD = parcelRequire("jysiD");
const $6274677668c554b3$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>(0, $jysiD.currentSiteCloudIdService).get(baseUriWithNoTrailingSlash);

});
parcelRegister("jysiD", function(module, exports) {
$parcel$export(module.exports, "currentSiteCloudIdService", () => $5bd102222727cf49$export$1956112846aa829e);

var $k6qWC = parcelRequire("k6qWC");

var $l1AMN = parcelRequire("l1AMN");
const $5bd102222727cf49$export$b4b75b5ce5d33ae5 = (0, $l1AMN.getCurrentSiteCloudIdLocalStorageKey)();
const $5bd102222727cf49$export$1956112846aa829e = new (0, $k6qWC.CurrentSiteCloudIdService)();

});
parcelRegister("k6qWC", function(module, exports) {
$parcel$export(module.exports, "CurrentSiteCloudIdService", () => $7206798ed616cf1c$export$a15da722a3b05509);

var $bhV4A = parcelRequire("bhV4A");

var $jBHs2 = parcelRequire("jBHs2");

var $jFJ1i = parcelRequire("jFJ1i");

var $1iKWH = parcelRequire("1iKWH");

var $9CvwT = parcelRequire("9CvwT");
const $7206798ed616cf1c$var$smartCardStorage = new (0, $bhV4A.StorageClient)((0, $1iKWH.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE);
class $7206798ed616cf1c$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $7206798ed616cf1c$var$smartCardStorage.getItem((0, $jFJ1i.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $7206798ed616cf1c$var$smartCardStorage.setItemWithExpiry((0, $jFJ1i.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash), cloudId, (0, $1iKWH.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_TTL_MS);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = (0, $9CvwT.normalizeBaseUri)(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $jBHs2.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response === null || response === void 0 ? void 0 : response.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}

});
parcelRegister("jFJ1i", function(module, exports) {
$parcel$export(module.exports, "cloudIdStorageItemKey", () => $0a481c3c02e2fad5$export$87f317e381996380);

var $1iKWH = parcelRequire("1iKWH");

var $9CvwT = parcelRequire("9CvwT");
function $0a481c3c02e2fad5$export$87f317e381996380(baseUriWithNoTrailingSlash = '') {
    return `${(0, $1iKWH.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX}${encodeURIComponent((0, $9CvwT.normalizeBaseUri)(baseUriWithNoTrailingSlash))}`;
}

});
parcelRegister("1iKWH", function(module, exports) {
$parcel$export(module.exports, "currentSiteCloudIdConstants", () => $15d4ab14709851da$export$a05eb2f7d4daba17);
const $15d4ab14709851da$export$a05eb2f7d4daba17 = {
    SMART_CARD_STORAGE_SCOPE: 'smart-card-social-proof',
    CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX: 'site-cloud-id:v1:',
    CURRENT_SITE_CLOUD_ID_TTL_MS: 86400000
};

});

parcelRegister("9CvwT", function(module, exports) {
$parcel$export(module.exports, "normalizeBaseUri", () => $2968ecb8d18ff8b7$export$d01aa4af38c023bb);
function $2968ecb8d18ff8b7$export$d01aa4af38c023bb(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}

});



parcelRegister("l1AMN", function(module, exports) {
$parcel$export(module.exports, "getCurrentSiteCloudIdLocalStorageKey", () => $1a03d41302b904c7$export$dea1a8bc5840f118);

var $jFJ1i = parcelRequire("jFJ1i");

var $1iKWH = parcelRequire("1iKWH");
const $1a03d41302b904c7$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${(0, $1iKWH.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE}_${(0, $jFJ1i.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash)}`;

});



parcelRegister("9Bg7Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe170e3e7b80264b949b54a1ecf34342>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fd4145a8b795c11$var$_react = $6fd4145a8b795c11$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $6fd4145a8b795c11$var$_iconNew = $6fd4145a8b795c11$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $6fd4145a8b795c11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/angle-brackets
 * Usage guidance:
 * Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fd4145a8b795c11$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6fd4145a8b795c11$var$_react.default.createElement($6fd4145a8b795c11$var$_iconNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6fd4145a8b795c11$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6fd4145a8b795c11$var$_default = module.exports.default = $6fd4145a8b795c11$var$AngleBracketsIcon;

});

parcelRegister("bNyFZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6f2d3ebe3a82c8cf$export$2e2bcd8739ae039);

var $3dgbz = parcelRequire("3dgbz");

var $jIzn1 = parcelRequire("jIzn1");
// `grayBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `grayBold` directly with `gray`.
const $6f2d3ebe3a82c8cf$var$FileIconWithColor = (0, $jIzn1.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3dgbz))), 'grayBold');
$6f2d3ebe3a82c8cf$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $6f2d3ebe3a82c8cf$export$2e2bcd8739ae039 = $6f2d3ebe3a82c8cf$var$FileIconWithColor;

});
parcelRegister("3dgbz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2381f0cfc7f82e9041a16cf397e08d17>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $256f241fdad8b2fe$var$_react = $256f241fdad8b2fe$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $256f241fdad8b2fe$var$_iconNew = $256f241fdad8b2fe$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $256f241fdad8b2fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/file
 * Usage guidance:
 * Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $256f241fdad8b2fe$var$FileIcon = (props)=>/*#__PURE__*/ $256f241fdad8b2fe$var$_react.default.createElement($256f241fdad8b2fe$var$_iconNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$256f241fdad8b2fe$var$FileIcon.displayName = 'FileIcon';
var $256f241fdad8b2fe$var$_default = module.exports.default = $256f241fdad8b2fe$var$FileIcon;

});


parcelRegister("64IAh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f608a9535844c97ef8ab19c5a3e36362>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46c5b343d895c781$var$_react = $46c5b343d895c781$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $46c5b343d895c781$var$_iconNew = $46c5b343d895c781$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $46c5b343d895c781$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/image
 * Usage guidance:
 * Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46c5b343d895c781$var$ImageIcon = (props)=>/*#__PURE__*/ $46c5b343d895c781$var$_react.default.createElement($46c5b343d895c781$var$_iconNew.default, Object.assign({
        name: "ImageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$46c5b343d895c781$var$ImageIcon.displayName = 'ImageIcon';
var $46c5b343d895c781$var$_default = module.exports.default = $46c5b343d895c781$var$ImageIcon;

});

parcelRegister("jR4gQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $259df869278b1f61$export$2e2bcd8739ae039);

var $htOsa = parcelRequire("htOsa");

var $jIzn1 = parcelRequire("jIzn1");
// `purpleBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `purpleBold` directly with `purple`.
const $259df869278b1f61$var$ChartBarIconWithColor = (0, $jIzn1.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($htOsa))), 'purpleBold');
$259df869278b1f61$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $259df869278b1f61$export$2e2bcd8739ae039 = $259df869278b1f61$var$ChartBarIconWithColor;

});
parcelRegister("htOsa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d0e12c208abbb78a0f55c6c4c303feb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb9c4810e5a1a003$var$_react = $cb9c4810e5a1a003$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $cb9c4810e5a1a003$var$_iconNew = $cb9c4810e5a1a003$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $cb9c4810e5a1a003$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-bar
 * Usage guidance:
 * Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb9c4810e5a1a003$var$ChartBarIcon = (props)=>/*#__PURE__*/ $cb9c4810e5a1a003$var$_react.default.createElement($cb9c4810e5a1a003$var$_iconNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$cb9c4810e5a1a003$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $cb9c4810e5a1a003$var$_default = module.exports.default = $cb9c4810e5a1a003$var$ChartBarIcon;

});


parcelRegister("3uDvS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $31ec9fd19fa9ff01$export$2e2bcd8739ae039);

var $2NnGi = parcelRequire("2NnGi");

var $jIzn1 = parcelRequire("jIzn1");
// `greenBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `greenBold` directly with `green`.
const $31ec9fd19fa9ff01$var$ListBulletedIconWithColor = (0, $jIzn1.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($2NnGi))), 'greenBold');
$31ec9fd19fa9ff01$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $31ec9fd19fa9ff01$export$2e2bcd8739ae039 = $31ec9fd19fa9ff01$var$ListBulletedIconWithColor;

});
parcelRegister("2NnGi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23389d96ad47534eee0427de6a1854fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $209286f5338687df$var$_react = $209286f5338687df$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $209286f5338687df$var$_iconNew = $209286f5338687df$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $209286f5338687df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-bulleted
 * Usage guidance:
 * Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $209286f5338687df$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $209286f5338687df$var$_react.default.createElement($209286f5338687df$var$_iconNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$209286f5338687df$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $209286f5338687df$var$_default = module.exports.default = $209286f5338687df$var$ListBulletedIcon;

});


parcelRegister("lUyjF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e827695d12a93239784734f306ed1225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff39726cb6b525b5$var$_react = $ff39726cb6b525b5$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ff39726cb6b525b5$var$_iconNew = $ff39726cb6b525b5$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ff39726cb6b525b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/people-group
 * Usage guidance:
 * Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff39726cb6b525b5$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $ff39726cb6b525b5$var$_react.default.createElement($ff39726cb6b525b5$var$_iconNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$ff39726cb6b525b5$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $ff39726cb6b525b5$var$_default = module.exports.default = $ff39726cb6b525b5$var$PeopleGroupIcon;

});

parcelRegister("ftQsl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dee10bb7d40cfcc19f635db898b5b8fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b452412ad6415d33$var$_react = $b452412ad6415d33$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b452412ad6415d33$var$_iconNew = $b452412ad6415d33$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b452412ad6415d33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/attachment
 * Usage guidance:
 * Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b452412ad6415d33$var$AttachmentIcon = (props)=>/*#__PURE__*/ $b452412ad6415d33$var$_react.default.createElement($b452412ad6415d33$var$_iconNew.default, Object.assign({
        name: "AttachmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$b452412ad6415d33$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $b452412ad6415d33$var$_default = module.exports.default = $b452412ad6415d33$var$AttachmentIcon;

});

parcelRegister("7y0BG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::037384548dae3362b5016ccfe4fa350d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57ec2de3e9f2fb5a$var$_react = $57ec2de3e9f2fb5a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $57ec2de3e9f2fb5a$var$_iconNew = $57ec2de3e9f2fb5a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $57ec2de3e9f2fb5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/task
 * Usage guidance:
 * Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57ec2de3e9f2fb5a$var$TaskIcon = (props)=>/*#__PURE__*/ $57ec2de3e9f2fb5a$var$_react.default.createElement($57ec2de3e9f2fb5a$var$_iconNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$57ec2de3e9f2fb5a$var$TaskIcon.displayName = 'TaskIcon';
var $57ec2de3e9f2fb5a$var$_default = module.exports.default = $57ec2de3e9f2fb5a$var$TaskIcon;

});

parcelRegister("4Mzcw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90fbd5da1cedf8ab72cfec6643bf73aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37b6f34740ec4e39$var$_react = $37b6f34740ec4e39$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $37b6f34740ec4e39$var$_iconNew = $37b6f34740ec4e39$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $37b6f34740ec4e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/subtasks
 * Usage guidance:
 * Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37b6f34740ec4e39$var$SubtasksIcon = (props)=>/*#__PURE__*/ $37b6f34740ec4e39$var$_react.default.createElement($37b6f34740ec4e39$var$_iconNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$37b6f34740ec4e39$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $37b6f34740ec4e39$var$_default = module.exports.default = $37b6f34740ec4e39$var$SubtasksIcon;

});

parcelRegister("62nNx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3f208f0f78ab034c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3mryR = parcelRequire("3mryR");

var $7aaSq = parcelRequire("7aaSq");
function $3f208f0f78ab034c$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3mryR))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("3mryR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efe1ac521db6624f24d88867703638c4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2728ce42c14730cc$var$_react = $2728ce42c14730cc$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $2728ce42c14730cc$var$_iconNew = $2728ce42c14730cc$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $2728ce42c14730cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/branch
 * Usage guidance:
 * Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2728ce42c14730cc$var$BranchIcon = (props)=>/*#__PURE__*/ $2728ce42c14730cc$var$_react.default.createElement($2728ce42c14730cc$var$_iconNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$2728ce42c14730cc$var$BranchIcon.displayName = 'BranchIcon';
var $2728ce42c14730cc$var$_default = module.exports.default = $2728ce42c14730cc$var$BranchIcon;

});

parcelRegister("7aaSq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2ca6e514ad5a7e4$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
function $c2ca6e514ad5a7e4$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});


parcelRegister("g1xpD", function(module, exports) {
$parcel$export(module.exports, "default", () => $20f0647c932eacb2$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $DNksS = parcelRequire("DNksS");

var $A0kxW = parcelRequire("A0kxW");
function $20f0647c932eacb2$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $DNksS.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $A0kxW.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("4gFtZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8d3c1de29ca2dd2c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $7qMsD = parcelRequire("7qMsD");

var $7aaSq = parcelRequire("7aaSq");
function $8d3c1de29ca2dd2c$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7qMsD))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});
parcelRegister("7qMsD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4043daf294edfb6e9fedbae382cffb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56908d6af60ad5bf$var$_react = $56908d6af60ad5bf$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $56908d6af60ad5bf$var$_iconNew = $56908d6af60ad5bf$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $56908d6af60ad5bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/commit
 * Usage guidance:
 * Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56908d6af60ad5bf$var$CommitIcon = (props)=>/*#__PURE__*/ $56908d6af60ad5bf$var$_react.default.createElement($56908d6af60ad5bf$var$_iconNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$56908d6af60ad5bf$var$CommitIcon.displayName = 'CommitIcon';
var $56908d6af60ad5bf$var$_default = module.exports.default = $56908d6af60ad5bf$var$CommitIcon;

});


parcelRegister("9tj5j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a9dbc73de4cea33f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $kWy07 = parcelRequire("kWy07");

var $7aaSq = parcelRequire("7aaSq");
function $a9dbc73de4cea33f$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWy07))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});
parcelRegister("kWy07", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e259fbb9cff618a518c8297911744c36>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3f3995322e4092b$var$_react = $f3f3995322e4092b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $f3f3995322e4092b$var$_iconNew = $f3f3995322e4092b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $f3f3995322e4092b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/pull-request
 * Usage guidance:
 * Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3f3995322e4092b$var$PullRequestIcon = (props)=>/*#__PURE__*/ $f3f3995322e4092b$var$_react.default.createElement($f3f3995322e4092b$var$_iconNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$f3f3995322e4092b$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $f3f3995322e4092b$var$_default = module.exports.default = $f3f3995322e4092b$var$PullRequestIcon;

});


parcelRegister("7uqom", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $551299b52c32f3f6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $9Bg7Y = parcelRequire("9Bg7Y");

var $7aaSq = parcelRequire("7aaSq");
function $551299b52c32f3f6$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Bg7Y))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("39BPV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $967042fa0880771e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $j2EaQ = parcelRequire("j2EaQ");

var $7aaSq = parcelRequire("7aaSq");
function $967042fa0880771e$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j2EaQ))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});
parcelRegister("j2EaQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffd9ef1cff51ae8bc69ef502364c6257>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddcd5def385de4a0$var$_react = $ddcd5def385de4a0$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ddcd5def385de4a0$var$_iconNew = $ddcd5def385de4a0$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ddcd5def385de4a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/bug
 * Usage guidance:
 * Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddcd5def385de4a0$var$BugIcon = (props)=>/*#__PURE__*/ $ddcd5def385de4a0$var$_react.default.createElement($ddcd5def385de4a0$var$_iconNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$ddcd5def385de4a0$var$BugIcon.displayName = 'BugIcon';
var $ddcd5def385de4a0$var$_default = module.exports.default = $ddcd5def385de4a0$var$BugIcon;

});


parcelRegister("lqopQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fc4d48c2dc87b273$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fFitK = parcelRequire("fFitK");

var $7aaSq = parcelRequire("7aaSq");
function $fc4d48c2dc87b273$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fFitK))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});
parcelRegister("fFitK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86e4cb0cec8e9e12166c70b4519c936c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b67904d7f8850d57$var$_react = $b67904d7f8850d57$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b67904d7f8850d57$var$_iconNew = $b67904d7f8850d57$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b67904d7f8850d57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/changes
 * Usage guidance:
 * Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b67904d7f8850d57$var$ChangesIcon = (props)=>/*#__PURE__*/ $b67904d7f8850d57$var$_react.default.createElement($b67904d7f8850d57$var$_iconNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$b67904d7f8850d57$var$ChangesIcon.displayName = 'ChangesIcon';
var $b67904d7f8850d57$var$_default = module.exports.default = $b67904d7f8850d57$var$ChangesIcon;

});


parcelRegister("d5YHt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d5525da20db497dd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2x49U = parcelRequire("2x49U");

var $7aaSq = parcelRequire("7aaSq");
function $d5525da20db497dd$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2x49U))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});
parcelRegister("2x49U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78c27fbf0b4dfca713ea16873edeb9da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d81e3b2a6611e66$var$_react = $1d81e3b2a6611e66$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $1d81e3b2a6611e66$var$_iconNew = $1d81e3b2a6611e66$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $1d81e3b2a6611e66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/epic
 * Usage guidance:
 * Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d81e3b2a6611e66$var$EpicIcon = (props)=>/*#__PURE__*/ $1d81e3b2a6611e66$var$_react.default.createElement($1d81e3b2a6611e66$var$_iconNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$1d81e3b2a6611e66$var$EpicIcon.displayName = 'EpicIcon';
var $1d81e3b2a6611e66$var$_default = module.exports.default = $1d81e3b2a6611e66$var$EpicIcon;

});


parcelRegister("hKYwr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $424e138f184d2db8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dQDhV = parcelRequire("dQDhV");

var $7aaSq = parcelRequire("7aaSq");
function $424e138f184d2db8$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQDhV))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});
parcelRegister("dQDhV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::272e3b8843112479f54c710862304c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a14e9b7a33442777$var$_react = $a14e9b7a33442777$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a14e9b7a33442777$var$_iconNew = $a14e9b7a33442777$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a14e9b7a33442777$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/incident
 * Usage guidance:
 * Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a14e9b7a33442777$var$IncidentIcon = (props)=>/*#__PURE__*/ $a14e9b7a33442777$var$_react.default.createElement($a14e9b7a33442777$var$_iconNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$a14e9b7a33442777$var$IncidentIcon.displayName = 'IncidentIcon';
var $a14e9b7a33442777$var$_default = module.exports.default = $a14e9b7a33442777$var$IncidentIcon;

});


parcelRegister("1bcrw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4d99232d4548cd1b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $vsYI8 = parcelRequire("vsYI8");

var $7aaSq = parcelRequire("7aaSq");
function $4d99232d4548cd1b$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($vsYI8))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});
parcelRegister("vsYI8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0e2f4aa13758d0bfd9dbdbb60ec6216>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05e95fd54925f7ef$var$_react = $05e95fd54925f7ef$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $05e95fd54925f7ef$var$_iconNew = $05e95fd54925f7ef$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $05e95fd54925f7ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/problem
 * Usage guidance:
 * Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05e95fd54925f7ef$var$ProblemIcon = (props)=>/*#__PURE__*/ $05e95fd54925f7ef$var$_react.default.createElement($05e95fd54925f7ef$var$_iconNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343A8 8 0 1 1 13.658 13.66 8 8 0 0 1 2.343 2.343m.562 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.692-.561a6.5 6.5 0 0 0-8.632-.5l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$05e95fd54925f7ef$var$ProblemIcon.displayName = 'ProblemIcon';
var $05e95fd54925f7ef$var$_default = module.exports.default = $05e95fd54925f7ef$var$ProblemIcon;

});


parcelRegister("62KtX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ba41f0c4e189b7f9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $jDS8z = parcelRequire("jDS8z");

var $7aaSq = parcelRequire("7aaSq");
function $ba41f0c4e189b7f9$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jDS8z))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("jDS8z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c0c4ad146353612d795bc46242b9b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4cba75cba12c9a7$var$_react = $e4cba75cba12c9a7$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e4cba75cba12c9a7$var$_iconNew = $e4cba75cba12c9a7$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e4cba75cba12c9a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/work-item
 * Usage guidance:
 * Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4cba75cba12c9a7$var$WorkItemIcon = (props)=>/*#__PURE__*/ $e4cba75cba12c9a7$var$_react.default.createElement($e4cba75cba12c9a7$var$_iconNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$e4cba75cba12c9a7$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $e4cba75cba12c9a7$var$_default = module.exports.default = $e4cba75cba12c9a7$var$WorkItemIcon;

});


parcelRegister("8uzl9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b25c21dc5c457862$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $g4ldU = parcelRequire("g4ldU");

var $7aaSq = parcelRequire("7aaSq");
function $b25c21dc5c457862$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g4ldU))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});
parcelRegister("g4ldU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e54e25b96851fc60bdb723a0652ff9cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb2d7b90569f9067$var$_react = $bb2d7b90569f9067$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $bb2d7b90569f9067$var$_iconNew = $bb2d7b90569f9067$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $bb2d7b90569f9067$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/story
 * Usage guidance:
 * Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb2d7b90569f9067$var$StoryIcon = (props)=>/*#__PURE__*/ $bb2d7b90569f9067$var$_react.default.createElement($bb2d7b90569f9067$var$_iconNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$bb2d7b90569f9067$var$StoryIcon.displayName = 'StoryIcon';
var $bb2d7b90569f9067$var$_default = module.exports.default = $bb2d7b90569f9067$var$StoryIcon;

});


parcelRegister("fvAOB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8644319267c52b78$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $4Mzcw = parcelRequire("4Mzcw");

var $7aaSq = parcelRequire("7aaSq");
function $8644319267c52b78$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4Mzcw))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("3YSuE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6438541dc5d777f6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $7y0BG = parcelRequire("7y0BG");

var $7aaSq = parcelRequire("7aaSq");
function $6438541dc5d777f6$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7y0BG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("i8H3c", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7797c311e247a4be$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $ajy7j = parcelRequire("ajy7j");

var $7aaSq = parcelRequire("7aaSq");
function $7797c311e247a4be$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ajy7j))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});
parcelRegister("ajy7j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a997026dcaaf883b169150a2776c7ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $782624a95cccf323$var$_react = $782624a95cccf323$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $782624a95cccf323$var$_iconNew = $782624a95cccf323$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $782624a95cccf323$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/quotation-mark
 * Usage guidance:
 * Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $782624a95cccf323$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $782624a95cccf323$var$_react.default.createElement($782624a95cccf323$var$_iconNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$782624a95cccf323$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $782624a95cccf323$var$_default = module.exports.default = $782624a95cccf323$var$QuotationMarkIcon;

});


parcelRegister("dWK4M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0b2cb57fae4868e5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $ajy7j = parcelRequire("ajy7j");

var $g1xpD = parcelRequire("g1xpD");
function $0b2cb57fae4868e5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $g1xpD.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ajy7j))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("cLmGU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4a5b8aa683d7efd6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $v2Oqo = parcelRequire("v2Oqo");

var $7aaSq = parcelRequire("7aaSq");
function $4a5b8aa683d7efd6$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($v2Oqo))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});
parcelRegister("v2Oqo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d513d454dd46c2$var$_react = $05d513d454dd46c2$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $05d513d454dd46c2$var$_iconNew = $05d513d454dd46c2$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $05d513d454dd46c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05d513d454dd46c2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $05d513d454dd46c2$var$_react.default.createElement($05d513d454dd46c2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$05d513d454dd46c2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $05d513d454dd46c2$var$_default = module.exports.default = $05d513d454dd46c2$var$PageLiveDocIcon;

});


parcelRegister("1EY6C", function(module, exports) {
$parcel$export(module.exports, "selectUnit", () => $1358269acfd03aaa$export$b8f7189986dd5395);
var $1358269acfd03aaa$var$__assign = undefined && undefined.__assign || function() {
    $1358269acfd03aaa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1358269acfd03aaa$var$__assign.apply(this, arguments);
};
var $1358269acfd03aaa$var$MS_PER_SECOND = 1e3;
var $1358269acfd03aaa$var$SECS_PER_MIN = 60;
var $1358269acfd03aaa$var$SECS_PER_HOUR = $1358269acfd03aaa$var$SECS_PER_MIN * 60;
var $1358269acfd03aaa$var$SECS_PER_DAY = $1358269acfd03aaa$var$SECS_PER_HOUR * 24;
var $1358269acfd03aaa$var$SECS_PER_WEEK = $1358269acfd03aaa$var$SECS_PER_DAY * 7;
function $1358269acfd03aaa$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $1358269acfd03aaa$var$__assign($1358269acfd03aaa$var$__assign({}, $1358269acfd03aaa$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $1358269acfd03aaa$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $1358269acfd03aaa$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $1358269acfd03aaa$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $1358269acfd03aaa$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $1358269acfd03aaa$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $1358269acfd03aaa$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};

});

parcelRegister("YihpL", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", () => $bbda946dee4de2e6$export$8a485e2e7ed91e8f);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $anluN = parcelRequire("anluN");

var $1wMGq = parcelRequire("1wMGq");

var $78H7C = parcelRequire("78H7C");

var $fR54P = parcelRequire("fR54P");
const $bbda946dee4de2e6$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fR54P.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $bbda946dee4de2e6$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $1wMGq.defaultLogoParams).size, iconColor: iconColor = (0, $1wMGq.defaultLogoParams).iconColor, textColor: textColor = (0, $1wMGq.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $78H7C.default), {
        appearance: appearance,
        label: label,
        svg: $bbda946dee4de2e6$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("1wMGq", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $2c2da520d42d0bf7$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $2c2da520d42d0bf7$export$793fba32aed8942a);
const $2c2da520d42d0bf7$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $2c2da520d42d0bf7$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

});

parcelRegister("78H7C", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c7fe218d49006a3$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $8c7fe218d49006a3$var$CSS_VAR_COLOR = '--logo-color';
const $8c7fe218d49006a3$var$CSS_VAR_FILL = '--logo-fill';
const $8c7fe218d49006a3$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $8c7fe218d49006a3$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
        "data-testid": testId,
        style: {
            [$8c7fe218d49006a3$var$CSS_VAR_COLOR]: iconColor,
            [$8c7fe218d49006a3$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $2R2iS.default)([
            $8c7fe218d49006a3$var$styles.root,
            shouldApplyStopColor && $8c7fe218d49006a3$var$styles.stop,
            size && $8c7fe218d49006a3$var$styles[size]
        ])
    });
};
var $8c7fe218d49006a3$export$2e2bcd8739ae039 = $8c7fe218d49006a3$var$Wrapper;

});

parcelRegister("fR54P", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearance", () => $2ef21b5b2b34612c$export$bbacc3980e0f3029);
const $2ef21b5b2b34612c$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});


parcelRegister("9OgN6", function(module, exports) {
$parcel$export(module.exports, "getPreviewUrlWithEmbedContext", () => $12194dc9c84423c9$export$736a7b9a8e50ca01);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $12194dc9c84423c9$export$4470f298c61a79da);

var $aHwAH = parcelRequire("aHwAH");
const $12194dc9c84423c9$export$736a7b9a8e50ca01 = (previewUrl, { hostProduct: hostProduct, themeState: themeState })=>{
    try {
        const url = new URL(previewUrl);
        if (themeState) url.searchParams.append('themeState', (0, $aHwAH.themeObjectToString)(themeState));
        if (hostProduct) url.searchParams.set('hostProduct', hostProduct);
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $12194dc9c84423c9$export$4470f298c61a79da = (previewUrl, themeState)=>$12194dc9c84423c9$export$736a7b9a8e50ca01(previewUrl, {
        themeState: themeState
    });

});

parcelRegister("3jqF1", function(module, exports) {
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $0f3034bad10f12dd$export$9b7e6a102056a387);
const $0f3034bad10f12dd$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};

});

parcelRegister("2KVKy", function(module, exports) {
$parcel$export(module.exports, "IFrame", () => $0e91e6e603226e96$export$b32b5f1ee4493319);

var $fc4bM = parcelRequire("fc4bM");

var $Xeg81 = parcelRequire("Xeg81");

var $ci6tk = parcelRequire("ci6tk");

var $fuKmY = parcelRequire("fuKmY");
const $0e91e6e603226e96$var$LazyEmbeddedConfluencePage = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(0, $fuKmY.loadEmbeddedConfluencePage)().then((Page)=>({
            default: Page
        })));
const $0e91e6e603226e96$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $Xeg81.useConfluencePageData)(props.src || '', extensionKey || '');
    const InjectedPage = (0, $ci6tk.useEmbeddedConfluencePage)();
    const Page = InjectedPage ?? $0e91e6e603226e96$var$LazyEmbeddedConfluencePage;
    const fallbackIframe = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: fallbackIframe
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Page, {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    })) : fallbackIframe;
};

});
parcelRegister("Xeg81", function(module, exports) {
$parcel$export(module.exports, "useConfluencePageData", () => $b171863a013b1c2a$export$10fb2803bc7b79fc);

var $fc4bM = parcelRequire("fc4bM");

var $1DvZb = parcelRequire("1DvZb");

var $lup9w = parcelRequire("lup9w");
var $b171863a013b1c2a$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $b171863a013b1c2a$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $b171863a013b1c2a$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $b171863a013b1c2a$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $fc4bM.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($b171863a013b1c2a$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('hostname')) || '';
        const contentId = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('contentId')) || '';
        const spaceKey = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('spaceKey')) || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('themeState')) || '';
        const themeMode = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('themeMode');
        const enableInlineComments = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('enableInlineComments')) === 'true';
        const enablePageComments = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('enablePageComments')) === 'true';
        const userId = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('userId')) || '';
        const userIdType = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('userInfo')) || undefined;
        const parentProduct = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('parentProduct')) || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $lup9w.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $fc4bM.useEffect)(()=>{
        if (parsedData !== null && parsedData !== void 0 && parsedData.themeStateObject) (0, $1DvZb.setGlobalTheme)(parsedData.themeStateObject);
    }, [
        parsedData === null || parsedData === void 0 ? void 0 : parsedData.themeStateObject
    ]);
    return parsedData;
};

});

parcelRegister("ci6tk", function(module, exports) {
$parcel$export(module.exports, "useEmbeddedConfluencePage", () => $b3a7a0134b8881cb$export$95a59d66783a54b3);

var $fc4bM = parcelRequire("fc4bM");
const $b3a7a0134b8881cb$var$EmbeddedConfluencePageContext = /*#__PURE__*/ (0, $fc4bM.createContext)(null);
const $b3a7a0134b8881cb$export$542af7a009641f95 = $b3a7a0134b8881cb$var$EmbeddedConfluencePageContext.Provider;
const $b3a7a0134b8881cb$export$95a59d66783a54b3 = ()=>(0, $fc4bM.useContext)($b3a7a0134b8881cb$var$EmbeddedConfluencePageContext);

});

parcelRegister("fuKmY", function(module, exports) {
$parcel$export(module.exports, "loadEmbeddedConfluencePage", () => $ab97a38405a62688$export$61cc2a15eefecd0b);
/**
 * Async factory for the Confluence embed `Page` component.
 *
 * Kept in its own module so `@atlaskit/embedded-confluence/page` is a dynamic
 * import only — hosts that never render a Confluence embed URL do not
 * download this chunk.
 */ 
async function $ab97a38405a62688$export$61cc2a15eefecd0b() {
    const { Page: Page } = await (parcelRequire("cpSN3"));
    return Page;
}

});
parcelRegister("cpSN3", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bMKAA"),
    $9dnsd("bBmVm"),
    $9dnsd("ajMM5")
]).then(()=>parcelRequire('ijaeU'));

});



parcelRegister("hQjsl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d917ba19410d867502f4eac87befeea4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfd6628fff6d09f0$var$_react = $cfd6628fff6d09f0$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $cfd6628fff6d09f0$var$_iconNew = $cfd6628fff6d09f0$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $cfd6628fff6d09f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-external
 * Usage guidance:
 * Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfd6628fff6d09f0$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $cfd6628fff6d09f0$var$_react.default.createElement($cfd6628fff6d09f0$var$_iconNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$cfd6628fff6d09f0$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $cfd6628fff6d09f0$var$_default = module.exports.default = $cfd6628fff6d09f0$var$LinkExternalIcon;

});

parcelRegister("eq4dS", function(module, exports) {
$parcel$export(module.exports, "useSmartCardContext", () => $07f23428b9174aba$export$10e9cca30e50f657);

var $fc4bM = parcelRequire("fc4bM");

var $gAa0D = parcelRequire("gAa0D");
function $07f23428b9174aba$var$useContextMemoized(reactContext) {
    const value = (0, $fc4bM.useContext)(reactContext);
    const context = (0, $fc4bM.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $07f23428b9174aba$export$10e9cca30e50f657 = ()=>$07f23428b9174aba$var$useContextMemoized((0, $gAa0D.SmartCardContext));

});

parcelRegister("hmNoe", function(module, exports) {
$parcel$export(module.exports, "embedHeaderHeight", () => $91167baa37bf77ed$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "EmbedResizeMessageListener", () => $91167baa37bf77ed$export$3482036c37e627f4);

var $fc4bM = parcelRequire("fc4bM");
const $91167baa37bf77ed$export$8f5a73ba0d077b01 = 32;
class $91167baa37bf77ed$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        }, this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $91167baa37bf77ed$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}

});

parcelRegister("hKw5n", function(module, exports) {
$parcel$export(module.exports, "CardSSR", () => $a2ffc5ae9d56f5eb$export$7b5e1b7f9a325b6);

var $fc4bM = parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $3TJLC = parcelRequire("3TJLC");

var $dRkX9 = parcelRequire("dRkX9");

var $9JzR9 = parcelRequire("9JzR9");

var $c2F9z = parcelRequire("c2F9z");

var $3cJGz = parcelRequire("3cJGz");

var $cHDa7 = parcelRequire("cHDa7");
const $a2ffc5ae9d56f5eb$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $fc4bM.useState)(()=>props.id ?? (0, $eUgRu.default)());
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring a complete response.
    // Override appearance to 'block' for FlexibleCards when FG is enabled.
    const effectiveAppearance = (0, $c2F9z.isFlexibleUiCard)(props.children, props.ui) && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : props.appearance;
    const propsWithId = {
        ...props,
        id: id,
        appearance: effectiveAppearance
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: (0, $9JzR9.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3cJGz.default), propsWithId, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cHDa7.CardWithUrl), propsWithId)));
};

});
parcelRegister("3cJGz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3b4cc624c41a9b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $792wf = parcelRequire("792wf");
const $2f3b4cc624c41a9b$var$CardErrorBoundary = ({ children: children, ...props })=>{
    // TODO: NAVX-4682: Add feature parity to CardWithURLRenderer
    const ErrorFallbackComponent = props.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $792wf.LoadingCardLink), props);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, children);
};
var $2f3b4cc624c41a9b$export$2e2bcd8739ae039 = $2f3b4cc624c41a9b$var$CardErrorBoundary;

});


parcelRegister("dHPTa", function(module, exports) {
$parcel$export(module.exports, "canRenderDatasource", () => $c989c121ce67308e$export$1974047c293dd52e);

var $pvPHQ = parcelRequire("pvPHQ");
const $c989c121ce67308e$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = (0, $pvPHQ.getDatasourceType)(datasourceId);
    switch(datasourceType){
        case 'jira':
        case 'assets':
            return true;
        default:
            return defaultValue;
    }
};

});
parcelRegister("pvPHQ", function(module, exports) {
$parcel$export(module.exports, "getDatasourceType", () => $40f41d0b0adb755f$export$19af9860957ca153);

var $h3Rf3 = parcelRequire("h3Rf3");

var $hBRo4 = parcelRequire("hBRo4");

var $hVFFL = parcelRequire("hVFFL");
const $40f41d0b0adb755f$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $hVFFL.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $h3Rf3.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $hBRo4.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};

});
parcelRegister("h3Rf3", function(module, exports) {
$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $1f676615432cff2c$export$34a6fbdd67f09ff6);

var $hRFhM = parcelRequire("hRFhM");
const $1f676615432cff2c$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';
var $1f676615432cff2c$export$2e2bcd8739ae039 = (0, $hRFhM.AssetsConfigModalWithWrappers);

});
parcelRegister("hRFhM", function(module, exports) {
$parcel$export(module.exports, "AssetsConfigModalWithWrappers", () => $df61f0ad118612f0$export$22622bb648794f66);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

const $df61f0ad118612f0$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("fPzhI")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $df61f0ad118612f0$export$22622bb648794f66 = (props)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($df61f0ad118612f0$var$LazyAssetsConfigModal, {
            ...props
        })
    });
};

});
parcelRegister("fPzhI", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("61osU"),
    $9dnsd("f1jnr"),
    $9dnsd("ozcFp"),
    $9dnsd("eJhPz"),
    $9dnsd("84PLG"),
    $9dnsd("hsX8N")
]).then(()=>parcelRequire('adOHB'));

});



parcelRegister("hBRo4", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $3843dd933f98bcb0$export$d9788d6cf1867282);

var $kjSSU = parcelRequire("kjSSU");
const $3843dd933f98bcb0$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';
var $3843dd933f98bcb0$export$2e2bcd8739ae039 = (0, $kjSSU.ConfluenceSearchConfigModalWithWrappers);

});
parcelRegister("kjSSU", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSearchConfigModalWithWrappers", () => $29723191bc7cd4d2$export$354a4025961c00ab);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

const $29723191bc7cd4d2$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("7UgHJ")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $29723191bc7cd4d2$export$354a4025961c00ab = (props)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($29723191bc7cd4d2$var$LazyConfluenceSearchConfigModal, {
            ...props
        })
    });
};

});
parcelRegister("7UgHJ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("63pFs"),
    $9dnsd("61osU"),
    $9dnsd("f1jnr"),
    $9dnsd("ozcFp"),
    $9dnsd("eJhPz"),
    $9dnsd("84PLG"),
    $9dnsd("7t7an")
]).then(()=>parcelRequire('b1GcV'));

});



parcelRegister("hVFFL", function(module, exports) {
$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $d1fffb16109a5d03$export$8ce19958117ece5c);

var $dHhUZ = parcelRequire("dHhUZ");
const $d1fffb16109a5d03$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';
var $d1fffb16109a5d03$export$2e2bcd8739ae039 = (0, $dHhUZ.JiraIssuesConfigModalWithWrappers);

});
parcelRegister("dHhUZ", function(module, exports) {
$parcel$export(module.exports, "JiraIssuesConfigModalWithWrappers", () => $52ae5b49a18a0a21$export$1cd9f81ef4050ddb);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

const $52ae5b49a18a0a21$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("4JF3W")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $52ae5b49a18a0a21$export$1cd9f81ef4050ddb = (props)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-testid": 'jira-datasource-table-suspense'
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($52ae5b49a18a0a21$var$LazyJiraIssuesConfigModal, {
            ...props
        })
    });
};

});
parcelRegister("4JF3W", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("hUmQ8"),
    $9dnsd("ajrSe"),
    $9dnsd("7Xeve"),
    $9dnsd("g80ld"),
    $9dnsd("cFGPX"),
    $9dnsd("fzEMG"),
    $9dnsd("h7P8A"),
    $9dnsd("c5b2p"),
    $9dnsd("kaxju"),
    $9dnsd("ahVgH"),
    $9dnsd("6Df0C"),
    $9dnsd("fAWGE"),
    $9dnsd("63pFs"),
    $9dnsd("61osU"),
    $9dnsd("f1jnr"),
    $9dnsd("ozcFp"),
    $9dnsd("eJhPz"),
    $9dnsd("4enTb"),
    $9dnsd("5nsCa"),
    $9dnsd("84PLG"),
    $9dnsd("ft2Gr")
]).then(()=>parcelRequire('abMb3'));

});





parcelRegister("a0d3L", function(module, exports) {
$parcel$export(module.exports, "buildDatasourceAdf", () => $ae578d2d0cefac48$export$1de3504963fc32f2);
const $ae578d2d0cefac48$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};

});

parcelRegister("6mhwO", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE", () => $617aa86865be639a$export$5e074c0b68e2ce03);
$parcel$export(module.exports, "useDatasourceClientExtension", () => $617aa86865be639a$export$7d812bb756889442);

var $fc4bM = parcelRequire("fc4bM");

var $11Qwb = parcelRequire("11Qwb");

var $fnEFU = parcelRequire("fnEFU");

var $jBHs2 = parcelRequire("jBHs2");

var $lLy0h = parcelRequire("lLy0h");
const $617aa86865be639a$var$URL_RESPONSE_CACHE_SIZE = 50;
const $617aa86865be639a$export$f82fcd766a8daa7f = new (0, $11Qwb.LRUMap)($617aa86865be639a$var$URL_RESPONSE_CACHE_SIZE);
const $617aa86865be639a$export$40b1dd31340bd5c2 = new (0, $11Qwb.LRUMap)($617aa86865be639a$var$URL_RESPONSE_CACHE_SIZE);
const $617aa86865be639a$export$15cd58682efec5a5 = new (0, $11Qwb.LRUMap)($617aa86865be639a$var$URL_RESPONSE_CACHE_SIZE);
const $617aa86865be639a$export$5e074c0b68e2ce03 = 20;
const $617aa86865be639a$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $fnEFU.useSmartLinkContext)();
    const resolverUrl = (0, $lLy0h.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
       * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
       * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $jBHs2.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $jBHs2.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $fc4bM.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $617aa86865be639a$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $fc4bM.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $617aa86865be639a$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $fc4bM.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $617aa86865be639a$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $fc4bM.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $fc4bM.useCallback)((ari)=>{
        $617aa86865be639a$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                var _item$ari;
                return ((_item$ari = item['ari']) === null || _item$ari === void 0 ? void 0 : _item$ari.data) === ari;
            });
            if (targetFound) $617aa86865be639a$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $fc4bM.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};

});

parcelRegister("c7F99", function(module, exports) {
$parcel$export(module.exports, "mergeStyles", () => $ed8f11c0494948b8$export$e618dc39ac9ad607);
function $ed8f11c0494948b8$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("5m5hr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1dc8de20280b4683a2b844103e1b1c5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e631a60ef7154cb$var$_react = $3e631a60ef7154cb$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $3e631a60ef7154cb$var$_iconNew = $3e631a60ef7154cb$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $3e631a60ef7154cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-columns-distribute
 * Usage guidance:
 * Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e631a60ef7154cb$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $3e631a60ef7154cb$var$_react.default.createElement($3e631a60ef7154cb$var$_iconNew.default, Object.assign({
        name: "TableColumnsDistributeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$3e631a60ef7154cb$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $3e631a60ef7154cb$var$_default = module.exports.default = $3e631a60ef7154cb$var$TableColumnsDistributeIcon;

});

parcelRegister("k33Yd", function(module, exports) {
$parcel$export(module.exports, "DropIndicator", () => $f784a20838a6f95a$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $f784a20838a6f95a$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $kWsCQ = parcelRequire("kWsCQ");

var $5x3Je = parcelRequire("5x3Je");
function $f784a20838a6f95a$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kWsCQ.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $5x3Je.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f784a20838a6f95a$export$2e2bcd8739ae039 = $f784a20838a6f95a$export$62ed72bc21f6b8a6;

});
parcelRegister("kWsCQ", function(module, exports) {
$parcel$export(module.exports, "Line", () => $fde5f257e3422859$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $5x3Je = parcelRequire("5x3Je");
const $fde5f257e3422859$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $fde5f257e3422859$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $fde5f257e3422859$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $fde5f257e3422859$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $fde5f257e3422859$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $fde5f257e3422859$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $5x3Je.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $5x3Je.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $fde5f257e3422859$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $fde5f257e3422859$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $2R2iS.default)([
            $fde5f257e3422859$var$baseStyles.root,
            $fde5f257e3422859$var$orientationStyles[orientation],
            $fde5f257e3422859$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$fde5f257e3422859$export$2e2bcd8739ae039 = $fde5f257e3422859$export$17d680238e50603e;

});
parcelRegister("5x3Je", function(module, exports) {
$parcel$export(module.exports, "presetStrokeColors", () => $507a8372a6de2f1c$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $507a8372a6de2f1c$export$45db03aa04b685e3);
const $507a8372a6de2f1c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $507a8372a6de2f1c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";

});



parcelRegister("cyTA8", function(module, exports) {
$parcel$export(module.exports, "default", () => $9253c66c30459281$export$2e2bcd8739ae039);

var $1Cu8A = parcelRequire("1Cu8A");

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $9253c66c30459281$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3mokv.default)(2, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var amount = (0, $1Cu8A.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("eABs0", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9f17a6512c422fa$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $a9f17a6512c422fa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("hVmok", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0c920fcd00d0769$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $eABs0 = parcelRequire("eABs0");

var $aeCvE = parcelRequire("aeCvE");

var $3mokv = parcelRequire("3mokv");
function $d0c920fcd00d0769$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    return (0, $eABs0.default)(date).getTime() === (0, $aeCvE.default)(date).getTime();
}

});
parcelRegister("aeCvE", function(module, exports) {
$parcel$export(module.exports, "default", () => $77391561c0a8dc78$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $77391561c0a8dc78$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});


parcelRegister("9IWSx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7145e52b659ebb66$export$2e2bcd8739ae039);

var $lQxpB = parcelRequire("lQxpB");

var $3mokv = parcelRequire("3mokv");
function $7145e52b659ebb66$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3mokv.default)(2, arguments);
    var dateLeftStartOfDay = (0, $lQxpB.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $lQxpB.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("7pUBR", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkDestinationUrl", () => $ba174d1476e568cc$export$30500dfe8339eafd);

var $jQwFa = parcelRequire("jQwFa");

var $fzYCU = parcelRequire("fzYCU");

var $jpYbX = parcelRequire("jpYbX");
/**
 * Returns the resolved destination URL for a Smart Link, with cross-product analytics
 * parameters appended when applicable.
 *
 * This is the same URL that SmartCard would navigate to when clicked. Use this as an `href`
 * wherever you render a link to a Smart Link URL outside of the SmartCard component itself
 * (e.g. toolbar buttons, overlays).
 *
 * Falls back to the raw `url` when:
 * - The link has not yet resolved
 * - The link is not a first-party Atlassian link
 *
 * @example
 * const href = useSmartLinkDestinationUrl(url);
 *
 * Use as <a href={href} target="_blank">Open link</a>
 */ const $ba174d1476e568cc$export$30500dfe8339eafd = (url)=>{
    const state = (0, $fzYCU.useSmartCardState)(url);
    const appendCrossProductAnalyticsParams = (0, $jpYbX.useSmartLinkCrossProductUrlWrapper)({
        details: state.details
    });
    const resolvedUrl = (0, $jQwFa.getClickUrl)(url, state.details);
    return appendCrossProductAnalyticsParams(resolvedUrl);
};

});

parcelRegister("cHfbF", function(module, exports) {
$parcel$export(module.exports, "default", () => $000fc5a9e2977003$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cWkQ8 = parcelRequire("cWkQ8");

var $hYnqX = parcelRequire("hYnqX");

var $PH0Je = parcelRequire("PH0Je");
const $000fc5a9e2977003$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $000fc5a9e2977003$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
function $000fc5a9e2977003$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $cWkQ8.default), {
        ...props,
        appearance: "square",
        size: size,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hYnqX.AvatarContent), {
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $PH0Je.TeamAvatarImage), {
                src: src,
                testId: testId,
                teamId: teamId
            }, teamId)
        })
    });
}

});
parcelRegister("PH0Je", function(module, exports) {
$parcel$export(module.exports, "TeamAvatarImage", () => $9e1fe255230e4670$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");

var $bOORM = parcelRequire("bOORM");

var $6Q2aV = parcelRequire("6Q2aV");
const $9e1fe255230e4670$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $9e1fe255230e4670$export$ac3673635a5387be = ({ alt: alt = '', src: src, testId: testId, teamId: teamId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $fc4bM.useState)(false);
    const avatarSrc = (0, $6Q2aV.getTeamAvatarSrc)(src, teamId);
    const resolvedSrc = hasImageErrored ? (0, $bOORM.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        as: "img",
        src: resolvedSrc,
        alt: alt,
        testId: testId && `${testId}--image`,
        xcss: $9e1fe255230e4670$var$avatarImageStyles.image,
        onError: ()=>setHasImageErrored(true)
    });
};

});
parcelRegister("bOORM", function(module, exports) {
$parcel$export(module.exports, "TEAM_FALLBACK_AVATAR_DATA_URI", () => $23ddc739d1057e4c$export$215bd25cfab1a96);
const $23ddc739d1057e4c$export$215bd25cfab1a96 = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2032_552)">
<rect width="32" height="32" rx="4" fill="#DCDFE4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z" fill="#44546F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z" fill="#44546F"/>
<path d="M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z" fill="#44546F"/>
<path d="M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z" fill="#44546F"/>
</g>
<defs>
<clipPath id="clip0_2032_552">
<rect width="32" height="32" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>`)}`;

});

parcelRegister("6Q2aV", function(module, exports) {
$parcel$export(module.exports, "getTeamAvatarSrc", () => $3f53a76117f238d5$export$59ff7d19feb890b6);

var $bOORM = parcelRequire("bOORM");
function $3f53a76117f238d5$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return 0, $bOORM.TEAM_FALLBACK_AVATAR_DATA_URI;
}

});



parcelRegister("7MNh1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdcfaadd200b1558cd21a6be22e04743>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ab33cce72de74fe$var$_react = $5ab33cce72de74fe$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5ab33cce72de74fe$var$_iconNew = $5ab33cce72de74fe$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5ab33cce72de74fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/calendar
 * Usage guidance:
 * Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ab33cce72de74fe$var$CalendarIcon = (props)=>/*#__PURE__*/ $5ab33cce72de74fe$var$_react.default.createElement($5ab33cce72de74fe$var$_iconNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$5ab33cce72de74fe$var$CalendarIcon.displayName = 'CalendarIcon';
var $5ab33cce72de74fe$var$_default = module.exports.default = $5ab33cce72de74fe$var$CalendarIcon;

});

parcelRegister("gn6xt", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $2e2a2824ec184343$export$ea56ca58f08ffa52);

var $giS2p = parcelRequire("giS2p");

var $2Ptbb = parcelRequire("2Ptbb");

var $9InEt = parcelRequire("9InEt");

var $4aOGO = parcelRequire("4aOGO");
const $2e2a2824ec184343$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $giS2p.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>getDays(weekStartDay, 'short');
    const getDaysLong = (weekStartDay = 0)=>getDays(weekStartDay, 'long');
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $2Ptbb.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $4aOGO.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $4aOGO.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    let intlLocale;
    const getFirstDayOfWeek = ()=>{
        if (!intlLocale) intlLocale = new Intl.Locale(normalizedLocale);
        const weekInfo = (0, $9InEt.getWeekInfo)(intlLocale);
        // Intl uses ISO weekdays (1 = Monday … 7 = Sunday).
        // Calendar / getDays* use JS weekdays (0 = Sunday … 6 = Saturday).
        return weekInfo.firstDay % 7;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts,
        getFirstDayOfWeek: getFirstDayOfWeek
    };
};

});
parcelRegister("giS2p", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $8eb7b2bbcf5cf884$export$dca0327c9b9c6498);
const $8eb7b2bbcf5cf884$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("2Ptbb", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $0cdb83868f288f2e$export$cfa2ef2687faeda2);

var $giS2p = parcelRequire("giS2p");

var $6fF4j = parcelRequire("6fF4j");

var $jKEYW = parcelRequire("jKEYW");

var $iUEzZ = parcelRequire("iUEzZ");
const $0cdb83868f288f2e$var$INVALID_DATE = new Date(NaN);
const $0cdb83868f288f2e$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $0cdb83868f288f2e$var$INVARIANT_DATE = (0, $iUEzZ.toDate)($0cdb83868f288f2e$var$INVARIANT);
const $0cdb83868f288f2e$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $0cdb83868f288f2e$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $0cdb83868f288f2e$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $0cdb83868f288f2e$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $0cdb83868f288f2e$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $giS2p.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($0cdb83868f288f2e$var$INVARIANT_DATE);
    const shortDate = $0cdb83868f288f2e$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($0cdb83868f288f2e$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $0cdb83868f288f2e$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($0cdb83868f288f2e$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($0cdb83868f288f2e$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($0cdb83868f288f2e$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $0cdb83868f288f2e$var$stripExtras(date).match($0cdb83868f288f2e$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $0cdb83868f288f2e$var$INVALID_DATE;
        const dateParts = $0cdb83868f288f2e$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $jKEYW.normalizeDate)(extractedDate, options === null || options === void 0 ? void 0 : options.defaultFirstDay);
        if (!(0, $6fF4j.isValid)(normalizedDate)) return $0cdb83868f288f2e$var$INVALID_DATE;
        return (0, $iUEzZ.toDate)(normalizedDate);
    };
};

});
parcelRegister("6fF4j", function(module, exports) {
$parcel$export(module.exports, "isValid", () => $82f301c46db7f11b$export$1ea939691cdc45b8);

var $8sMJq = parcelRequire("8sMJq");
const $82f301c46db7f11b$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $8sMJq.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};

});
parcelRegister("8sMJq", function(module, exports) {
$parcel$export(module.exports, "getDaysInMonth", () => $b3994bc6db0451e5$export$f645ddd439eb259d);

var $4YZt3 = parcelRequire("4YZt3");
const $b3994bc6db0451e5$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $4YZt3.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};

});
parcelRegister("4YZt3", function(module, exports) {
$parcel$export(module.exports, "isLeapYear", () => $14555d0110362eff$export$553d7fa8e3805fc0);
const $14555d0110362eff$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};

});



parcelRegister("jKEYW", function(module, exports) {
$parcel$export(module.exports, "normalizeDate", () => $b9bb7983fe86168c$export$fcc71269590ba0a8);

var $908Ua = parcelRequire("908Ua");
const $b9bb7983fe86168c$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $908Ua.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});
parcelRegister("908Ua", function(module, exports) {
$parcel$export(module.exports, "toDateObj", () => $2d135357ba282a2b$export$abe96da78d4f59dd);
const $2d135357ba282a2b$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });

});


parcelRegister("iUEzZ", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $3fc8eca55b25ea72$export$e67a095c620b86fe);
const $3fc8eca55b25ea72$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);

});


parcelRegister("9InEt", function(module, exports) {
$parcel$export(module.exports, "getWeekInfo", () => $d0a68b319572b3d5$export$837830ce0c77272);
// Regional exceptions from Unicode CLDR 48; all other regions use Monday.
// https://github.com/unicode-org/cldr-json/blob/48.0.0/cldr-json/cldr-core/supplemental/weekData.json
const $d0a68b319572b3d5$var$firstDays = {
    AF: 6,
    AG: 7,
    AS: 7,
    BD: 7,
    BH: 6,
    BR: 7,
    BS: 7,
    BT: 7,
    BW: 7,
    BZ: 7,
    CA: 7,
    CO: 7,
    DJ: 6,
    DM: 7,
    DO: 7,
    DZ: 6,
    EG: 6,
    ET: 7,
    GT: 7,
    GU: 7,
    HK: 7,
    HN: 7,
    ID: 7,
    IL: 7,
    IN: 7,
    IQ: 6,
    IR: 6,
    IS: 7,
    JM: 7,
    JO: 6,
    JP: 7,
    KE: 7,
    KH: 7,
    KR: 7,
    KW: 6,
    LA: 7,
    LY: 6,
    MH: 7,
    MM: 7,
    MO: 7,
    MT: 7,
    MV: 5,
    MX: 7,
    MZ: 7,
    NI: 7,
    NP: 7,
    OM: 6,
    PA: 7,
    PE: 7,
    PH: 7,
    PK: 7,
    PR: 7,
    PT: 7,
    PY: 7,
    QA: 6,
    SA: 7,
    SD: 6,
    SG: 7,
    SV: 7,
    SY: 6,
    TH: 7,
    TT: 7,
    TW: 7,
    UM: 7,
    US: 7,
    VE: 7,
    VI: 7,
    WS: 7,
    YE: 7,
    ZA: 7,
    ZW: 7
};
// Only regular territories may override a locale's region (CLDR 48 region validity data).
// https://github.com/unicode-org/cldr/blob/release-48/common/validity/region.xml
const $d0a68b319572b3d5$var$regularRegions = new Set([
    'AC AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF',
    'BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH',
    'CI CK CL CM CN CO CP CQ CR CU CV CW CX CY CZ DE DG DJ DK DM DO DZ',
    'EA EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI',
    'GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU IC ID IE IL IM',
    'IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA',
    'LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO',
    'MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU',
    'NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW',
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TA',
    'TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ',
    'VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
].join(' ').split(' '));
// Read only Unicode keywords, excluding other extensions and private-use subtags.
const $d0a68b319572b3d5$var$getUnicodeKeyword = (locale, key)=>{
    const extensions = locale.toString().split('-');
    const start = extensions.indexOf('u');
    const privateUse = extensions.indexOf('x');
    if (start === -1 || privateUse !== -1 && privateUse < start) return undefined;
    for(let index = start + 1; index < extensions.length; index++){
        if (extensions[index].length === 1) break;
        if (extensions[index] === key) {
            const value = [];
            while(((_extensions = extensions[index + 1]) === null || _extensions === void 0 ? void 0 : _extensions.length) > 2){
                var _extensions;
                value.push(extensions[++index]);
            }
            return value.join('-');
        }
    }
    return undefined;
};
// Canonicalize aliases before rejecting unknown, private-use, and macroregion overrides.
const $d0a68b319572b3d5$var$getOverrideRegion = (value)=>{
    if (!value) return undefined;
    const region = new Intl.Locale(`und-${value}`).region;
    return region && $d0a68b319572b3d5$var$regularRegions.has(region) ? region : undefined;
};
const $d0a68b319572b3d5$export$837830ce0c77272 = (locale)=>{
    var _getUnicodeKeyword, _getUnicodeKeyword2;
    if (typeof locale.getWeekInfo === 'function') return locale.getWeekInfo();
    const legacyWeekInfo = locale.weekInfo;
    if (legacyWeekInfo) return legacyWeekInfo;
    const regionOverride = $d0a68b319572b3d5$var$getOverrideRegion((_getUnicodeKeyword = $d0a68b319572b3d5$var$getUnicodeKeyword(locale, 'rg')) === null || _getUnicodeKeyword === void 0 || (_getUnicodeKeyword = _getUnicodeKeyword.match(/^([a-z]{2}|[0-9]{3})zzzz$/)) === null || _getUnicodeKeyword === void 0 ? void 0 : _getUnicodeKeyword[1]);
    const subdivision = $d0a68b319572b3d5$var$getOverrideRegion((_getUnicodeKeyword2 = $d0a68b319572b3d5$var$getUnicodeKeyword(locale, 'sd')) === null || _getUnicodeKeyword2 === void 0 || (_getUnicodeKeyword2 = _getUnicodeKeyword2.match(/^([a-z]{2}|[0-9]{3})[a-z0-9]+$/)) === null || _getUnicodeKeyword2 === void 0 ? void 0 : _getUnicodeKeyword2[1]);
    const region = regionOverride || locale.region || subdivision || locale.maximize().region || '001';
    const preferredDay = [
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
        'sun'
    ].indexOf($d0a68b319572b3d5$var$getUnicodeKeyword(locale, 'fw') || '');
    const firstDay = preferredDay !== -1 ? preferredDay + 1 : !regionOverride && locale.calendar === 'iso8601' ? 1 : $d0a68b319572b3d5$var$firstDays[region] || 1;
    return {
        firstDay: firstDay
    };
};

});

parcelRegister("4aOGO", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $7376652f26b3db2c$export$9b7ca29af37c192);
const $7376652f26b3db2c$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("9ovHK", function(module, exports) {
'use strict';

var $6d6ef2d3c0dcb8da$var$hasToStringTag = (parcelRequire("45wf7"))();

var $2uFpc = parcelRequire("2uFpc");
var $6d6ef2d3c0dcb8da$var$$toString = $2uFpc('Object.prototype.toString');
var $6d6ef2d3c0dcb8da$var$isStandardArguments = function isArguments(value) {
    if ($6d6ef2d3c0dcb8da$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $6d6ef2d3c0dcb8da$var$$toString(value) === '[object Arguments]';
};
var $6d6ef2d3c0dcb8da$var$isLegacyArguments = function isArguments(value) {
    if ($6d6ef2d3c0dcb8da$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6d6ef2d3c0dcb8da$var$$toString(value) !== '[object Array]' && $6d6ef2d3c0dcb8da$var$$toString(value.callee) === '[object Function]';
};
var $6d6ef2d3c0dcb8da$var$supportsStandardArguments = function() {
    return $6d6ef2d3c0dcb8da$var$isStandardArguments(arguments);
}();
$6d6ef2d3c0dcb8da$var$isStandardArguments.isLegacyArguments = $6d6ef2d3c0dcb8da$var$isLegacyArguments; // for tests
module.exports = $6d6ef2d3c0dcb8da$var$supportsStandardArguments ? $6d6ef2d3c0dcb8da$var$isStandardArguments : $6d6ef2d3c0dcb8da$var$isLegacyArguments;

});
parcelRegister("45wf7", function(module, exports) {
'use strict';

var $4bQ3t = parcelRequire("4bQ3t");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $4bQ3t() && !!Symbol.toStringTag;
};

});

parcelRegister("2uFpc", function(module, exports) {
'use strict';

var $irjph = parcelRequire("irjph");

var $hHjoO = parcelRequire("hHjoO");
var $1d0e805fb51dedbd$var$$indexOf = $hHjoO($irjph('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $irjph(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $1d0e805fb51dedbd$var$$indexOf(name, '.prototype.') > -1) return $hHjoO(intrinsic);
    return intrinsic;
};

});
parcelRegister("hHjoO", function(module, exports) {
'use strict';

var $9ZdfT = parcelRequire("9ZdfT");

var $khfLq = parcelRequire("khfLq");

var $9IoLQ = parcelRequire("9IoLQ");

var $lJWeb = parcelRequire("lJWeb");
module.exports = function callBind(originalFunction) {
    var func = $9IoLQ(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $9ZdfT(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($khfLq) $khfLq(module.exports, 'apply', {
    value: $lJWeb
});
else module.exports.apply = $lJWeb;

});
parcelRegister("9ZdfT", function(module, exports) {
'use strict';

var $irjph = parcelRequire("irjph");

var $deSEJ = parcelRequire("deSEJ");

var $745417cfba0e3056$var$hasDescriptors = (parcelRequire("5LSCB"))();

var $hUGkq = parcelRequire("hUGkq");

var $j5K2T = parcelRequire("j5K2T");
var $745417cfba0e3056$var$$floor = $irjph('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $j5K2T('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $745417cfba0e3056$var$$floor(length) !== length) throw new $j5K2T('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $hUGkq) {
        var desc = $hUGkq(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($745417cfba0e3056$var$hasDescriptors) $deSEJ(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $deSEJ(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("deSEJ", function(module, exports) {
'use strict';

var $khfLq = parcelRequire("khfLq");

var $7eMIZ = parcelRequire("7eMIZ");

var $j5K2T = parcelRequire("j5K2T");

var $hUGkq = parcelRequire("hUGkq");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $j5K2T('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $j5K2T('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $j5K2T('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $j5K2T('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $j5K2T('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $j5K2T('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$hUGkq && $hUGkq(obj, property);
    if ($khfLq) $khfLq(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $7eMIZ('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("5LSCB", function(module, exports) {
'use strict';

var $khfLq = parcelRequire("khfLq");
var $433bb64006fb3da3$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$khfLq;
};
$433bb64006fb3da3$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$khfLq) return null;
    try {
        return $khfLq([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $433bb64006fb3da3$var$hasPropertyDescriptors;

});


parcelRegister("lJWeb", function(module, exports) {
'use strict';

var $atY7R = parcelRequire("atY7R");

var $chjTq = parcelRequire("chjTq");

var $8O3dv = parcelRequire("8O3dv");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $8O3dv($atY7R, $chjTq, arguments);
};

});




parcelRegister("kLzN4", function(module, exports) {
'use strict';

var $bsi7A = parcelRequire("bsi7A");

var $efurh = parcelRequire("efurh");

var $hHjoO = parcelRequire("hHjoO");

var $lBruB = parcelRequire("lBruB");

var $hUGkq = parcelRequire("hUGkq");

var $8Dp7G = parcelRequire("8Dp7G");
var $f1e3f5aff02404b2$var$$toString = $lBruB('Object.prototype.toString');

var $f1e3f5aff02404b2$var$hasToStringTag = (parcelRequire("45wf7"))();
var $f1e3f5aff02404b2$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $f1e3f5aff02404b2$var$typedArrays = $efurh();
var $f1e3f5aff02404b2$var$$slice = $lBruB('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $f1e3f5aff02404b2$var$$indexOf = $lBruB('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $f1e3f5aff02404b2$var$cache = {
    __proto__: null
};
if ($f1e3f5aff02404b2$var$hasToStringTag && $hUGkq && $8Dp7G) $bsi7A($f1e3f5aff02404b2$var$typedArrays, function(typedArray) {
    var arr = new $f1e3f5aff02404b2$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $8Dp7G) {
        var proto = $8Dp7G(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $hUGkq(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $8Dp7G(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $hUGkq(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $f1e3f5aff02404b2$var$cache['$' + typedArray] = $hHjoO(descriptor.get);
    }
});
else $bsi7A($f1e3f5aff02404b2$var$typedArrays, function(typedArray) {
    var arr = new $f1e3f5aff02404b2$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $f1e3f5aff02404b2$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $hHjoO(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $f1e3f5aff02404b2$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $bsi7A(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $f1e3f5aff02404b2$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $f1e3f5aff02404b2$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $f1e3f5aff02404b2$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $bsi7A(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $f1e3f5aff02404b2$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $f1e3f5aff02404b2$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$f1e3f5aff02404b2$var$hasToStringTag) {
        /** @type {string} */ var tag = $f1e3f5aff02404b2$var$$slice($f1e3f5aff02404b2$var$$toString(value), 8, -1);
        if ($f1e3f5aff02404b2$var$$indexOf($f1e3f5aff02404b2$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $f1e3f5aff02404b2$var$trySlices(value);
    }
    if (!$hUGkq) return null;
     // unknown engine
    return $f1e3f5aff02404b2$var$tryTypedArrays(value);
};

});
parcelRegister("bsi7A", function(module, exports) {
'use strict';

var $6DZae = parcelRequire("6DZae");
var $85705dc82da2ff64$var$toStr = Object.prototype.toString;
var $85705dc82da2ff64$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $85705dc82da2ff64$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($85705dc82da2ff64$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $85705dc82da2ff64$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $85705dc82da2ff64$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($85705dc82da2ff64$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $85705dc82da2ff64$var$isArray(x) {
    return $85705dc82da2ff64$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$6DZae(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($85705dc82da2ff64$var$isArray(list)) $85705dc82da2ff64$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $85705dc82da2ff64$var$forEachString(list, iterator, receiver);
    else $85705dc82da2ff64$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("6DZae", function(module, exports) {
'use strict';
var $4d65d4793317cd2d$var$fnToStr = Function.prototype.toString;
var $4d65d4793317cd2d$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $4d65d4793317cd2d$var$badArrayLike;
var $4d65d4793317cd2d$var$isCallableMarker;
if (typeof $4d65d4793317cd2d$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $4d65d4793317cd2d$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $4d65d4793317cd2d$var$isCallableMarker;
        }
    });
    $4d65d4793317cd2d$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $4d65d4793317cd2d$var$reflectApply(function() {
        throw 42;
    }, null, $4d65d4793317cd2d$var$badArrayLike);
} catch (_) {
    if (_ !== $4d65d4793317cd2d$var$isCallableMarker) $4d65d4793317cd2d$var$reflectApply = null;
}
else $4d65d4793317cd2d$var$reflectApply = null;
var $4d65d4793317cd2d$var$constructorRegex = /^\s*class\b/;
var $4d65d4793317cd2d$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $4d65d4793317cd2d$var$fnToStr.call(value);
        return $4d65d4793317cd2d$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $4d65d4793317cd2d$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($4d65d4793317cd2d$var$isES6ClassFn(value)) return false;
        $4d65d4793317cd2d$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $4d65d4793317cd2d$var$toStr = Object.prototype.toString;
var $4d65d4793317cd2d$var$objectClass = '[object Object]';
var $4d65d4793317cd2d$var$fnClass = '[object Function]';
var $4d65d4793317cd2d$var$genClass = '[object GeneratorFunction]';
var $4d65d4793317cd2d$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $4d65d4793317cd2d$var$ddaClass2 = '[object HTML document.all class]';
var $4d65d4793317cd2d$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $4d65d4793317cd2d$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $4d65d4793317cd2d$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $4d65d4793317cd2d$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $4d65d4793317cd2d$var$all = document.all;
    if ($4d65d4793317cd2d$var$toStr.call($4d65d4793317cd2d$var$all) === $4d65d4793317cd2d$var$toStr.call(document.all)) $4d65d4793317cd2d$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($4d65d4793317cd2d$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $4d65d4793317cd2d$var$toStr.call(value);
            return (str === $4d65d4793317cd2d$var$ddaClass || str === $4d65d4793317cd2d$var$ddaClass2 || str === $4d65d4793317cd2d$var$ddaClass3 // opera 12.16
             || str === $4d65d4793317cd2d$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $4d65d4793317cd2d$var$reflectApply ? function isCallable(value) {
    if ($4d65d4793317cd2d$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $4d65d4793317cd2d$var$reflectApply(value, null, $4d65d4793317cd2d$var$badArrayLike);
    } catch (e) {
        if (e !== $4d65d4793317cd2d$var$isCallableMarker) return false;
    }
    return !$4d65d4793317cd2d$var$isES6ClassFn(value) && $4d65d4793317cd2d$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($4d65d4793317cd2d$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($4d65d4793317cd2d$var$hasToStringTag) return $4d65d4793317cd2d$var$tryFunctionObject(value);
    if ($4d65d4793317cd2d$var$isES6ClassFn(value)) return false;
    var strClass = $4d65d4793317cd2d$var$toStr.call(value);
    if (strClass !== $4d65d4793317cd2d$var$fnClass && strClass !== $4d65d4793317cd2d$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $4d65d4793317cd2d$var$tryFunctionObject(value);
};

});


parcelRegister("efurh", function(module, exports) {
'use strict';

var $35K11 = parcelRequire("35K11");
var $a5fa13f8f883c2c4$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $35K11.length; i++)if (typeof $a5fa13f8f883c2c4$var$g[$35K11[i]] === 'function') // @ts-expect-error
    out[out.length] = $35K11[i];
    return out;
};

});
parcelRegister("35K11", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});



parcelRegister("85mLv", function(module, exports) {
'use strict';

var $kLzN4 = parcelRequire("kLzN4");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$kLzN4(value);
};

});

parcelRegister("eI8DB", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("9Hrjb", function(module, exports) {
'use strict';
var $70fd50140c1f9eed$var$slice = Array.prototype.slice;

var $mATlC = parcelRequire("mATlC");
var $70fd50140c1f9eed$var$origKeys = Object.keys;

var $70fd50140c1f9eed$var$keysShim = $70fd50140c1f9eed$var$origKeys ? function keys(o) {
    return $70fd50140c1f9eed$var$origKeys(o);
} : (parcelRequire("2bsK2"));
var $70fd50140c1f9eed$var$originalKeys = Object.keys;
$70fd50140c1f9eed$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($mATlC(object)) return $70fd50140c1f9eed$var$originalKeys($70fd50140c1f9eed$var$slice.call(object));
            return $70fd50140c1f9eed$var$originalKeys(object);
        };
    } else Object.keys = $70fd50140c1f9eed$var$keysShim;
    return Object.keys || $70fd50140c1f9eed$var$keysShim;
};
module.exports = $70fd50140c1f9eed$var$keysShim;

});
parcelRegister("mATlC", function(module, exports) {
'use strict';
var $043eac1cf5f7924d$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $043eac1cf5f7924d$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $043eac1cf5f7924d$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("2bsK2", function(module, exports) {
'use strict';
var $1972e750d1fe8d91$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $1972e750d1fe8d91$var$has = Object.prototype.hasOwnProperty;
    var $1972e750d1fe8d91$var$toStr = Object.prototype.toString;
    var $1972e750d1fe8d91$var$isArgs = (parcelRequire("mATlC")); // eslint-disable-line global-require
    var $1972e750d1fe8d91$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $1972e750d1fe8d91$var$hasDontEnumBug = !$1972e750d1fe8d91$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $1972e750d1fe8d91$var$hasProtoEnumBug = $1972e750d1fe8d91$var$isEnumerable.call(function() {}, 'prototype');
    var $1972e750d1fe8d91$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $1972e750d1fe8d91$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $1972e750d1fe8d91$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $1972e750d1fe8d91$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$1972e750d1fe8d91$var$excludedKeys['$' + k] && $1972e750d1fe8d91$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $1972e750d1fe8d91$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $1972e750d1fe8d91$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$1972e750d1fe8d91$var$hasAutomationEqualityBug) return $1972e750d1fe8d91$var$equalsConstructorPrototype(o);
        try {
            return $1972e750d1fe8d91$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $1972e750d1fe8d91$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $1972e750d1fe8d91$var$toStr.call(object) === '[object Function]';
        var isArguments = $1972e750d1fe8d91$var$isArgs(object);
        var isString = isObject && $1972e750d1fe8d91$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $1972e750d1fe8d91$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$1972e750d1fe8d91$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $1972e750d1fe8d91$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($1972e750d1fe8d91$var$hasDontEnumBug) {
            var skipConstructor = $1972e750d1fe8d91$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $1972e750d1fe8d91$var$dontEnums.length; ++k)if (!(skipConstructor && $1972e750d1fe8d91$var$dontEnums[k] === 'constructor') && $1972e750d1fe8d91$var$has.call(object, $1972e750d1fe8d91$var$dontEnums[k])) theKeys.push($1972e750d1fe8d91$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $1972e750d1fe8d91$var$keysShim;

});


parcelRegister("aD995", function(module, exports) {
'use strict';

var $eJotx = parcelRequire("eJotx");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $eJotx;
};

});
parcelRegister("eJotx", function(module, exports) {
'use strict';
var $ab9840f1f3eb7527$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($ab9840f1f3eb7527$var$numberIsNaN(a) && $ab9840f1f3eb7527$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("kG4IP", function(module, exports) {
'use strict';

var $fX8oU = parcelRequire("fX8oU");

var $hHjoO = parcelRequire("hHjoO");

var $eJotx = parcelRequire("eJotx");

var $aD995 = parcelRequire("aD995");

var $49olW = parcelRequire("49olW");
var $f0db6497eec495ae$var$polyfill = $hHjoO($aD995(), Object);
$fX8oU($f0db6497eec495ae$var$polyfill, {
    getPolyfill: $aD995,
    implementation: $eJotx,
    shim: $49olW
});
module.exports = $f0db6497eec495ae$var$polyfill;

});
parcelRegister("fX8oU", function(module, exports) {
'use strict';

var $9Hrjb = parcelRequire("9Hrjb");
var $b9d2e1ea44431dd7$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $b9d2e1ea44431dd7$var$toStr = Object.prototype.toString;
var $b9d2e1ea44431dd7$var$concat = Array.prototype.concat;

var $deSEJ = parcelRequire("deSEJ");
var $b9d2e1ea44431dd7$var$isFunction = function(fn) {
    return typeof fn === 'function' && $b9d2e1ea44431dd7$var$toStr.call(fn) === '[object Function]';
};

var $b9d2e1ea44431dd7$var$supportsDescriptors = (parcelRequire("5LSCB"))();
var $b9d2e1ea44431dd7$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$b9d2e1ea44431dd7$var$isFunction(predicate) || !predicate()) return;
    }
    if ($b9d2e1ea44431dd7$var$supportsDescriptors) $deSEJ(object, name, value, true);
    else $deSEJ(object, name, value);
};
var $b9d2e1ea44431dd7$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $9Hrjb(map);
    if ($b9d2e1ea44431dd7$var$hasSymbols) props = $b9d2e1ea44431dd7$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$b9d2e1ea44431dd7$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$b9d2e1ea44431dd7$var$defineProperties.supportsDescriptors = !!$b9d2e1ea44431dd7$var$supportsDescriptors;
module.exports = $b9d2e1ea44431dd7$var$defineProperties;

});

parcelRegister("49olW", function(module, exports) {
'use strict';

var $aD995 = parcelRequire("aD995");

var $fX8oU = parcelRequire("fX8oU");
module.exports = function shimObjectIs() {
    var polyfill = $aD995();
    $fX8oU(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("hLBpb", function(module, exports) {
$parcel$export(module.exports, "base", () => $cef3d75a620c50a1$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $cef3d75a620c50a1$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $cef3d75a620c50a1$export$fb33aafd75404f4c);
var $cef3d75a620c50a1$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $cef3d75a620c50a1$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $cef3d75a620c50a1$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $cef3d75a620c50a1$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $cef3d75a620c50a1$var$i = 0; $cef3d75a620c50a1$var$i < 10; $cef3d75a620c50a1$var$i++)$cef3d75a620c50a1$export$e2253033e6e1df16[48 + $cef3d75a620c50a1$var$i] = $cef3d75a620c50a1$export$e2253033e6e1df16[96 + $cef3d75a620c50a1$var$i] = String($cef3d75a620c50a1$var$i);
// The function keys
for(var $cef3d75a620c50a1$var$i = 1; $cef3d75a620c50a1$var$i <= 24; $cef3d75a620c50a1$var$i++)$cef3d75a620c50a1$export$e2253033e6e1df16[$cef3d75a620c50a1$var$i + 111] = "F" + $cef3d75a620c50a1$var$i;
// And the alphabetic keys
for(var $cef3d75a620c50a1$var$i = 65; $cef3d75a620c50a1$var$i <= 90; $cef3d75a620c50a1$var$i++){
    $cef3d75a620c50a1$export$e2253033e6e1df16[$cef3d75a620c50a1$var$i] = String.fromCharCode($cef3d75a620c50a1$var$i + 32);
    $cef3d75a620c50a1$export$fba63a578e423eb[$cef3d75a620c50a1$var$i] = String.fromCharCode($cef3d75a620c50a1$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $cef3d75a620c50a1$var$code in $cef3d75a620c50a1$export$e2253033e6e1df16)if (!$cef3d75a620c50a1$export$fba63a578e423eb.hasOwnProperty($cef3d75a620c50a1$var$code)) $cef3d75a620c50a1$export$fba63a578e423eb[$cef3d75a620c50a1$var$code] = $cef3d75a620c50a1$export$e2253033e6e1df16[$cef3d75a620c50a1$var$code];
function $cef3d75a620c50a1$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $cef3d75a620c50a1$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $cef3d75a620c50a1$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $cef3d75a620c50a1$export$fba63a578e423eb : $cef3d75a620c50a1$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});

parcelRegister("dm6Jy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15752cbf5c5b8ff3e6a05bbcbc7d40d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b928d98f6b64774$var$_react = $9b928d98f6b64774$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9b928d98f6b64774$var$_iconNew = $9b928d98f6b64774$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9b928d98f6b64774$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-left
 * Usage guidance:
 * Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b928d98f6b64774$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $9b928d98f6b64774$var$_react.default.createElement($9b928d98f6b64774$var$_iconNew.default, Object.assign({
        name: "AlignTextLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$9b928d98f6b64774$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $9b928d98f6b64774$var$_default = module.exports.default = $9b928d98f6b64774$var$AlignTextLeftIcon;

});

parcelRegister("fUD4v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64347d86305d18a44e2d07d8a13aff6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b95a64cf9d357b8d$var$_react = $b95a64cf9d357b8d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b95a64cf9d357b8d$var$_iconNew = $b95a64cf9d357b8d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b95a64cf9d357b8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text
 * Usage guidance:
 * Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b95a64cf9d357b8d$var$TextIcon = (props)=>/*#__PURE__*/ $b95a64cf9d357b8d$var$_react.default.createElement($b95a64cf9d357b8d$var$_iconNew.default, Object.assign({
        name: "TextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.25V15h-1.5V2.5H0V1zm1 12V8h-2V6.5h2V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2"/>`
    }, props));
$b95a64cf9d357b8d$var$TextIcon.displayName = 'TextIcon';
var $b95a64cf9d357b8d$var$_default = module.exports.default = $b95a64cf9d357b8d$var$TextIcon;

});

parcelRegister("jyQ1U", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a00817678c45f13$export$2e2bcd8739ae039);
const $0a00817678c45f13$var$getAppearanceForAppType = (appType)=>{
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
};
var $0a00817678c45f13$export$2e2bcd8739ae039 = $0a00817678c45f13$var$getAppearanceForAppType;

});

parcelRegister("9r4bt", function(module, exports) {
$parcel$export(module.exports, "DatasourceTableViewWithWrappers", () => $f7fa1f34e70b9aec$export$2f5bdb66685d3fb4);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3ZJj6 = parcelRequire("3ZJj6");

const $f7fa1f34e70b9aec$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("3XCif")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $f7fa1f34e70b9aec$export$2f5bdb66685d3fb4 = /*#__PURE__*/ (0, $fc4bM.memo)(function DatasourceTableViewWithWrappers(props) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($f7fa1f34e70b9aec$var$LazyDatasourceTableView, {
            ...props
        })
    });
}, (0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6))));

});
parcelRegister("3XCif", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("8fIwp"),
    $9dnsd("61osU"),
    $9dnsd("f1jnr"),
    $9dnsd("ozcFp"),
    $9dnsd("eJhPz"),
    $9dnsd("84PLG"),
    $9dnsd("3LItB")
]).then(()=>parcelRequire('k1HX4'));

});


parcelRegister("e6UFk", function(module, exports) {
$parcel$export(module.exports, "ExternalImageBadge", () => $38ceed0266c95758$export$66bf2ed7a5d4691f);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $fKWgA = parcelRequire("fKWgA");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $bcTS3 = parcelRequire("bcTS3");

var $gCBtR = parcelRequire("gCBtR");
const $38ceed0266c95758$var$baseStyles = (0, $kig2V.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $38ceed0266c95758$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com',
    'bitbucket.org'
];
const $38ceed0266c95758$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname === null || pathname === void 0 ? void 0 : pathname.startsWith('image/');
    return Boolean(hostname && $38ceed0266c95758$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $38ceed0266c95758$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $gpjDl.default)();
    const message = intl.formatMessage((0, $gCBtR.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $38ceed0266c95758$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5a4EU.Box), {
        padding: "space.050",
        xcss: $38ceed0266c95758$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))), {
                    label: message
                })
            })
        ]
    });
};

});
parcelRegister("gCBtR", function(module, exports) {
$parcel$export(module.exports, "externalMediaMessages", () => $79290134a90ec994$export$8e36294abfabe45e);

var $8p5Cv = parcelRequire("8p5Cv");
const $79290134a90ec994$export$8e36294abfabe45e = (0, $8p5Cv.defineMessages)({
    externalMediaFile: {
        id: 'fabric.editor.externalMediaFile',
        defaultMessage: 'External media file',
        description: 'Displayed as a tooltip and accessibility label for an info icon badge when an externally hosted media file is shown in the editor.'
    }
});

});


parcelRegister("eh1GK", function(module, exports) {
$parcel$export(module.exports, "MediaBadges", () => $839e06f9fa5581f1$export$6a31fc38737d0e58);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $efOj7 = parcelRequire("efOj7");
const $839e06f9fa5581f1$export$6a31fc38737d0e58 = ({ mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, children: children, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $efOj7.BlockNodeBadges), {
        element: mediaElement,
        width: mediaWidth,
        height: mediaHeight,
        extendedResizeOffset: extendedResizeOffset,
        useMinimumZIndex: useMinimumZIndex,
        children: children
    });

});
parcelRegister("efOj7", function(module, exports) {
$parcel$export(module.exports, "BlockNodeBadges", () => $bf386e9dcfc1cf03$export$d7fda18776ad9a8d);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $53bjB = parcelRequire("53bjB");

var $dRkX9 = parcelRequire("dRkX9");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");
const $bf386e9dcfc1cf03$var$BADGE_VISIBILITY_BREAKPOINT = 200;
const $bf386e9dcfc1cf03$var$containerStyles = (0, $kig2V.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $bf386e9dcfc1cf03$var$hackedZIndexStyles = (0, $kig2V.xcss)({
    zIndex: '1'
});
const $bf386e9dcfc1cf03$var$resizeOffsetStyles = (0, $kig2V.xcss)({
    right: 'space.150'
});
const $bf386e9dcfc1cf03$var$getBadgeVisible = (width, height)=>{
    return width && width < $bf386e9dcfc1cf03$var$BADGE_VISIBILITY_BREAKPOINT || height && height < $bf386e9dcfc1cf03$var$BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $bf386e9dcfc1cf03$export$d7fda18776ad9a8d = ({ children: children, element: element, width: width, height: height, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $fc4bM.useState)($bf386e9dcfc1cf03$var$getBadgeVisible(width, height));
    (0, $fc4bM.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($bf386e9dcfc1cf03$var$getBadgeVisible(width, height));
        }));
        if (element) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $dRkX9.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!element || (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $bf386e9dcfc1cf03$var$containerStyles,
            useMinimumZIndex && $bf386e9dcfc1cf03$var$hackedZIndexStyles,
            extendedResizeOffset && $bf386e9dcfc1cf03$var$resizeOffsetStyles
        ],
        children: children
    });
};

});


parcelRegister("99mkY", function(module, exports) {
$parcel$export(module.exports, "createRenderedResultTracker", () => $45e0bc58849e9b1f$export$274bb07166a08e06);

var $6Zi52 = parcelRequire("6Zi52");
function $45e0bc58849e9b1f$export$274bb07166a08e06({ onRendered: onRendered }) {
    let resultId;
    let ready = false;
    let intersects = false;
    let element = null;
    let observer;
    let unbindVisibility;
    let destroyed = false;
    const emitted = new Set();
    const updateIntersection = (entries)=>{
        for (const entry of entries)if (entry.target === element) intersects = entry.isIntersecting && entry.intersectionRatio > 0;
    };
    const emit = ()=>{
        var _observer, _element;
        if (destroyed || !ready || resultId === undefined || emitted.has(resultId)) return;
        updateIntersection(((_observer = observer) === null || _observer === void 0 ? void 0 : _observer.takeRecords()) ?? []);
        if (!intersects || ((_element = element) === null || _element === void 0 ? void 0 : _element.ownerDocument.visibilityState) !== 'visible') return;
        emitted.add(resultId);
        onRendered(resultId);
    };
    const disconnect = ()=>{
        var _observer2, _unbindVisibility;
        (_observer2 = observer) === null || _observer2 === void 0 || _observer2.disconnect();
        observer = undefined;
        (_unbindVisibility = unbindVisibility) === null || _unbindVisibility === void 0 || _unbindVisibility();
        unbindVisibility = undefined;
        intersects = false;
    };
    return {
        setResult: (nextResultId)=>{
            if (resultId !== nextResultId) {
                resultId = nextResultId;
                ready = false;
            }
        },
        ready: (renderedResultId)=>{
            if (resultId === renderedResultId) {
                ready = true;
                emit();
            }
        },
        observe: (nextElement)=>{
            if (destroyed || element === nextElement) return;
            disconnect();
            element = nextElement;
            if (element) {
                observer = new IntersectionObserver((entries)=>{
                    updateIntersection(entries);
                    emit();
                }, {
                    // The root property identifies what to observe in the viewport
                    // `null` will use the owning document (most likely the browser window)
                    root: null,
                    // Detect when overlap reaches 0.1% of the element's area
                    threshold: [
                        0,
                        0.001
                    ]
                });
                observer.observe(element);
                unbindVisibility = (0, $6Zi52.bind)(element.ownerDocument, {
                    type: 'visibilitychange',
                    listener: emit
                });
            }
        },
        destroy: ()=>{
            destroyed = true;
            disconnect();
            element = null;
        }
    };
}

});

parcelRegister("fgXx3", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $7c42918f55124415$export$bad3c41dd33cb4bc);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $7c42918f55124415$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $7c42918f55124415$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $7c42918f55124415$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #0B120E24)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #7D818A)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #292A2E)"
};

});

parcelRegister("aNwcB", function(module, exports) {
$parcel$export(module.exports, "withImageLoader", () => $7027efcf00f6ef6a$export$9b0f795b2e33f057);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");
const $7027efcf00f6ef6a$export$9b0f795b2e33f057 = (Wrapped)=>class WithImageLoader extends (0, $fc4bM.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $3LM7S.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };

});

parcelRegister("gRAAc", function(module, exports) {
$parcel$export(module.exports, "getDimensionsWithDefault", () => $23be703155d00b9f$export$36acad525b1fb57b);
const $23be703155d00b9f$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("3zXap", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $364c93a369d18c2c$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $29RFM = parcelRequire("29RFM");
const $364c93a369d18c2c$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $29RFM.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("29RFM", function(module, exports) {
$parcel$export(module.exports, "wrapperStyles", () => $836e18e88c75144f$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $8eHsn = parcelRequire("8eHsn");
const $836e18e88c75144f$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $jctmk.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $8eHsn.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $8eHsn.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("8eHsn", function(module, exports) {
$parcel$export(module.exports, "center", () => $bce39475efbf46e0$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $bce39475efbf46e0$export$7a57f79000377ca2);
const $bce39475efbf46e0$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $bce39475efbf46e0$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $bce39475efbf46e0$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $bce39475efbf46e0$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});



parcelRegister("af3Ca", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ecbf68a53fcbaa$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $dRkX9 = parcelRequire("dRkX9");

var $pMGlN = parcelRequire("pMGlN");

var $kYtcy = parcelRequire("kYtcy");
const $48ecbf68a53fcbaa$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext({});
const $48ecbf68a53fcbaa$var$CardLoadingWithContext = ()=>{
    const props = (0, $fc4bM.useContext)($48ecbf68a53fcbaa$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kYtcy.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $48ecbf68a53fcbaa$var$loadCardWithMediaClient() {
    return (parcelRequire("R3ZMO"));
}
const $48ecbf68a53fcbaa$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>$48ecbf68a53fcbaa$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($48ecbf68a53fcbaa$var$CardLoadingWithContext, null)
});
const $48ecbf68a53fcbaa$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).lazy(()=>$48ecbf68a53fcbaa$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $48ecbf68a53fcbaa$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $pMGlN.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($48ecbf68a53fcbaa$var$MediaCardContext.Provider, {
        value: props
    }, (0, $dRkX9.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($48ecbf68a53fcbaa$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($48ecbf68a53fcbaa$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($48ecbf68a53fcbaa$var$MediaCardWithMediaClientLoadable, props)));
};
$48ecbf68a53fcbaa$var$CardLoader.preload = ()=>{
    if ((0, $dRkX9.fg)('platform_media_react19_support')) $48ecbf68a53fcbaa$var$loadCardWithMediaClient().then(()=>{});
    else {
        var _MediaCardWithMediaCl;
        (_MediaCardWithMediaCl = $48ecbf68a53fcbaa$var$MediaCardWithMediaClientLoadable.preload) === null || _MediaCardWithMediaCl === void 0 || _MediaCardWithMediaCl.call($48ecbf68a53fcbaa$var$MediaCardWithMediaClientLoadable);
    }
};
var $48ecbf68a53fcbaa$export$2e2bcd8739ae039 = $48ecbf68a53fcbaa$var$CardLoader;

});
parcelRegister("kYtcy", function(module, exports) {
$parcel$export(module.exports, "CardLoading", () => $2c9d91fea6b45e84$export$5d25853fd6bdf402);

var $fc4bM = parcelRequire("fc4bM");

var $b04mi = parcelRequire("b04mi");

var $gRAAc = parcelRequire("gRAAc");

var $3zXap = parcelRequire("3zXap");
const $2c9d91fea6b45e84$export$5d25853fd6bdf402 = ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $gRAAc.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3zXap.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $b04mi.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }));
};

});
parcelRegister("b04mi", function(module, exports) {
$parcel$export(module.exports, "LoadingBar", () => $df45e20f04e66f86$export$6665614bc5d690f6);
/* loadingBar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $8p5Cv = parcelRequire("8p5Cv");
var $gpjDl = parcelRequire("gpjDl");

var $fVzQQ = parcelRequire("fVzQQ");
const $df45e20f04e66f86$var$TICK_INTERVAL_MS = 1000;
const $df45e20f04e66f86$var$STATIC_PROGRESS_VALUE = 0.9;
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $df45e20f04e66f86$var$useLayoutEffect = typeof window === 'undefined' ? (0, $fc4bM.useEffect) : (0, $fc4bM.useLayoutEffect);
const $df45e20f04e66f86$var$messages = (0, $8p5Cv.defineMessages)({
    loadingBarLabel: {
        id: 'fabric.media.loading_bar_label',
        defaultMessage: 'Loading',
        description: 'Aria label for the loading bar shown while a media card is loading'
    }
});
const $df45e20f04e66f86$var$trackStyles = null;
const $df45e20f04e66f86$var$fillStyles = null;
const $df45e20f04e66f86$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $df45e20f04e66f86$export$6665614bc5d690f6 = ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $gpjDl.default)();
    const [progress, setProgress] = (0, $fc4bM.useState)(animationDisabled ? $df45e20f04e66f86$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $fc4bM.useRef)();
    const interactionContext = (0, $fc4bM.useContext)((0, $fVzQQ.default));
    $df45e20f04e66f86$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($df45e20f04e66f86$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $df45e20f04e66f86$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($df45e20f04e66f86$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        style: {
            width: `${$df45e20f04e66f86$var$clampToPercent(progress)}%`
        },
        className: (0, $2R2iS.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ])
    }));
};

});


parcelRegister("R3ZMO", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("EiaEi"),
    $9dnsd("b1NYz"),
    $9dnsd("flroK")
]).then(()=>parcelRequire('4JgFL'));

});


parcelRegister("hq7uM", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_MEDIA_CHANNEL", () => $94fff244f85070eb$export$ec1779cb96554e1);
const $94fff244f85070eb$export$ec1779cb96554e1 = 'media';

});

parcelRegister("OO7bU", function(module, exports) {
$parcel$export(module.exports, "isFileIdentifier", () => $33b06cf45b7c1a5f$export$7695387cd66cf5b5);
const $33b06cf45b7c1a5f$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};

});

parcelRegister("bKJJ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $edc30f24b63e70ba$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $hmOjU = parcelRequire("hmOjU");

var $2uHor = parcelRequire("2uHor");

var $7LzQO = parcelRequire("7LzQO");
const $edc30f24b63e70ba$var$MediaViewer = /*#__PURE__*/ (0, $fc4bM.lazy)(()=>(0, $hmOjU.loadMediaViewerChunk)().then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $edc30f24b63e70ba$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2uHor.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7LzQO.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($edc30f24b63e70ba$var$MediaViewer, props)));
}

});
parcelRegister("hmOjU", function(module, exports) {
$parcel$export(module.exports, "loadMediaViewerChunk", () => $ac11824ebe268e93$export$8d8c2c2be317e2a4);
$parcel$export(module.exports, "loadImageViewerChunk", () => $ac11824ebe268e93$export$457a0a3ac31f3be9);
/**
 * The single call site for each lazily loaded chunk that `./preload` warms.
 *
 * Both the render path and the warm-up path must go through these. Repeating an
 * `import()` with the same `webpackChunkName` in two files relies on the two
 * comments staying identical forever; if they drift, the warm-up fetches a
 * different chunk than the one the viewer loads and silently does nothing.
 */ 
const $ac11824ebe268e93$export$8d8c2c2be317e2a4 = ()=>(parcelRequire("1wync"));

const $ac11824ebe268e93$export$457a0a3ac31f3be9 = ()=>(parcelRequire("1kHz7"));

});
parcelRegister("1wync", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("fyN2x"),
    $9dnsd("i9Q1y"),
    $9dnsd("5HVZU"),
    $9dnsd("aejHq"),
    $9dnsd("EiaEi"),
    $9dnsd("b1NYz"),
    $9dnsd("8F4iO"),
    $9dnsd("6YxJZ"),
    $9dnsd("eamXe"),
    $9dnsd("32rp9"),
    $9dnsd("cADPK"),
    $9dnsd("5TT1O"),
    $9dnsd("6C386"),
    $9dnsd("WFTrL"),
    $9dnsd("5s3ed"),
    $9dnsd("bRIcI"),
    $9dnsd("8LMxR"),
    $9dnsd("dTYFa"),
    $9dnsd("98elN"),
    $9dnsd("fBPcn"),
    $9dnsd("6z401"),
    $9dnsd("1N1Ks")
]).then(()=>parcelRequire('2hxGt'));

});

parcelRegister("1kHz7", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("fyN2x"),
    $9dnsd("i9Q1y"),
    $9dnsd("5HVZU"),
    $9dnsd("aejHq"),
    $9dnsd("b1NYz"),
    $9dnsd("8F4iO"),
    $9dnsd("6Df0C"),
    $9dnsd("2HmsM")
]).then(()=>parcelRequire('3lnMb'));

});


parcelRegister("2uHor", function(module, exports) {
$parcel$export(module.exports, "default", () => $da9bdd65c2d92efb$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $fc4bM = parcelRequire("fc4bM");

var $5UvBW = parcelRequire("5UvBW");

var $anluN = parcelRequire("anluN");
const $da9bdd65c2d92efb$export$442b7be89436c101 = '#101214';
const $da9bdd65c2d92efb$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $anluN.useThemeObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5UvBW.default), {
        blankedColor: $da9bdd65c2d92efb$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $da9bdd65c2d92efb$export$2e2bcd8739ae039 = $da9bdd65c2d92efb$var$ModalSpinner;

});
parcelRegister("5UvBW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1d04a40ebbde184$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $i4ZpT = parcelRequire("i4ZpT");
const $f1d04a40ebbde184$var$ModalSpinner = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i4ZpT.default), props);
var $f1d04a40ebbde184$export$2e2bcd8739ae039 = $f1d04a40ebbde184$var$ModalSpinner;

});
parcelRegister("i4ZpT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca1feddf2411da7a$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $hculA = parcelRequire("hculA");
const $ca1feddf2411da7a$var$blanketStyles = null;
const $ca1feddf2411da7a$var$spinnerStyles = null;
const $ca1feddf2411da7a$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ca1feddf2411da7a$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $fc4bM.createElement("div", {
        style: {
            backgroundColor: blankedColor || $ca1feddf2411da7a$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $2R2iS.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $hculA.default), {
        size: "large",
        appearance: invertSpinnerColor || $ca1feddf2411da7a$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});



parcelRegister("7LzQO", function(module, exports) {
$parcel$export(module.exports, "MediaViewerPortal", () => $1b6852e5c169a89e$export$51aee4c01b17acde);

var $fc4bM = parcelRequire("fc4bM");

var $cufVT = parcelRequire("cufVT");
const $1b6852e5c169a89e$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cufVT.default), {
        zIndex: 510
    }, children);

});


parcelRegister("hidNJ", function(module, exports) {
$parcel$export(module.exports, "isExternalImageIdentifier", () => $5b8c7178a29c81ec$export$2782f2fbff82f0c9);
const $5b8c7178a29c81ec$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};

});

parcelRegister("8IUoY", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagKeysAllProducts", () => $87e585ab530cf73d$export$c8bcd5e6111ea1f3);
$parcel$export(module.exports, "getMediaFeatureFlag", () => $87e585ab530cf73d$export$383e8f51978266d);

var $3XFSJ = parcelRequire("3XFSJ");

var $9epBD = parcelRequire("9epBD");

var $dH3VR = parcelRequire("dH3VR");
const $87e585ab530cf73d$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $87e585ab530cf73d$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $9epBD.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $dH3VR.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $87e585ab530cf73d$export$836625761e76d373 = {
    mediaInline: false
};
function $87e585ab530cf73d$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $3XFSJ.getGenericFeatureFlag)(flagName, $87e585ab530cf73d$export$836625761e76d373, featureFlags);
}

});
parcelRegister("3XFSJ", function(module, exports) {
$parcel$export(module.exports, "getGenericFeatureFlag", () => $abf1b6a6c3fad947$export$f2687d0de19e4973);

var $iScgM = parcelRequire("iScgM");
function $abf1b6a6c3fad947$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $iScgM.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}

});
parcelRegister("iScgM", function(module, exports) {
$parcel$export(module.exports, "getLocalMediaFeatureFlag", () => $2b140e1ea362fdb2$export$d125817a2695dbc9);
// window.localStorage is easier to mock in tests if wrapped in this module
const $2b140e1ea362fdb2$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};

});


parcelRegister("9epBD", function(module, exports) {
$parcel$export(module.exports, "getProductKeys", () => $62c66b07d7afa59f$export$189fe120be7e73fc);
const $62c66b07d7afa59f$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $62c66b07d7afa59f$export$189fe120be7e73fc = ()=>$62c66b07d7afa59f$var$productKeys;

});

parcelRegister("dH3VR", function(module, exports) {
$parcel$export(module.exports, "supportedProducts", () => $77d1985a461e084f$export$2db74afa1ef496f1);
// Media feature flags - type and defaults defined here in one source of truth
const $77d1985a461e084f$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];

});


parcelRegister("jGvkt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e54a3dea3bc1ef0f$var$_react = $e54a3dea3bc1ef0f$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e54a3dea3bc1ef0f$var$_iconNew = $e54a3dea3bc1ef0f$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e54a3dea3bc1ef0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e54a3dea3bc1ef0f$var$AddIcon = (props)=>/*#__PURE__*/ $e54a3dea3bc1ef0f$var$_react.default.createElement($e54a3dea3bc1ef0f$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$e54a3dea3bc1ef0f$var$AddIcon.displayName = 'AddIcon';
var $e54a3dea3bc1ef0f$var$_default = module.exports.default = $e54a3dea3bc1ef0f$var$AddIcon;

});

parcelRegister("k5tNs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b7b5313441e64074b34abd119ca75dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9fb6344c138a751$var$_react = $e9fb6344c138a751$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e9fb6344c138a751$var$_iconNew = $e9fb6344c138a751$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e9fb6344c138a751$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/minus
 * Usage guidance:
 * Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9fb6344c138a751$var$MinusIcon = (props)=>/*#__PURE__*/ $e9fb6344c138a751$var$_react.default.createElement($e9fb6344c138a751$var$_iconNew.default, Object.assign({
        name: "MinusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$e9fb6344c138a751$var$MinusIcon.displayName = 'MinusIcon';
var $e9fb6344c138a751$var$_default = module.exports.default = $e9fb6344c138a751$var$MinusIcon;

});

parcelRegister("Admw7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd451baebec3ee8af80e499b33257918>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06cdba5b8cefb727$var$_react = $06cdba5b8cefb727$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $06cdba5b8cefb727$var$_iconNew = $06cdba5b8cefb727$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $06cdba5b8cefb727$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/delete
 * Usage guidance:
 * Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06cdba5b8cefb727$var$DeleteIcon = (props)=>/*#__PURE__*/ $06cdba5b8cefb727$var$_react.default.createElement($06cdba5b8cefb727$var$_iconNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$06cdba5b8cefb727$var$DeleteIcon.displayName = 'DeleteIcon';
var $06cdba5b8cefb727$var$_default = module.exports.default = $06cdba5b8cefb727$var$DeleteIcon;

});

parcelRegister("aQvZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfb96ac8121d6e86aa07f23b47de6511>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e57922273edae0b$var$_react = $7e57922273edae0b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $7e57922273edae0b$var$_iconNew = $7e57922273edae0b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $7e57922273edae0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e57922273edae0b$var$SettingsIcon = (props)=>/*#__PURE__*/ $7e57922273edae0b$var$_react.default.createElement($7e57922273edae0b$var$_iconNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$7e57922273edae0b$var$SettingsIcon.displayName = 'SettingsIcon';
var $7e57922273edae0b$var$_default = module.exports.default = $7e57922273edae0b$var$SettingsIcon;

});

parcelRegister("8jQcJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::441dfad9ee46f29a271b393b57a2f5c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e897ccecd47586$var$_react = $60e897ccecd47586$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $60e897ccecd47586$var$_iconNew = $60e897ccecd47586$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $60e897ccecd47586$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/upload
 * Usage guidance:
 * Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e897ccecd47586$var$UploadIcon = (props)=>/*#__PURE__*/ $60e897ccecd47586$var$_react.default.createElement($60e897ccecd47586$var$_iconNew.default, Object.assign({
        name: "UploadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$60e897ccecd47586$var$UploadIcon.displayName = 'UploadIcon';
var $60e897ccecd47586$var$_default = module.exports.default = $60e897ccecd47586$var$UploadIcon;

});

parcelRegister("7XpO2", function(module, exports) {
$parcel$export(module.exports, "getWarmedImageKey", () => $7f783fe25d4fdd4f$export$6e7c4e4f0cbdf806);
$parcel$export(module.exports, "hasWarmedImage", () => $7f783fe25d4fdd4f$export$7d5707133dcb705f);
$parcel$export(module.exports, "hasWarmedImageForFile", () => $7f783fe25d4fdd4f$export$41822d12dda3d8e3);
$parcel$export(module.exports, "setWarmedImage", () => $7f783fe25d4fdd4f$export$34a185d9a1fbb19f);
$parcel$export(module.exports, "takeWarmedImage", () => $7f783fe25d4fdd4f$export$9a8bfd88893fad6a);
/**
 * Full resolution image fetches started before the viewer opens.
 *
 * `ImageViewer` takes the entry for the file it opens and awaits the same request, so
 * the image downloads once even when the click lands while the warm-up is still
 * downloading.
 *
 * Taking an entry hands over its `AbortController` too. The viewer then owns the
 * download, and closing the viewer aborts it as it aborts the viewer's own request.
 * Entries nobody takes are aborted when they are evicted or expire.
 *
 * Whoever takes the blob creates and revokes its own object URL.
 *
 * Entries are keyed by file, collection and watermark version. The watermark is
 * applied server-side, so a warm-up made before a watermark config change carries
 * the old watermark, and a viewer opened after the change must not take it.
 *
 * The store lives on `globalThis`, not in this module. A bundler can copy a small
 * module into several bundles, each with its own module state, and the warm-up and
 * `ImageViewer` load from different bundles. The shared key gives every copy of this
 * file the same store.
 */ /**
 * How many untaken warm-ups to hold at once. These are full resolution images and can
 * be several megabytes each, so the ceiling is deliberately low: the point is the
 * image the user is about to open, plus a little slack for hovering past one image on
 * the way to another.
 */ const $7f783fe25d4fdd4f$var$MAX_WARMED_IMAGES = 2;
const $7f783fe25d4fdd4f$export$96f8a06367fe92d2 = 30000;
// Versioned, so a later change to `Entry` never reads a store another version wrote.
const $7f783fe25d4fdd4f$var$STORE_KEY = Symbol.for('@atlaskit/media-viewer/warmed-images/v1');
const $7f783fe25d4fdd4f$var$getStore = ()=>{
    const scope = globalThis;
    let store = scope[$7f783fe25d4fdd4f$var$STORE_KEY];
    if (!store) {
        store = new Map();
        scope[$7f783fe25d4fdd4f$var$STORE_KEY] = store;
    }
    return store;
};
/**
 * Listeners report analytics. A throw from one must not break a take, which runs
 * inside `ImageViewer`, or an eviction, which runs inside the next warm-up.
 */ const $7f783fe25d4fdd4f$var$notify = (call)=>{
    try {
        call();
    } catch  {
    // Ignored, see above.
    }
};
const $7f783fe25d4fdd4f$export$6e7c4e4f0cbdf806 = ({ id: id, collectionName: collectionName, watermarkVersion: watermarkVersion })=>// Joined as JSON, because a watermark version can contain any separator character.
    JSON.stringify([
        id,
        collectionName ?? '',
        watermarkVersion ?? ''
    ]);
const $7f783fe25d4fdd4f$export$7d5707133dcb705f = (key)=>$7f783fe25d4fdd4f$var$getStore().has(key);
const $7f783fe25d4fdd4f$export$41822d12dda3d8e3 = ({ id: id, collectionName: collectionName })=>{
    // The file's keys all start with the JSON of its first two parts, minus the closing
    // bracket. JSON quotes each part, so no other file's key can share the prefix.
    const prefix = `${JSON.stringify([
        id,
        collectionName ?? ''
    ]).slice(0, -1)},`;
    return [
        ...$7f783fe25d4fdd4f$var$getStore().keys()
    ].some((key)=>key.startsWith(prefix));
};
const $7f783fe25d4fdd4f$var$removeWarmedImage = (key, outcome)=>{
    const store = $7f783fe25d4fdd4f$var$getStore();
    const entry = store.get(key);
    if (entry) {
        var _entry$listener;
        clearTimeout(entry.expiry);
        store.delete(key);
        const onEnd = (_entry$listener = entry.listener) === null || _entry$listener === void 0 ? void 0 : _entry$listener.onEnd;
        if (outcome && onEnd) $7f783fe25d4fdd4f$var$notify(()=>onEnd(outcome, entry.blob));
    }
    return entry;
};
const $7f783fe25d4fdd4f$var$discardWarmedImage = (key, outcome)=>{
    var _removeWarmedImage;
    (_removeWarmedImage = $7f783fe25d4fdd4f$var$removeWarmedImage(key, outcome)) === null || _removeWarmedImage === void 0 || _removeWarmedImage.controller.abort();
};
const $7f783fe25d4fdd4f$export$34a185d9a1fbb19f = (key, { image: image, controller: controller }, listener)=>{
    const store = $7f783fe25d4fdd4f$var$getStore();
    $7f783fe25d4fdd4f$var$discardWarmedImage(key, 'replaced');
    // `Map` iterates in insertion order, so the first key is the oldest.
    if (store.size >= $7f783fe25d4fdd4f$var$MAX_WARMED_IMAGES) {
        const oldest = store.keys().next().value;
        if (oldest !== undefined) $7f783fe25d4fdd4f$var$discardWarmedImage(oldest, 'evicted');
    }
    const entry = {
        image: image,
        controller: controller,
        listener: listener,
        expiry: setTimeout(()=>$7f783fe25d4fdd4f$var$discardWarmedImage(key, 'expired'), $7f783fe25d4fdd4f$export$96f8a06367fe92d2)
    };
    store.set(key, entry);
    image.then((blob)=>{
        entry.blob = blob;
    }, (error)=>{
        // Every removal except a take aborts the request, and so does closing the
        // viewer after a take. None of those are failures.
        if (controller.signal.aborted) return;
        // Drop a failed warm-up so a later hover can try again. This handler also marks
        // the rejection as handled when nobody takes the warm-up.
        const wasTaken = $7f783fe25d4fdd4f$var$getStore().get(key) !== entry;
        if (!wasTaken) $7f783fe25d4fdd4f$var$removeWarmedImage(key, 'failed');
        const onError = listener === null || listener === void 0 ? void 0 : listener.onError;
        if (onError) $7f783fe25d4fdd4f$var$notify(()=>onError(error, wasTaken));
    });
};
const $7f783fe25d4fdd4f$export$9a8bfd88893fad6a = (key)=>{
    const entry = $7f783fe25d4fdd4f$var$removeWarmedImage(key, 'taken');
    return entry && {
        image: entry.image,
        controller: entry.controller
    };
};
const $7f783fe25d4fdd4f$export$aa3f8cc063752584 = ()=>{
    [
        ...$7f783fe25d4fdd4f$var$getStore().keys()
    ].forEach((key)=>$7f783fe25d4fdd4f$var$discardWarmedImage(key));
};

});

parcelRegister("4Vhfr", function(module, exports) {
$parcel$export(module.exports, "IMAGE_VIEWER_FETCH_MAX_RES", () => $c8eff7ac53fb3a82$export$e74e3703c1830bfb);
$parcel$export(module.exports, "getImageViewerRequestParams", () => $c8eff7ac53fb3a82$export$d9f77e6e2df1dedb);
const $c8eff7ac53fb3a82$export$e74e3703c1830bfb = true;
const $c8eff7ac53fb3a82$export$d9f77e6e2df1dedb = (collectionName)=>({
        collection: collectionName,
        mode: 'fit'
    });

});

parcelRegister("90Exr", function(module, exports) {
$parcel$export(module.exports, "defaultImageCardDimensions", () => $6818d1f3bf2a29a5$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $6818d1f3bf2a29a5$export$ed7b8a4728e9c63);
const $6818d1f3bf2a29a5$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $6818d1f3bf2a29a5$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $6818d1f3bf2a29a5$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $6818d1f3bf2a29a5$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $6818d1f3bf2a29a5$export$d87a47989c00f322;
    if (appearance === 'square') return $6818d1f3bf2a29a5$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $6818d1f3bf2a29a5$export$aeb48196afcd236a;
    return $6818d1f3bf2a29a5$export$d87a47989c00f322;
};

});

parcelRegister("6CDdN", function(module, exports) {
$parcel$export(module.exports, "preloadMediaViewer", () => $1925ac8892373d3c$export$c50fda67e674adf9);

var $4vCw2 = parcelRequire("4vCw2");

var $OO7bU = parcelRequire("OO7bU");

var $ayBkd = parcelRequire("ayBkd");

var $heTdg = parcelRequire("heTdg");

var $9iffu = parcelRequire("9iffu");

var $bcN2K = parcelRequire("bcN2K");

var $hGp4b = parcelRequire("hGp4b");

var $hmOjU = parcelRequire("hmOjU");

var $4Vhfr = parcelRequire("4Vhfr");

var $7XpO2 = parcelRequire("7XpO2");
/**
 * Share of warm-ups that report `preloadEnded`, which measures how many warm-ups the
 * viewer takes. `preloadFailed` is never sampled.
 */ const $1925ac8892373d3c$var$PRELOAD_ENDED_SAMPLING_RATE = 0.1;
/**
 * A warm-up is speculative, so it doesn't retry a failure with backoff. Retrying a
 * 5xx would add load when the image endpoint is already struggling, and the viewer
 * makes its own request on open anyway. media-client's Edge network-error fallback
 * still applies. `fetchRetry` waits `startTimeoutInMs` even
 * after the last attempt, so it is zero: a failed warm-up a viewer has taken then
 * hands over to the viewer's own request without a pause.
 */ const $1925ac8892373d3c$var$WARM_UP_CLIENT_OPTIONS = {
    retryOptions: {
        maxAttempts: 1,
        startTimeoutInMs: 0
    }
};
/** SVGs are rendered by `SvgViewer`, which does not go through the image endpoint. */ const $1925ac8892373d3c$var$SVG_MIME_TYPE = 'image/svg+xml';
/**
 * Effective connection types where speculatively downloading a full resolution
 * image costs the user more than the latency it saves.
 */ const $1925ac8892373d3c$var$METERED_EFFECTIVE_TYPES = [
    'slow-2g',
    '2g',
    '3g'
];
const $1925ac8892373d3c$var$isMeteredConnection = ()=>{
    if (typeof navigator === 'undefined') return false;
    const { connection: connection } = navigator;
    if (!connection) return false;
    return !!connection.saveData || !!connection.effectiveType && $1925ac8892373d3c$var$METERED_EFFECTIVE_TYPES.includes(connection.effectiveType);
};
const $1925ac8892373d3c$export$c50fda67e674adf9 = ({ getMediaClient: getMediaClient, identifier: identifier, mimeType: mimeType, mediaType: mediaType, fileState: fileState, traceContext: traceContext, onAnalyticsEvent: onAnalyticsEvent })=>{
    // External images need no warm-up: the viewer renders the same `dataURI` the
    // card is already displaying. Checked before the exposure, so neither arm is
    // exposed for them.
    if (!(0, $OO7bU.isFileIdentifier)(identifier)) return;
    if (!(0, $bcN2K.isExperimentEnabled)('platform_media_viewer_preload_on_hover')) return;
    (0, $hmOjU.loadMediaViewerChunk)().catch(()=>{});
    const resolvedMediaType = mediaType ?? (mimeType ? (0, $heTdg.getMediaTypeFromMimeType)(mimeType) : undefined);
    if (resolvedMediaType !== 'image' || mimeType === $1925ac8892373d3c$var$SVG_MIME_TYPE) return;
    (0, $hmOjU.loadImageViewerChunk)().catch(()=>{});
    if (fileState) {
        // `ImageViewer` renders `fileState.preview` directly when one exists
        // (typically a local upload preview) without touching the image endpoint.
        if (!(0, $4vCw2.isErrorFileState)(fileState) && fileState.preview) return;
        // Otherwise it waits for the backend image representation before fetching.
        if (!(0, $ayBkd.isImageRepresentationReady)(fileState)) return;
    }
    if ($1925ac8892373d3c$var$isMeteredConnection()) return;
    const mediaClient = getMediaClient();
    const { id: id, collectionName: collectionName } = identifier;
    const warmImage = (watermarkVersion)=>{
        const key = (0, $7XpO2.getWarmedImageKey)({
            id: id,
            collectionName: collectionName,
            watermarkVersion: watermarkVersion
        });
        // An existing entry is either still downloading or already resolved. Either way
        // the viewer can take it, so there is nothing to do. Checked after the version
        // resolves, so repeated hovers still make one request.
        if ((0, $7XpO2.hasWarmedImage)(key)) return;
        const controller = new AbortController();
        const startedAt = Date.now();
        const fileSize = fileState && !(0, $4vCw2.isErrorFileState)(fileState) ? fileState.size : undefined;
        const fileAttributes = {
            fileId: id,
            fileMediatype: resolvedMediaType,
            fileMimetype: mimeType,
            ...fileSize !== undefined && {
                fileSize: fileSize
            }
        };
        const report = (createPayload)=>{
            try {
                // Sanitised here, as every media channel event is, so each caller sends the
                // same masked payload.
                onAnalyticsEvent === null || onAnalyticsEvent === void 0 || onAnalyticsEvent((0, $9iffu.sanitiseAnalyticsPayload)(createPayload()));
            } catch  {
            // Analytics must never break the warm-up.
            }
        };
        const isSampled = !!onAnalyticsEvent && Math.random() < $1925ac8892373d3c$var$PRELOAD_ENDED_SAMPLING_RATE;
        (0, $7XpO2.setWarmedImage)(key, {
            image: mediaClient.getImage(id, (0, $4Vhfr.getImageViewerRequestParams)(collectionName), controller, (0, $4Vhfr.IMAGE_VIEWER_FETCH_MAX_RES), traceContext, $1925ac8892373d3c$var$WARM_UP_CLIENT_OPTIONS),
            controller: controller
        }, onAnalyticsEvent && {
            onEnd: isSampled ? (outcome, blob)=>report(()=>(0, $hGp4b.createPreloadEndedEventPayload)({
                        outcome: outcome,
                        blob: blob,
                        durationMs: Date.now() - startedAt,
                        fileAttributes: fileAttributes,
                        traceContext: traceContext,
                        samplingRate: $1925ac8892373d3c$var$PRELOAD_ENDED_SAMPLING_RATE
                    })) : undefined,
            onError: (error, wasTaken)=>report(()=>(0, $hGp4b.createPreloadFailedEventPayload)({
                        error: error,
                        wasTaken: wasTaken,
                        durationMs: Date.now() - startedAt,
                        fileAttributes: fileAttributes,
                        traceContext: traceContext
                    }))
        });
    };
    // The key carries the watermark version the image request is made with, so a
    // warm-up made before a watermark config change never reaches a viewer opened after
    // it. If auth fails, the image request would fail too, so only the chunks are warmed
    // and the viewer's own request reports the failure. Called inside a promise, so a
    // throw (say, from an older media-client without the method) can't reach the hover
    // handler that called this.
    Promise.resolve().then(()=>mediaClient.getImageWatermarkVersion(collectionName)).then(warmImage, ()=>{});
};

});
parcelRegister("hGp4b", function(module, exports) {
$parcel$export(module.exports, "createPreloadFailedEventPayload", () => $27666c2bf7b7aa0a$export$73691aece6b385c6);
$parcel$export(module.exports, "createPreloadEndedEventPayload", () => $27666c2bf7b7aa0a$export$b449648f7a4fa168);

var $PSldb = parcelRequire("PSldb");

var $dk6G9 = parcelRequire("dk6G9");

var $h4ZpL = parcelRequire("h4ZpL");

var $2KcZI = parcelRequire("2KcZI");

var $lBbEM = parcelRequire("lBbEM");
const $27666c2bf7b7aa0a$export$73691aece6b385c6 = ({ error: error, wasTaken: wasTaken, durationMs: durationMs, fileAttributes: fileAttributes, traceContext: traceContext })=>{
    const viewerError = new (0, $lBbEM.MediaViewerError)('preload-image-fetch', error instanceof Error ? error : undefined);
    const requestMetadata = (0, $h4ZpL.getRequestMetadata)(viewerError);
    return {
        eventType: 'operational',
        actionSubject: 'mediaFile',
        action: 'preloadFailed',
        attributes: {
            status: 'fail',
            failReason: (0, $dk6G9.getPrimaryErrorReason)(viewerError),
            error: (0, $2KcZI.getSecondaryErrorReason)(viewerError),
            errorDetail: (0, $PSldb.getErrorDetail)(viewerError),
            statusCode: requestMetadata === null || requestMetadata === void 0 ? void 0 : requestMetadata.statusCode,
            request: requestMetadata,
            fileMimetype: fileAttributes.fileMimetype,
            fileMediatype: fileAttributes.fileMediatype,
            fileAttributes: fileAttributes,
            traceContext: traceContext,
            wasTaken: wasTaken,
            durationMs: durationMs
        }
    };
};
const $27666c2bf7b7aa0a$export$b449648f7a4fa168 = ({ outcome: outcome, blob: blob, durationMs: durationMs, fileAttributes: fileAttributes, traceContext: traceContext, samplingRate: samplingRate })=>({
        eventType: 'operational',
        actionSubject: 'mediaFile',
        action: 'preloadEnded',
        attributes: {
            outcome: outcome,
            resolved: !!blob,
            sizeBytes: blob === null || blob === void 0 ? void 0 : blob.size,
            durationMs: durationMs,
            fileAttributes: fileAttributes,
            traceContext: traceContext,
            isSamplingEnabled: samplingRate < 1,
            samplingRate: samplingRate
        }
    });

});


parcelRegister("fbyw0", function(module, exports) {
$parcel$export(module.exports, "isResolvingMentionProvider", () => $fe9cd54702e5d145$export$ae1fce5f69858ef3);
const $fe9cd54702e5d145$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());

});

parcelRegister("22VWa", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $5957d57af5aaf893$export$4369c812aac99591);
const $5957d57af5aaf893$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("cQ4LZ", function(module, exports) {
$parcel$export(module.exports, "AGENT_MENTION_LOAD_ERROR_ID", () => $b7d8502a31aa5e9e$export$43bc8ec87115a7b3);
$parcel$export(module.exports, "MentionType", () => $b7d8502a31aa5e9e$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $b7d8502a31aa5e9e$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $b7d8502a31aa5e9e$export$8436e53e45ffe15b);
$parcel$export(module.exports, "ComponentNames", () => $b7d8502a31aa5e9e$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "MentionNameStatus", () => $b7d8502a31aa5e9e$export$b8fa67dc54502853);
const $b7d8502a31aa5e9e$export$43bc8ec87115a7b3 = '__agent-mentions-load-error__';
var $b7d8502a31aa5e9e$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $b7d8502a31aa5e9e$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $b7d8502a31aa5e9e$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $b7d8502a31aa5e9e$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $b7d8502a31aa5e9e$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $b7d8502a31aa5e9e$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $b7d8502a31aa5e9e$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});

});

parcelRegister("fxWTn", function(module, exports) {
$parcel$export(module.exports, "getUrlForDomainInContext", () => $5ab992ab0af41862$export$c162de1e7fecc908);

var $ku8wa = parcelRequire("ku8wa");
function $5ab992ab0af41862$export$c162de1e7fecc908(subdomain, envType) {
    var _globalThis$location;
    const domain = (0, $ku8wa.getDomainInContext)(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${((_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.protocol) ?? 'https:'}//${domain}`;
}

});
parcelRegister("ku8wa", function(module, exports) {
$parcel$export(module.exports, "getDomainInContext", () => $12e3a9e4a805319a$export$3f82b86ecb947bf0);

var $5nZb1 = parcelRequire("5nZb1");

var $bL6do = parcelRequire("bL6do");

var $h8Dhq = parcelRequire("h8Dhq");

var $gWkjP = parcelRequire("gWkjP");

var $8Rwzm = parcelRequire("8Rwzm");

var $jgbDT = parcelRequire("jgbDT");
function $12e3a9e4a805319a$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $jgbDT.isolatedCloudFunctions)[perimeter];
    if ((0, $jgbDT.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $jgbDT.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
function $12e3a9e4a805319a$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    var _fullDomainOverride$s;
    // First, check if the subdomain is associated with a global domain
    if ((0, $h8Dhq.globalDomains)[subdomain]) return (0, $h8Dhq.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (_fullDomainOverride$s = (0, $bL6do.fullDomainOverride)[subdomain]) === null || _fullDomainOverride$s === void 0 || (_fullDomainOverride$s = _fullDomainOverride$s[perimeter]) === null || _fullDomainOverride$s === void 0 ? void 0 : _fullDomainOverride$s[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $jgbDT.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $12e3a9e4a805319a$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $gWkjP.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $8Rwzm.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $12e3a9e4a805319a$var$getDomainForIsolatedCloud(subdomain, (0, $5nZb1.COMMERCIAL), domain);
    }
    return $12e3a9e4a805319a$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}

});
parcelRegister("bL6do", function(module, exports) {
$parcel$export(module.exports, "fullDomainOverride", () => $f9fc594ea665e4fd$export$4723232b625f823e);

var $5nZb1 = parcelRequire("5nZb1");
const $f9fc594ea665e4fd$export$4723232b625f823e = {
    id: {
        [(0, $5nZb1.COMMERCIAL)]: {
            [(0, $5nZb1.PRODUCTION)]: 'id.atlassian.com',
            [(0, $5nZb1.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $5nZb1.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $5nZb1.FEDRAMP_MODERATE)]: {
            [(0, $5nZb1.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $5nZb1.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};

});

parcelRegister("h8Dhq", function(module, exports) {
$parcel$export(module.exports, "globalDomains", () => $3797072967ff65b9$export$cfd430a73d68f4bc);
const $3797072967ff65b9$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    // Atlassian design system documentation
    design: 'design.atlassian.com',
    // Atlassian design system documentation
    extranet: 'extranet.atlassian.com',
    // Old staff intranet (now hello.atlassian.net)
    go: 'go.atlassian.com',
    // Go links
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    // WAC CDN links
    integrations: 'integrations.atlassian.com',
    // Integrations links
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};

});

parcelRegister("gWkjP", function(module, exports) {
$parcel$export(module.exports, "cloudEnvironment", () => $4deb627be9c5d2fd$export$9e04105551ffc5c4);

var $5nZb1 = parcelRequire("5nZb1");

var $cq0dB = parcelRequire("cq0dB");

var $iPUNO = parcelRequire("iPUNO");
function $4deb627be9c5d2fd$var$cloudEnvironmentSsrLookup() {
    var _globalThis$ssrContex, _globalThis$ssrContex2;
    // @ts-ignore
    if (((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInIC) === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $5nZb1.COMMERCIAL)
    };
    // @ts-ignore
    if (((_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nZb1.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nZb1.COMMERCIAL)
    };
}
function $4deb627be9c5d2fd$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $iPUNO.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nZb1.COMMERCIAL)
    };
    const isIc = (0, $cq0dB.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $5nZb1.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $5nZb1.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nZb1.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}
function $4deb627be9c5d2fd$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $4deb627be9c5d2fd$var$cloudEnvironmentSsrLookup();
    return $4deb627be9c5d2fd$var$cloudEnvironmentCookieLookup();
}

});

parcelRegister("jgbDT", function(module, exports) {
$parcel$export(module.exports, "ReservedNameMapping", () => $80f1f0944a826a4f$export$5860df3acd1ee020);
$parcel$export(module.exports, "AtlDomainMapping", () => $80f1f0944a826a4f$export$c6366754aee43afa);
$parcel$export(module.exports, "isolatedCloudFunctions", () => $80f1f0944a826a4f$export$ad1f7afdb45ad83);
$parcel$export(module.exports, "nonIsolatedCloudFunctions", () => $80f1f0944a826a4f$export$c3b4bc58a05128d6);

var $5nZb1 = parcelRequire("5nZb1");
const $80f1f0944a826a4f$export$5860df3acd1ee020 = {
    [(0, $5nZb1.COMMERCIAL)]: [
        'home',
        'team',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $80f1f0944a826a4f$export$c6366754aee43afa = {
    [(0, $5nZb1.COMMERCIAL)]: [
        'packages'
    ]
};
const $80f1f0944a826a4f$export$ad1f7afdb45ad83 = {
    [(0, $5nZb1.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $80f1f0944a826a4f$export$c3b4bc58a05128d6 = {
    [(0, $5nZb1.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $5nZb1.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, $5nZb1.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $5nZb1.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $5nZb1.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $5nZb1.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $5nZb1.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};

});



parcelRegister("2feYn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eaee527b5a9128134f2f3ecac1b0a289>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a2898c7452ddac4$var$_react = $1a2898c7452ddac4$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $1a2898c7452ddac4$var$_iconNew = $1a2898c7452ddac4$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $1a2898c7452ddac4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/information-circle
 * Usage guidance:
 * Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a2898c7452ddac4$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $1a2898c7452ddac4$var$_react.default.createElement($1a2898c7452ddac4$var$_iconNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$1a2898c7452ddac4$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $1a2898c7452ddac4$var$_default = module.exports.default = $1a2898c7452ddac4$var$InformationCircleIcon;

});

parcelRegister("doRwA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c17091f10fc21dd$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $iNoaQ = parcelRequire("iNoaQ");

var $jE7eB = parcelRequire("jE7eB");

var $3mokv = parcelRequire("3mokv");

var $hVmok = parcelRequire("hVmok");
function $9c17091f10fc21dd$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3mokv.default)(2, arguments);
    var dateLeft = (0, $a3cTc.default)(dirtyDateLeft);
    var dateRight = (0, $a3cTc.default)(dirtyDateRight);
    var sign = (0, $jE7eB.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $iNoaQ.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $jE7eB.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $hVmok.default)((0, $a3cTc.default)(dirtyDateLeft)) && difference === 1 && (0, $jE7eB.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("iNoaQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $daef8e0451c5c01e$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $daef8e0451c5c01e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3mokv.default)(2, arguments);
    var dateLeft = (0, $a3cTc.default)(dirtyDateLeft);
    var dateRight = (0, $a3cTc.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("jE7eB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4d75d5cbfd56141$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $e4d75d5cbfd56141$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3mokv.default)(2, arguments);
    var dateLeft = (0, $a3cTc.default)(dirtyDateLeft);
    var dateRight = (0, $a3cTc.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});


parcelRegister("4sEya", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58a0b7e350797ce13f4ff95adc3c91f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33f93b5c9e132b4c$var$_react = $33f93b5c9e132b4c$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $33f93b5c9e132b4c$var$_iconNew = $33f93b5c9e132b4c$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $33f93b5c9e132b4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/email
 * Usage guidance:
 * Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33f93b5c9e132b4c$var$EmailIcon = (props)=>/*#__PURE__*/ $33f93b5c9e132b4c$var$_react.default.createElement($33f93b5c9e132b4c$var$_iconNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$33f93b5c9e132b4c$var$EmailIcon.displayName = 'EmailIcon';
var $33f93b5c9e132b4c$var$_default = module.exports.default = $33f93b5c9e132b4c$var$EmailIcon;

});

parcelRegister("62lW6", function(module, exports) {
$parcel$export(module.exports, "messages", () => $01d069a5aac987f1$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $01d069a5aac987f1$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $01d069a5aac987f1$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $01d069a5aac987f1$export$c67faf67c1185cba);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $8p5Cv = parcelRequire("8p5Cv");

var $014x6 = parcelRequire("014x6");
function $01d069a5aac987f1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01d069a5aac987f1$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    loading: {
        id: 'fabric.editor.expand.loading',
        defaultMessage: 'Loading...',
        description: 'Text shown inside an expand node while its content is being loaded, indicating to the user that data is still being fetched.'
    },
    collapseNode: {
        id: 'fabric.editor.collapseNode',
        defaultMessage: 'Collapse content',
        description: 'The text is shown as a tooltip on a button when the user clicks to collapse an expand node in the editor, hiding its content.'
    },
    expandDefaultTitle: {
        id: 'fabric.editor.expandDefaultTitle',
        defaultMessage: 'Click here to expand...',
        description: 'Placeholder text shown in the title field of an expand node when no title has been entered, prompting the user to click and expand the content.'
    },
    expandNode: {
        id: 'fabric.editor.expandNode',
        defaultMessage: 'Expand content',
        description: 'The text is shown as a tooltip on a button when the user clicks to expand a collapsed expand node in the editor, revealing its content.'
    },
    expandPlaceholderText: {
        id: 'fabric.editor.expandPlaceholder',
        defaultMessage: 'Give this expand a title...',
        description: 'Placeholder text for an expand node title input field'
    },
    expandArialabel: {
        id: 'fabric.editor.expandAriaLabel',
        defaultMessage: 'Give this expand a title',
        description: 'aria label for an expand node title input field'
    },
    // Clean up with platform_editor_expand_content_a11y_2.
    expandBodyAriaLabelOriginal: {
        id: 'fabric.editor.expandBodyAriaLabel',
        defaultMessage: 'Expand body content',
        description: 'Aria label for the body content of an expand node'
    },
    expandBodyAriaLabel: {
        id: 'editor-common.Expand.expandBodyAriaLabel',
        defaultMessage: 'Body content for {title}',
        description: 'Aria label for the body content of an expand node'
    },
    expandBodyAriaLabelUntitled: {
        id: 'editor-common.Expand.expandBodyAriaLabelUntitled',
        defaultMessage: 'untitled expand',
        description: 'Fallback title for the body content of an expand node without a title'
    },
    expandBodyAriaDescription: {
        id: 'fabric.editor.expandBodyAriaDescription',
        defaultMessage: 'Enter the content that will be revealed when this expand is opened.',
        description: 'Aria description for the body content of an expand node'
    },
    expandBodyRoleDescription: {
        id: 'fabric.editor.expandBodyRoleDescription',
        defaultMessage: 'macro',
        description: 'Aria role description for the body content of an expand node'
    }
});
const $01d069a5aac987f1$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: ()=>expanded ? [
                $01d069a5aac987f1$var$expandIconWrapperStyle(),
                $01d069a5aac987f1$var$expandIconWrapperExpandedStyle
            ] : $01d069a5aac987f1$var$expandIconWrapperStyle()
    }, children);
};
const $01d069a5aac987f1$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $jctmk.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $014x6.akEditorSwoopCubicBezier)}`
        }
    });
const $01d069a5aac987f1$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $01d069a5aac987f1$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $01d069a5aac987f1$export$c67faf67c1185cba = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $01d069a5aac987f1$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});

});

parcelRegister("9iQMP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c38ef1bf4d6e29ea$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dS86g = parcelRequire("dS86g");

var $7aaSq = parcelRequire("7aaSq");
function $c38ef1bf4d6e29ea$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7aaSq.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dS86g))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("dpjXT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::572305b998c439047b1ac624fa78e28b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c2d18cc176e6e86$var$_react = $9c2d18cc176e6e86$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9c2d18cc176e6e86$var$_iconNew = $9c2d18cc176e6e86$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9c2d18cc176e6e86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/whiteboard
 * Usage guidance:
 * Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c2d18cc176e6e86$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $9c2d18cc176e6e86$var$_react.default.createElement($9c2d18cc176e6e86$var$_iconNew.default, Object.assign({
        name: "WhiteboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$9c2d18cc176e6e86$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $9c2d18cc176e6e86$var$_default = module.exports.default = $9c2d18cc176e6e86$var$WhiteboardIcon;

});

parcelRegister("bbssL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab7816171fed87d9a608211bee0e0796>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8246cce92ce4bc14$var$_react = $8246cce92ce4bc14$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $8246cce92ce4bc14$var$_iconNew = $8246cce92ce4bc14$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $8246cce92ce4bc14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextCenter".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-center
 * Usage guidance:
 * Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8246cce92ce4bc14$var$AlignTextCenterIcon = (props)=>/*#__PURE__*/ $8246cce92ce4bc14$var$_react.default.createElement($8246cce92ce4bc14$var$_iconNew.default, Object.assign({
        name: "AlignTextCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 3.5H4V2h8zm3 5.25H1v-1.5h14zM12 14H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$8246cce92ce4bc14$var$AlignTextCenterIcon.displayName = 'AlignTextCenterIcon';
var $8246cce92ce4bc14$var$_default = module.exports.default = $8246cce92ce4bc14$var$AlignTextCenterIcon;

});

parcelRegister("cqf2i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a36c3184c18665c26dfb7db95698b9af>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90b393978ee25a9f$var$_react = $90b393978ee25a9f$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $90b393978ee25a9f$var$_iconNew = $90b393978ee25a9f$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $90b393978ee25a9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/align-text-right
 * Usage guidance:
 * Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90b393978ee25a9f$var$AlignTextRightIcon = (props)=>/*#__PURE__*/ $90b393978ee25a9f$var$_react.default.createElement($90b393978ee25a9f$var$_iconNew.default, Object.assign({
        name: "AlignTextRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H8v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$90b393978ee25a9f$var$AlignTextRightIcon.displayName = 'AlignTextRightIcon';
var $90b393978ee25a9f$var$_default = module.exports.default = $90b393978ee25a9f$var$AlignTextRightIcon;

});

parcelRegister("gBMlX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7e789de9ffb828a5785c4954dbfb813>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1759bfe62c2827c$var$_react = $c1759bfe62c2827c$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $c1759bfe62c2827c$var$_iconNew = $c1759bfe62c2827c$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $c1759bfe62c2827c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-center
 * Usage guidance:
 * Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1759bfe62c2827c$var$AlignImageCenterIcon = (props)=>/*#__PURE__*/ $c1759bfe62c2827c$var$_react.default.createElement($c1759bfe62c2827c$var$_iconNew.default, Object.assign({
        name: "AlignImageCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-8.5 4v3h3v-3zM6.375 5h3.25C10.385 5 11 5.616 11 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 11 5 10.384 5 9.625v-3.25C5 5.615 5.616 5 6.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$c1759bfe62c2827c$var$AlignImageCenterIcon.displayName = 'AlignImageCenterIcon';
var $c1759bfe62c2827c$var$_default = module.exports.default = $c1759bfe62c2827c$var$AlignImageCenterIcon;

});

parcelRegister("4qPnd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f0dc0e9a1d8ab9bc4e6a31098b6f2fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33a170d1b7a52df9$var$_react = $33a170d1b7a52df9$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $33a170d1b7a52df9$var$_iconNew = $33a170d1b7a52df9$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $33a170d1b7a52df9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-left
 * Usage guidance:
 * Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33a170d1b7a52df9$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $33a170d1b7a52df9$var$_react.default.createElement($33a170d1b7a52df9$var$_iconNew.default, Object.assign({
        name: "AlignImageLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$33a170d1b7a52df9$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $33a170d1b7a52df9$var$_default = module.exports.default = $33a170d1b7a52df9$var$AlignImageLeftIcon;

});

parcelRegister("b1V3P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::363ad103c09d1ad4a29a90276bbc91d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $807c0cc9d456dfd0$var$_react = $807c0cc9d456dfd0$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $807c0cc9d456dfd0$var$_iconNew = $807c0cc9d456dfd0$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $807c0cc9d456dfd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/align-image-right
 * Usage guidance:
 * Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $807c0cc9d456dfd0$var$AlignImageRightIcon = (props)=>/*#__PURE__*/ $807c0cc9d456dfd0$var$_react.default.createElement($807c0cc9d456dfd0$var$_iconNew.default, Object.assign({
        name: "AlignImageRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$807c0cc9d456dfd0$var$AlignImageRightIcon.displayName = 'AlignImageRightIcon';
var $807c0cc9d456dfd0$var$_default = module.exports.default = $807c0cc9d456dfd0$var$AlignImageRightIcon;

});

parcelRegister("bY7Ml", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f38f1db86e7b7e5a1df46515f47bbd95>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b6b54fe0ef96f79$var$_react = $8b6b54fe0ef96f79$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $8b6b54fe0ef96f79$var$_iconNew = $8b6b54fe0ef96f79$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $8b6b54fe0ef96f79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/paint-bucket
 * Usage guidance:
 * Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b6b54fe0ef96f79$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $8b6b54fe0ef96f79$var$_react.default.createElement($8b6b54fe0ef96f79$var$_iconNew.default, Object.assign({
        name: "PaintBucketIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 1.94 6.78.66A1.38 1.38 0 0 1 8.62.57l.11.09 5.62 5.62a1.38 1.38 0 0 1 0 1.95l-5.73 5.73a2.63 2.63 0 0 1-3.71 0l-3.85-3.85a2.63 2.63 0 0 1 0-3.71L4.44 3 2.6 1.15 3.66.09zM1.81 8.5c.05.2.14.39.3.55l3.85 3.85c.44.44 1.15.44 1.59 0l4.39-4.39zM6.57 3l1.22 1.22-1.06 1.06L5.5 4.06 2.56 7h10.38L7.75 1.81zm7.68 8.25c.27 0 .52.14.65.38v.01l.01.02.03.06.12.21c.1.18.23.42.36.68s.27.55.37.82c.09.23.21.56.21.86 0 .97-.8 1.73-1.75 1.73s-1.75-.75-1.75-1.72c0-.29.12-.63.21-.86.11-.27.24-.56.37-.82s.26-.5.36-.68l.12-.21.03-.06.01-.02v-.01a.75.75 0 0 1 .65-.38"/>`
    }, props));
$8b6b54fe0ef96f79$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $8b6b54fe0ef96f79$var$_default = module.exports.default = $8b6b54fe0ef96f79$var$PaintBucketIcon;

});

parcelRegister("e6uCS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd19492838c8bf6d2562d3c6e1f4b1c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a44961effd2475e7$var$_react = $a44961effd2475e7$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a44961effd2475e7$var$_iconNew = $a44961effd2475e7$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a44961effd2475e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextBold".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-bold
 * Usage guidance:
 * Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a44961effd2475e7$var$TextBoldIcon = (props)=>/*#__PURE__*/ $a44961effd2475e7$var$_react.default.createElement($a44961effd2475e7$var$_iconNew.default, Object.assign({
        name: "TextBoldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.125C3 1.504 3.504 1 4.125 1H8.75C11.004 1 13 2.626 13 5.063a3.93 3.93 0 0 1-.855 2.492A3.92 3.92 0 0 1 14 10.938C14 13.374 12.004 15 9.75 15H4.125A1.125 1.125 0 0 1 3 13.875zm5.75 4.75c1.198 0 2-.798 2-1.812s-.802-1.813-2-1.813h-3.5v3.625zm-3.5 2.25h4.5c1.198 0 2 .798 2 1.813s-.802 1.812-2 1.812h-4.5z" clip-rule="evenodd"/>`
    }, props));
$a44961effd2475e7$var$TextBoldIcon.displayName = 'TextBoldIcon';
var $a44961effd2475e7$var$_default = module.exports.default = $a44961effd2475e7$var$TextBoldIcon;

});

parcelRegister("16zRT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c78712d633a3463bd40c9b97dadf0e09>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ce22cac55a3f08b$var$_react = $0ce22cac55a3f08b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $0ce22cac55a3f08b$var$_iconNew = $0ce22cac55a3f08b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $0ce22cac55a3f08b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shrink-horizontal
 * Usage guidance:
 * Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ce22cac55a3f08b$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $0ce22cac55a3f08b$var$_react.default.createElement($0ce22cac55a3f08b$var$_iconNew.default, Object.assign({
        name: "ShrinkHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$0ce22cac55a3f08b$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $0ce22cac55a3f08b$var$_default = module.exports.default = $0ce22cac55a3f08b$var$ShrinkHorizontalIcon;

});

parcelRegister("euVgq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f554af16de9998b4fc80f1fde7a03b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8e0497a0270ddda$var$_react = $a8e0497a0270ddda$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a8e0497a0270ddda$var$_iconNew = $a8e0497a0270ddda$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a8e0497a0270ddda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/grow-horizontal
 * Usage guidance:
 * Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8e0497a0270ddda$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $a8e0497a0270ddda$var$_react.default.createElement($a8e0497a0270ddda$var$_iconNew.default, Object.assign({
        name: "GrowHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a8e0497a0270ddda$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $a8e0497a0270ddda$var$_default = module.exports.default = $a8e0497a0270ddda$var$GrowHorizontalIcon;

});

parcelRegister("glLfW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57bb91851f2608c878b3bf5cfef0f2ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be734398d86db89a$var$_react = $be734398d86db89a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $be734398d86db89a$var$_iconNew = $be734398d86db89a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $be734398d86db89a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Maximize".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/maximize
 * Usage guidance:
 * Single purpose - Reserved for resizing screens, panels, modals, or media to its maximum size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be734398d86db89a$var$MaximizeIcon = (props)=>/*#__PURE__*/ $be734398d86db89a$var$_react.default.createElement($be734398d86db89a$var$_iconNew.default, Object.assign({
        name: "MaximizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zm-2-.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM8 4H4.75a.75.75 0 0 0-.75.75V8h1.5V5.5H8zm2.5 6.5V8H12v3.25a.75.75 0 0 1-.75.75H8v-1.5z" clip-rule="evenodd"/>`
    }, props));
$be734398d86db89a$var$MaximizeIcon.displayName = 'MaximizeIcon';
var $be734398d86db89a$var$_default = module.exports.default = $be734398d86db89a$var$MaximizeIcon;

});

parcelRegister("73XdT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c2370ad8f2d629cac1adc2a88058b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5246c0ab92a1930b$var$_react = $5246c0ab92a1930b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5246c0ab92a1930b$var$_iconNew = $5246c0ab92a1930b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5246c0ab92a1930b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-indent-right
 * Usage guidance:
 * Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5246c0ab92a1930b$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $5246c0ab92a1930b$var$_react.default.createElement($5246c0ab92a1930b$var$_iconNew.default, Object.assign({
        name: "TextIndentRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.03 4.72l2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L3.19 8 .97 5.78zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zm0 2.667V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$5246c0ab92a1930b$var$TextIndentRightIcon.displayName = 'TextIndentRightIcon';
var $5246c0ab92a1930b$var$_default = module.exports.default = $5246c0ab92a1930b$var$TextIndentRightIcon;

});

parcelRegister("4nSJV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::266cfa8a244e6a03d3f71862db1654df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3313c59938755917$var$_react = $3313c59938755917$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $3313c59938755917$var$_iconNew = $3313c59938755917$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $3313c59938755917$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextItalic".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-italic
 * Usage guidance:
 * Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3313c59938755917$var$TextItalicIcon = (props)=>/*#__PURE__*/ $3313c59938755917$var$_react.default.createElement($3313c59938755917$var$_iconNew.default, Object.assign({
        name: "TextItalicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h6.5v1.5h-2.409l-2.64 11H10V15H3.5v-1.5h2.409l2.64-11H6z" clip-rule="evenodd"/>`
    }, props));
$3313c59938755917$var$TextItalicIcon.displayName = 'TextItalicIcon';
var $3313c59938755917$var$_default = module.exports.default = $3313c59938755917$var$TextItalicIcon;

});

parcelRegister("f9Uoo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a646c20da4c58fe32e3018bb3269735d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b09370a7e4fe5a04$var$_react = $b09370a7e4fe5a04$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b09370a7e4fe5a04$var$_iconNew = $b09370a7e4fe5a04$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b09370a7e4fe5a04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutOneColumn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-one-column
 * Usage guidance:
 * Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b09370a7e4fe5a04$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $b09370a7e4fe5a04$var$_react.default.createElement($b09370a7e4fe5a04$var$_iconNew.default, Object.assign({
        name: "LayoutOneColumnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h13.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 15 0 14.384 0 13.625zm1.5.125v11h13v-11z" clip-rule="evenodd"/>`
    }, props));
$b09370a7e4fe5a04$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
var $b09370a7e4fe5a04$var$_default = module.exports.default = $b09370a7e4fe5a04$var$LayoutOneColumnIcon;

});

parcelRegister("5xh1u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c93698a16267611d6fb579c008d00c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $407d3d3cf29ac90a$var$_react = $407d3d3cf29ac90a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $407d3d3cf29ac90a$var$_iconNew = $407d3d3cf29ac90a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $407d3d3cf29ac90a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-three-columns
 * Usage guidance:
 * Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $407d3d3cf29ac90a$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $407d3d3cf29ac90a$var$_react.default.createElement($407d3d3cf29ac90a$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$407d3d3cf29ac90a$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $407d3d3cf29ac90a$var$_default = module.exports.default = $407d3d3cf29ac90a$var$LayoutThreeColumnsIcon;

});

parcelRegister("ewmvX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a2ebfcfec4a83dd52309bf27259f43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a92584bff2a09240$var$_react = $a92584bff2a09240$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a92584bff2a09240$var$_iconNew = $a92584bff2a09240$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a92584bff2a09240$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebars".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-three-columns-sidebars
 * Usage guidance:
 * Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a92584bff2a09240$var$LayoutThreeColumnsSidebarsIcon = (props)=>/*#__PURE__*/ $a92584bff2a09240$var$_react.default.createElement($a92584bff2a09240$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h3.25C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 15 5 14.384 5 13.625zm1.5.125v11h3v-11zm6-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$a92584bff2a09240$var$LayoutThreeColumnsSidebarsIcon.displayName = 'LayoutThreeColumnsSidebarsIcon';
var $a92584bff2a09240$var$_default = module.exports.default = $a92584bff2a09240$var$LayoutThreeColumnsSidebarsIcon;

});

parcelRegister("f4Ysc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27a7fabc1fabdcec8784e5ae291a6333>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa61f9d7a00ac91$var$_react = $afa61f9d7a00ac91$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $afa61f9d7a00ac91$var$_iconNew = $afa61f9d7a00ac91$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $afa61f9d7a00ac91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa61f9d7a00ac91$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $afa61f9d7a00ac91$var$_react.default.createElement($afa61f9d7a00ac91$var$_iconNew.default, Object.assign({
        name: "LayoutTwoColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h4.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5C.615 15 0 14.384 0 13.625zm1.5.125v11h4.25v-11zm7.25-.125c0-.76.616-1.375 1.375-1.375h4.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h4.25v-11z" clip-rule="evenodd"/>`
    }, props));
$afa61f9d7a00ac91$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $afa61f9d7a00ac91$var$_default = module.exports.default = $afa61f9d7a00ac91$var$LayoutTwoColumnsIcon;

});

parcelRegister("iu5bQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7426eac0679209b584652b7cacb52d34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d74f0dfaf4df0275$var$_react = $d74f0dfaf4df0275$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $d74f0dfaf4df0275$var$_iconNew = $d74f0dfaf4df0275$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $d74f0dfaf4df0275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns-sidebar-left
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d74f0dfaf4df0275$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $d74f0dfaf4df0275$var$_react.default.createElement($d74f0dfaf4df0275$var$_iconNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$d74f0dfaf4df0275$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $d74f0dfaf4df0275$var$_default = module.exports.default = $d74f0dfaf4df0275$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("gtxSA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::016771fe6116559afc90969f7cd64cf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfe9a2887d0e6e41$var$_react = $bfe9a2887d0e6e41$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $bfe9a2887d0e6e41$var$_iconNew = $bfe9a2887d0e6e41$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $bfe9a2887d0e6e41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/layout-two-columns-sidebar-right
 * Usage guidance:
 * Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfe9a2887d0e6e41$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $bfe9a2887d0e6e41$var$_react.default.createElement($bfe9a2887d0e6e41$var$_iconNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h7.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-7.75C.615 15 0 14.384 0 13.625zm1.5.125v11H9v-11zM12 2.375C12 1.615 12.616 1 13.375 1h1.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1v-11z" clip-rule="evenodd"/>`
    }, props));
$bfe9a2887d0e6e41$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
var $bfe9a2887d0e6e41$var$_default = module.exports.default = $bfe9a2887d0e6e41$var$LayoutTwoColumnsSidebarRightIcon;

});

parcelRegister("aRPz6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f30f1ece100e9c6940f39e1796a26132>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e96da6819d1c6cc$var$_react = $7e96da6819d1c6cc$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $7e96da6819d1c6cc$var$_iconNew = $7e96da6819d1c6cc$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $7e96da6819d1c6cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthNarrow".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-width-narrow
 * Usage guidance:
 * Single purpose - Reserved for setting media and content to a narrow width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e96da6819d1c6cc$var$ContentWidthNarrowIcon = (props)=>/*#__PURE__*/ $7e96da6819d1c6cc$var$_react.default.createElement($7e96da6819d1c6cc$var$_iconNew.default, Object.assign({
        name: "ContentWidthNarrowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5H2V1h12zm-10.5 3v5h9v-5zM3.375 4h9.25C13.385 4 14 4.616 14 5.375v5.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 12 2 11.384 2 10.625v-5.25C2 4.615 2.616 4 3.375 4M14 15H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$7e96da6819d1c6cc$var$ContentWidthNarrowIcon.displayName = 'ContentWidthNarrowIcon';
var $7e96da6819d1c6cc$var$_default = module.exports.default = $7e96da6819d1c6cc$var$ContentWidthNarrowIcon;

});

parcelRegister("g0VQ6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb735195a4450dbae1bbcfc30fb20c7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba898324fc054662$var$_react = $ba898324fc054662$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ba898324fc054662$var$_iconNew = $ba898324fc054662$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ba898324fc054662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/expand-horizontal
 * Usage guidance:
 * Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba898324fc054662$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $ba898324fc054662$var$_react.default.createElement($ba898324fc054662$var$_iconNew.default, Object.assign({
        name: "ExpandHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 1v14H0V1zM16 1v14h-1.5V1zm-1.72 6.47a.75.75 0 0 1 0 1.06l-3.25 3.25-1.06-1.06 1.97-1.97H4.06l1.97 1.97-1.06 1.06-3.25-3.25a.75.75 0 0 1 0-1.06l3.25-3.25 1.06 1.06-1.97 1.97h7.88L9.97 5.28l1.06-1.06z"/>`
    }, props));
$ba898324fc054662$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $ba898324fc054662$var$_default = module.exports.default = $ba898324fc054662$var$ExpandHorizontalIcon;

});

parcelRegister("gOZz1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b906b7c624205e45ee60c81e60477bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3f1122941db4007$var$_react = $c3f1122941db4007$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $c3f1122941db4007$var$_iconNew = $c3f1122941db4007$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $c3f1122941db4007$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-width-wide
 * Usage guidance:
 * Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3f1122941db4007$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $c3f1122941db4007$var$_react.default.createElement($c3f1122941db4007$var$_iconNew.default, Object.assign({
        name: "ContentWidthWideIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5H4V1h8zm-10.5 3v5h13v-5zM1.375 4h13.25C15.385 4 16 4.616 16 5.375v5.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 12 0 11.384 0 10.625v-5.25C0 4.615.616 4 1.375 4M12 15H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$c3f1122941db4007$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $c3f1122941db4007$var$_default = module.exports.default = $c3f1122941db4007$var$ContentWidthWideIcon;

});

parcelRegister("lzMCL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b4cab910924222021336600cfef472b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb5295998484d17d$var$_react = $fb5295998484d17d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $fb5295998484d17d$var$_iconNew = $fb5295998484d17d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $fb5295998484d17d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-wrap-left
 * Usage guidance:
 * Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb5295998484d17d$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $fb5295998484d17d$var$_react.default.createElement($fb5295998484d17d$var$_iconNew.default, Object.assign({
        name: "ContentWrapLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$fb5295998484d17d$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $fb5295998484d17d$var$_default = module.exports.default = $fb5295998484d17d$var$ContentWrapLeftIcon;

});

parcelRegister("3HbHS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef7c6107d1b27b47b5ef786d5a90cbe7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b0e77f1953fc6ac$var$_react = $2b0e77f1953fc6ac$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $2b0e77f1953fc6ac$var$_iconNew = $2b0e77f1953fc6ac$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $2b0e77f1953fc6ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/content-wrap-right
 * Usage guidance:
 * Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b0e77f1953fc6ac$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $2b0e77f1953fc6ac$var$_react.default.createElement($2b0e77f1953fc6ac$var$_iconNew.default, Object.assign({
        name: "ContentWrapRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M7 6.667H1v-1.5h6zm0 4.166H1v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$2b0e77f1953fc6ac$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $2b0e77f1953fc6ac$var$_default = module.exports.default = $2b0e77f1953fc6ac$var$ContentWrapRightIcon;

});

parcelRegister("da5lF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce6a9824d35ee82505b8acded17c6ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99505b9e7f15931e$var$_react = $99505b9e7f15931e$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $99505b9e7f15931e$var$_iconNew = $99505b9e7f15931e$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $99505b9e7f15931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/mention
 * Usage guidance:
 * Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99505b9e7f15931e$var$MentionIcon = (props)=>/*#__PURE__*/ $99505b9e7f15931e$var$_react.default.createElement($99505b9e7f15931e$var$_iconNew.default, Object.assign({
        name: "MentionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$99505b9e7f15931e$var$MentionIcon.displayName = 'MentionIcon';
var $99505b9e7f15931e$var$_default = module.exports.default = $99505b9e7f15931e$var$MentionIcon;

});

parcelRegister("fb551", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb0d2797cf5666e2287eff3bcf39de93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0cbd2e5fbe2967b$var$_react = $b0cbd2e5fbe2967b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b0cbd2e5fbe2967b$var$_iconNew = $b0cbd2e5fbe2967b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b0cbd2e5fbe2967b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/list-numbered
 * Usage guidance:
 * Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0cbd2e5fbe2967b$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $b0cbd2e5fbe2967b$var$_react.default.createElement($b0cbd2e5fbe2967b$var$_iconNew.default, Object.assign({
        name: "ListNumberedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 5H6V3.5h10zm0 7.5H6V11h10zM.5 1h1.75a.75.75 0 0 1 .75.75V7H1.5V2.5h-1zM0 8.5h2.63C3.39 8.5 4 9.12 4 9.88v1.25c0 .76-.62 1.38-1.37 1.38H1.5v1H4V15H.75a.75.75 0 0 1-.75-.75v-1.87C0 11.62.62 11 1.38 11H2.5v-1H0z" clip-rule="evenodd"/>`
    }, props));
$b0cbd2e5fbe2967b$var$ListNumberedIcon.displayName = 'ListNumberedIcon';
var $b0cbd2e5fbe2967b$var$_default = module.exports.default = $b0cbd2e5fbe2967b$var$ListNumberedIcon;

});

parcelRegister("4kG8a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cfb509a7f1979b2b736fe67208d0bad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3279b5f2b53b9930$var$_react = $3279b5f2b53b9930$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $3279b5f2b53b9930$var$_iconNew = $3279b5f2b53b9930$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $3279b5f2b53b9930$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-indent-left
 * Usage guidance:
 * Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3279b5f2b53b9930$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $3279b5f2b53b9930$var$_react.default.createElement($3279b5f2b53b9930$var$_iconNew.default, Object.assign({
        name: "TextIndentLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.81 8l2.22-2.22-1.06-1.06-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75 1.06-1.06zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$3279b5f2b53b9930$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIcon';
var $3279b5f2b53b9930$var$_default = module.exports.default = $3279b5f2b53b9930$var$TextIndentLeftIcon;

});

parcelRegister("nb6IT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e06a4b64daf6b9c430eec634bed57c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $045ac3cd89a8a98e$var$_react = $045ac3cd89a8a98e$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $045ac3cd89a8a98e$var$_iconNew = $045ac3cd89a8a98e$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $045ac3cd89a8a98e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/redo
 * Usage guidance:
 * Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $045ac3cd89a8a98e$var$RedoIcon = (props)=>/*#__PURE__*/ $045ac3cd89a8a98e$var$_react.default.createElement($045ac3cd89a8a98e$var$_iconNew.default, Object.assign({
        name: "RedoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 0 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$045ac3cd89a8a98e$var$RedoIcon.displayName = 'RedoIcon';
var $045ac3cd89a8a98e$var$_default = module.exports.default = $045ac3cd89a8a98e$var$RedoIcon;

});

parcelRegister("fFppY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b80b485d8f3151e8a189e7a1ca0b045>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b67e66d904af9c82$var$_react = $b67e66d904af9c82$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $b67e66d904af9c82$var$_iconNew = $b67e66d904af9c82$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $b67e66d904af9c82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/grid
 * Usage guidance:
 * Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b67e66d904af9c82$var$GridIcon = (props)=>/*#__PURE__*/ $b67e66d904af9c82$var$_react.default.createElement($b67e66d904af9c82$var$_iconNew.default, Object.assign({
        name: "GridIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$b67e66d904af9c82$var$GridIcon.displayName = 'GridIcon';
var $b67e66d904af9c82$var$_default = module.exports.default = $b67e66d904af9c82$var$GridIcon;

});

parcelRegister("kwbky", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0812cf7af63b42bd3bd830103e378223>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeff95d105a7369b$var$_react = $eeff95d105a7369b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $eeff95d105a7369b$var$_iconNew = $eeff95d105a7369b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $eeff95d105a7369b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-style
 * Usage guidance:
 * Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eeff95d105a7369b$var$TextStyleIcon = (props)=>/*#__PURE__*/ $eeff95d105a7369b$var$_react.default.createElement($eeff95d105a7369b$var$_iconNew.default, Object.assign({
        name: "TextStyleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$eeff95d105a7369b$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $eeff95d105a7369b$var$_default = module.exports.default = $eeff95d105a7369b$var$TextStyleIcon;

});

parcelRegister("eYfNt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::135f4c7bdbceeb077cf9a8a8ded75f12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae62ec3b4a29051c$var$_react = $ae62ec3b4a29051c$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ae62ec3b4a29051c$var$_iconNew = $ae62ec3b4a29051c$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ae62ec3b4a29051c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/undo
 * Usage guidance:
 * Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae62ec3b4a29051c$var$UndoIcon = (props)=>/*#__PURE__*/ $ae62ec3b4a29051c$var$_react.default.createElement($ae62ec3b4a29051c$var$_iconNew.default, Object.assign({
        name: "UndoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ae62ec3b4a29051c$var$UndoIcon.displayName = 'UndoIcon';
var $ae62ec3b4a29051c$var$_default = module.exports.default = $ae62ec3b4a29051c$var$UndoIcon;

});

parcelRegister("h3M1Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d45545d418279a0953f605b02a0f6e7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6b7f9793ea2abea$var$_react = $c6b7f9793ea2abea$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $c6b7f9793ea2abea$var$_iconNew = $c6b7f9793ea2abea$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $c6b7f9793ea2abea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/work-items
 * Usage guidance:
 * Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6b7f9793ea2abea$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $c6b7f9793ea2abea$var$_react.default.createElement($c6b7f9793ea2abea$var$_iconNew.default, Object.assign({
        name: "WorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$c6b7f9793ea2abea$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $c6b7f9793ea2abea$var$_default = module.exports.default = $c6b7f9793ea2abea$var$WorkItemsIcon;

});

parcelRegister("3jAjk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f8dcfcce24cb1cbca3bd0f7d9ea3784>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $269f50008eba5f4d$var$_react = $269f50008eba5f4d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $269f50008eba5f4d$var$_iconNew = $269f50008eba5f4d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $269f50008eba5f4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-small
 * Usage guidance:
 * Reserved for representing thin border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $269f50008eba5f4d$var$StrokeWeightSmallIcon = (props)=>/*#__PURE__*/ $269f50008eba5f4d$var$_react.default.createElement($269f50008eba5f4d$var$_iconNew.default, Object.assign({
        name: "StrokeWeightSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0" clip-rule="evenodd"/>`
    }, props));
$269f50008eba5f4d$var$StrokeWeightSmallIcon.displayName = 'StrokeWeightSmallIcon';
var $269f50008eba5f4d$var$_default = module.exports.default = $269f50008eba5f4d$var$StrokeWeightSmallIcon;

});

parcelRegister("jQsma", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a86f4b205ac22b1546889eacd37f769a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e728deaa96b1123b$var$_react = $e728deaa96b1123b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e728deaa96b1123b$var$_iconNew = $e728deaa96b1123b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e728deaa96b1123b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-add
 * Usage guidance:
 * Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e728deaa96b1123b$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $e728deaa96b1123b$var$_react.default.createElement($e728deaa96b1123b$var$_iconNew.default, Object.assign({
        name: "EmojiAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$e728deaa96b1123b$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $e728deaa96b1123b$var$_default = module.exports.default = $e728deaa96b1123b$var$EmojiAddIcon;

});

parcelRegister("2ZNqo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95e148480949ecb8f2215f7268d6e3a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22e79dfc7f461598$var$_react = $22e79dfc7f461598$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $22e79dfc7f461598$var$_iconNew = $22e79dfc7f461598$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $22e79dfc7f461598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Accessibility".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/accessibility
 * Usage guidance:
 * Reserved for representing accessibility and accessibility-related features and settings
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22e79dfc7f461598$var$AccessibilityIcon = (props)=>/*#__PURE__*/ $22e79dfc7f461598$var$_react.default.createElement($22e79dfc7f461598$var$_iconNew.default, Object.assign({
        name: "AccessibilityIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A.75.75 0 1 0 8 4a.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M6.77 8H2V6.5h12V8H9.23l3.18 6.16-1.33.69L8 8.88l-3.08 5.96-1.33-.69z" clip-rule="evenodd"/>`
    }, props));
$22e79dfc7f461598$var$AccessibilityIcon.displayName = 'AccessibilityIcon';
var $22e79dfc7f461598$var$_default = module.exports.default = $22e79dfc7f461598$var$AccessibilityIcon;

});

parcelRegister("9tJhO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5d9d22b41ee491811e82fedd8cf80d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e69f3666c2a3b7b$var$_react = $6e69f3666c2a3b7b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $6e69f3666c2a3b7b$var$_iconNew = $6e69f3666c2a3b7b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $6e69f3666c2a3b7b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/apps
 * Usage guidance:
 * Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e69f3666c2a3b7b$var$AppsIcon = (props)=>/*#__PURE__*/ $6e69f3666c2a3b7b$var$_react.default.createElement($6e69f3666c2a3b7b$var$_iconNew.default, Object.assign({
        name: "AppsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm7.25-2v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5h2.25V9zM5.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0-8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$6e69f3666c2a3b7b$var$AppsIcon.displayName = 'AppsIcon';
var $6e69f3666c2a3b7b$var$_default = module.exports.default = $6e69f3666c2a3b7b$var$AppsIcon;

});

parcelRegister("1wGSa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed3e64ddc98c9818e2b632fa43be9778>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11ca093dac3e4800$var$_react = $11ca093dac3e4800$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $11ca093dac3e4800$var$_iconNew = $11ca093dac3e4800$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $11ca093dac3e4800$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Assets".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/assets
 * Usage guidance:
 * Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11ca093dac3e4800$var$AssetsIcon = (props)=>/*#__PURE__*/ $11ca093dac3e4800$var$_react.default.createElement($11ca093dac3e4800$var$_iconNew.default, Object.assign({
        name: "AssetsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.487 2.013a1.75 1.75 0 1 0-2.474 2.474 1.75 1.75 0 0 0 2.474-2.474M.952.952A3.25 3.25 0 0 1 6.412 2.5H9.5V4H6.413a3.24 3.24 0 0 1-.865 1.548c-.442.442-.98.73-1.548.865V9.5H2.5V6.413A3.25 3.25 0 0 1 .952.953M10.5 3.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m3 3.25v3H12v-3zM1 12.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m9.5 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m-1 .75h-3V12h3z" clip-rule="evenodd"/>`
    }, props));
$11ca093dac3e4800$var$AssetsIcon.displayName = 'AssetsIcon';
var $11ca093dac3e4800$var$_default = module.exports.default = $11ca093dac3e4800$var$AssetsIcon;

});

parcelRegister("lxh0w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff136a20504d88688371d92a86f2c77e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fad9df596064df7d$var$_react = $fad9df596064df7d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $fad9df596064df7d$var$_iconNew = $fad9df596064df7d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $fad9df596064df7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Border".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/border
 * Usage guidance:
 * Reserved for toggling the visibility of a border on an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fad9df596064df7d$var$BorderIcon = (props)=>/*#__PURE__*/ $fad9df596064df7d$var$_react.default.createElement($fad9df596064df7d$var$_iconNew.default, Object.assign({
        name: "BorderIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.5 8A.75.75 0 1 1 4 8a.75.75 0 0 1 1.5 0M12 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 12 8m-3.25 3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0-6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$fad9df596064df7d$var$BorderIcon.displayName = 'BorderIcon';
var $fad9df596064df7d$var$_default = module.exports.default = $fad9df596064df7d$var$BorderIcon;

});

parcelRegister("1tIeJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da700306fe9346a3fbf34e0d7fc8a9b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $113ad0590f9bc2d6$var$_react = $113ad0590f9bc2d6$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $113ad0590f9bc2d6$var$_iconNew = $113ad0590f9bc2d6$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $113ad0590f9bc2d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Card".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/card
 * Usage guidance:
 * Known uses: Representing cards in Trello. Toggling card detail in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $113ad0590f9bc2d6$var$CardIcon = (props)=>/*#__PURE__*/ $113ad0590f9bc2d6$var$_react.default.createElement($113ad0590f9bc2d6$var$_iconNew.default, Object.assign({
        name: "CardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V9h11v4a.5.5 0 0 1-.5.5zm10.5-6h-11V3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5zM4 12h5v-1.5H4zm6.5 0H12v-1.5h-1.5z" clip-rule="evenodd"/>`
    }, props));
$113ad0590f9bc2d6$var$CardIcon.displayName = 'CardIcon';
var $113ad0590f9bc2d6$var$_default = module.exports.default = $113ad0590f9bc2d6$var$CardIcon;

});

parcelRegister("ksrbj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a5273bf73a300c0a96580f2d60e5eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee4b81d34555ba67$var$_react = $ee4b81d34555ba67$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ee4b81d34555ba67$var$_iconNew = $ee4b81d34555ba67$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ee4b81d34555ba67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clipboard".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clipboard
 * Usage guidance:
 * Known uses: Pasting content from clipboard.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee4b81d34555ba67$var$ClipboardIcon = (props)=>/*#__PURE__*/ $ee4b81d34555ba67$var$_react.default.createElement($ee4b81d34555ba67$var$_iconNew.default, Object.assign({
        name: "ClipboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.563 1.5A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.937 1.5H12.5a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2zM4.5 3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75zm2-1.5A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$ee4b81d34555ba67$var$ClipboardIcon.displayName = 'ClipboardIcon';
var $ee4b81d34555ba67$var$_default = module.exports.default = $ee4b81d34555ba67$var$ClipboardIcon;

});

parcelRegister("bEgPE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7dc2367d51e33d9821000c60dc59b5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b07c9fab774703$var$_react = $87b07c9fab774703$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $87b07c9fab774703$var$_iconNew = $87b07c9fab774703$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $87b07c9fab774703$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/emoji-remove
 * Usage guidance:
 * Reserved for removing emoji.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87b07c9fab774703$var$EmojiRemoveIcon = (props)=>/*#__PURE__*/ $87b07c9fab774703$var$_react.default.createElement($87b07c9fab774703$var$_iconNew.default, Object.assign({
        name: "EmojiRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.72 13.9 1.12 1.12A8 8 0 0 1 .98 4.16L2.1 5.28a6.5 6.5 0 0 0 8.63 8.63M8 0C6.61 0 5.3.36 4.16.98L5.28 2.1a6.5 6.5 0 0 1 8.63 8.63l1.12 1.12A8 8 0 0 0 8 0"/><path fill="currentcolor" d="m9.06 5.88 1.57 1.57a1.25 1.25 0 1 0-1.57-1.57m-2.97 4.15c.38.3.87.57 1.44.67l1.43 1.43c-.3.07-.62.11-.96.11-1.23 0-2.2-.54-2.83-1.03a6 6 0 0 1-.94-.92l-.06-.07-.02-.02-.01-.01.61-.44.61-.44.01.01.03.04q.05.06.14.16c.13.14.31.33.55.51M.47 1.53l14 14 1.06-1.06-14-14z"/>`
    }, props));
$87b07c9fab774703$var$EmojiRemoveIcon.displayName = 'EmojiRemoveIcon';
var $87b07c9fab774703$var$_default = module.exports.default = $87b07c9fab774703$var$EmojiRemoveIcon;

});

parcelRegister("68NNn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b14cef514625053097dfa4d10359700b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $478a1dc085d58f83$var$_react = $478a1dc085d58f83$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $478a1dc085d58f83$var$_iconNew = $478a1dc085d58f83$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $478a1dc085d58f83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldCheckboxGroup".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/field-checkbox-group
 * Usage guidance:
 * Known uses: Checkbox group field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $478a1dc085d58f83$var$FieldCheckboxGroupIcon = (props)=>/*#__PURE__*/ $478a1dc085d58f83$var$_react.default.createElement($478a1dc085d58f83$var$_iconNew.default, Object.assign({
        name: "FieldCheckboxGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75A.75.75 0 0 1 1.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 1 6.25zm1.5.75v2h2v-2zM16 5.25H8v-1.5h8zM1 9.75A.75.75 0 0 1 1.75 9h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75zm1.5.75v2h2v-2zM16 12.25H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$478a1dc085d58f83$var$FieldCheckboxGroupIcon.displayName = 'FieldCheckboxGroupIcon';
var $478a1dc085d58f83$var$_default = module.exports.default = $478a1dc085d58f83$var$FieldCheckboxGroupIcon;

});

parcelRegister("lgkbT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c95e3b2b5922216d1b08416f0f7380e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7aac1174f064064$var$_react = $f7aac1174f064064$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $f7aac1174f064064$var$_iconNew = $f7aac1174f064064$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $f7aac1174f064064$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageFullscreen".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/image-fullscreen
 * Usage guidance:
 * Reserved for viewing an image in a fullscreen view or modal.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7aac1174f064064$var$ImageFullscreenIcon = (props)=>/*#__PURE__*/ $f7aac1174f064064$var$_react.default.createElement($f7aac1174f064064$var$_iconNew.default, Object.assign({
        name: "ImageFullscreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 1.5H5V0H1.375C.615 0 0 .616 0 1.375V5h1.5zM3 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h.633l2.892-3.719a1.375 1.375 0 0 1 1.927-.244l1.048.81V5a.5.5 0 0 0-.5-.5zm6.5 5.743L9.633 8.801l-2.1 2.699H11a.5.5 0 0 0 .5-.5zM16 11v3.625c0 .76-.616 1.375-1.375 1.375H11v-1.5h3.5V11z" clip-rule="evenodd"/><path fill="currentcolor" d="M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f7aac1174f064064$var$ImageFullscreenIcon.displayName = 'ImageFullscreenIcon';
var $f7aac1174f064064$var$_default = module.exports.default = $f7aac1174f064064$var$ImageFullscreenIcon;

});

parcelRegister("djINe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::558c104ff8faf5b48aac0a9ed58ae604>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b1fcbb028a04d4a$var$_react = $9b1fcbb028a04d4a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9b1fcbb028a04d4a$var$_iconNew = $9b1fcbb028a04d4a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9b1fcbb028a04d4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageInline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/image-inline
 * Usage guidance:
 * Reserved for representing inline images in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b1fcbb028a04d4a$var$ImageInlineIcon = (props)=>/*#__PURE__*/ $9b1fcbb028a04d4a$var$_react.default.createElement($9b1fcbb028a04d4a$var$_iconNew.default, Object.assign({
        name: "ImageInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6.375C0 5.615.616 5 1.375 5h3.25C5.385 5 6 5.616 6 6.375v3.25C6 10.385 5.384 11 4.625 11h-3.25C.615 11 0 10.384 0 9.625zm1.5.125v3h3v-3zM16 8.75H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$9b1fcbb028a04d4a$var$ImageInlineIcon.displayName = 'ImageInlineIcon';
var $9b1fcbb028a04d4a$var$_default = module.exports.default = $9b1fcbb028a04d4a$var$ImageInlineIcon;

});

parcelRegister("3Oq8F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98a7fb9d1f8215942557835e8fe15757>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c6a513bf66f6d40$var$_react = $2c6a513bf66f6d40$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $2c6a513bf66f6d40$var$_iconNew = $2c6a513bf66f6d40$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $2c6a513bf66f6d40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/megaphone
 * Usage guidance:
 * Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c6a513bf66f6d40$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $2c6a513bf66f6d40$var$_react.default.createElement($2c6a513bf66f6d40$var$_iconNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$2c6a513bf66f6d40$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $2c6a513bf66f6d40$var$_default = module.exports.default = $2c6a513bf66f6d40$var$MegaphoneIcon;

});

parcelRegister("aLsi9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a080bf20295b7d277e5525fa21e7a7cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d643d58a2c8eca1$var$_react = $7d643d58a2c8eca1$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $7d643d58a2c8eca1$var$_iconNew = $7d643d58a2c8eca1$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $7d643d58a2c8eca1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Note".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/note
 * Usage guidance:
 * Single purpose - Reserved for notes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d643d58a2c8eca1$var$NoteIcon = (props)=>/*#__PURE__*/ $7d643d58a2c8eca1$var$_react.default.createElement($7d643d58a2c8eca1$var$_iconNew.default, Object.assign({
        name: "NoteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 15H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6V9.75A.75.75 0 0 1 9.75 9h3.75V3a.5.5 0 0 0-.5-.5zm9.94 8H10.5v2.44zM11 6H4V4.5h7zM7 9.5H4V8h3z" clip-rule="evenodd"/>`
    }, props));
$7d643d58a2c8eca1$var$NoteIcon.displayName = 'NoteIcon';
var $7d643d58a2c8eca1$var$_default = module.exports.default = $7d643d58a2c8eca1$var$NoteIcon;

});

parcelRegister("ksbIv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::094fe57c93517a6ea39f3973813cfaec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3f82e87c93facd$var$_react = $ee3f82e87c93facd$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $ee3f82e87c93facd$var$_iconNew = $ee3f82e87c93facd$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $ee3f82e87c93facd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pin".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/pin
 * Usage guidance:
 * Known uses: unpinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3f82e87c93facd$var$PinIcon = (props)=>/*#__PURE__*/ $ee3f82e87c93facd$var$_react.default.createElement($ee3f82e87c93facd$var$_iconNew.default, Object.assign({
        name: "PinIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864a.75.75 0 0 0-.106.386V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$ee3f82e87c93facd$var$PinIcon.displayName = 'PinIcon';
var $ee3f82e87c93facd$var$_default = module.exports.default = $ee3f82e87c93facd$var$PinIcon;

});

parcelRegister("a29qj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25371e7e1c229a6eed686770dc07063d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74e1668d0391ad3a$var$_react = $74e1668d0391ad3a$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $74e1668d0391ad3a$var$_iconNew = $74e1668d0391ad3a$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $74e1668d0391ad3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PinFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/pin-filled
 * Usage guidance:
 * Known uses: pinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74e1668d0391ad3a$var$PinFilledIcon = (props)=>/*#__PURE__*/ $74e1668d0391ad3a$var$_react.default.createElement($74e1668d0391ad3a$var$_iconNew.default, Object.assign({
        name: "PinFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/><path fill="currentcolor" d="m9.606 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$74e1668d0391ad3a$var$PinFilledIcon.displayName = 'PinFilledIcon';
var $74e1668d0391ad3a$var$_default = module.exports.default = $74e1668d0391ad3a$var$PinFilledIcon;

});

parcelRegister("bTymE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfa2cf486e4aacf3a93b8dc816f49bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a8f7cd4845fa674$var$_react = $8a8f7cd4845fa674$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $8a8f7cd4845fa674$var$_iconNew = $8a8f7cd4845fa674$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $8a8f7cd4845fa674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkCard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-card
 * Usage guidance:
 * Reserved for representing Smart link preview cards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a8f7cd4845fa674$var$SmartLinkCardIcon = (props)=>/*#__PURE__*/ $8a8f7cd4845fa674$var$_react.default.createElement($8a8f7cd4845fa674$var$_iconNew.default, Object.assign({
        name: "SmartLinkCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8v-7zm9.5 0v7H14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM0 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5H3V6h5.5zM6 10H3V8.5h3z" clip-rule="evenodd"/>`
    }, props));
$8a8f7cd4845fa674$var$SmartLinkCardIcon.displayName = 'SmartLinkCardIcon';
var $8a8f7cd4845fa674$var$_default = module.exports.default = $8a8f7cd4845fa674$var$SmartLinkCardIcon;

});

parcelRegister("dyHxB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::91eb3cc88ce44a200106439f98b1c931>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9df039b15151558d$var$_react = $9df039b15151558d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9df039b15151558d$var$_iconNew = $9df039b15151558d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9df039b15151558d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkEmbed".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-embed
 * Usage guidance:
 * Reserved for representing Smart link embeds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9df039b15151558d$var$SmartLinkEmbedIcon = (props)=>/*#__PURE__*/ $9df039b15151558d$var$_react.default.createElement($9df039b15151558d$var$_iconNew.default, Object.assign({
        name: "SmartLinkEmbedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4h11V3a.5.5 0 0 0-.5-.5zm10.5 6h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zm-8-3H4V4h1.5zm6.5 0H7V4h5z" clip-rule="evenodd"/>`
    }, props));
$9df039b15151558d$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
var $9df039b15151558d$var$_default = module.exports.default = $9df039b15151558d$var$SmartLinkEmbedIcon;

});

parcelRegister("4Ll4N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37aef58481faa7bf408ae8e16cd35331>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $377be68d36a2075d$var$_react = $377be68d36a2075d$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $377be68d36a2075d$var$_iconNew = $377be68d36a2075d$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $377be68d36a2075d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkInline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-inline
 * Usage guidance:
 * Reserved for representing inline Smart link lozenges.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $377be68d36a2075d$var$SmartLinkInlineIcon = (props)=>/*#__PURE__*/ $377be68d36a2075d$var$_react.default.createElement($377be68d36a2075d$var$_iconNew.default, Object.assign({
        name: "SmartLinkInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.5v-3zm4 0v3h8a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$377be68d36a2075d$var$SmartLinkInlineIcon.displayName = 'SmartLinkInlineIcon';
var $377be68d36a2075d$var$_default = module.exports.default = $377be68d36a2075d$var$SmartLinkInlineIcon;

});

parcelRegister("lB61D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc3dca90319e7388db9e2dce4ed3d07c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb91ba341564a608$var$_react = $fb91ba341564a608$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $fb91ba341564a608$var$_iconNew = $fb91ba341564a608$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $fb91ba341564a608$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/smart-link-list
 * Usage guidance:
 * Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb91ba341564a608$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $fb91ba341564a608$var$_react.default.createElement($fb91ba341564a608$var$_iconNew.default, Object.assign({
        name: "SmartLinkListIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$fb91ba341564a608$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $fb91ba341564a608$var$_default = module.exports.default = $fb91ba341564a608$var$SmartLinkListIcon;

});

parcelRegister("cMkOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b21529f89f7d042240b8c37cbada8167>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94da1e4721e02aa4$var$_react = $94da1e4721e02aa4$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $94da1e4721e02aa4$var$_iconNew = $94da1e4721e02aa4$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $94da1e4721e02aa4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightLarge".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-large
 * Usage guidance:
 * Reserved for representing thick border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94da1e4721e02aa4$var$StrokeWeightLargeIcon = (props)=>/*#__PURE__*/ $94da1e4721e02aa4$var$_react.default.createElement($94da1e4721e02aa4$var$_iconNew.default, Object.assign({
        name: "StrokeWeightLargeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0" clip-rule="evenodd"/>`
    }, props));
$94da1e4721e02aa4$var$StrokeWeightLargeIcon.displayName = 'StrokeWeightLargeIcon';
var $94da1e4721e02aa4$var$_default = module.exports.default = $94da1e4721e02aa4$var$StrokeWeightLargeIcon;

});

parcelRegister("5Kt9Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18d5d901ba554d7c6cf9038d41b45bd8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42f7de326c4477fb$var$_react = $42f7de326c4477fb$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $42f7de326c4477fb$var$_iconNew = $42f7de326c4477fb$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $42f7de326c4477fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/stroke-weight-medium
 * Usage guidance:
 * Reserved for representing medium border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42f7de326c4477fb$var$StrokeWeightMediumIcon = (props)=>/*#__PURE__*/ $42f7de326c4477fb$var$_react.default.createElement($42f7de326c4477fb$var$_iconNew.default, Object.assign({
        name: "StrokeWeightMediumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 8a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0" clip-rule="evenodd"/>`
    }, props));
$42f7de326c4477fb$var$StrokeWeightMediumIcon.displayName = 'StrokeWeightMediumIcon';
var $42f7de326c4477fb$var$_default = module.exports.default = $42f7de326c4477fb$var$StrokeWeightMediumIcon;

});

parcelRegister("8SESw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37466cf4f5caccf974d8190845f39f40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6773137eb458b1e1$var$_react = $6773137eb458b1e1$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $6773137eb458b1e1$var$_iconNew = $6773137eb458b1e1$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $6773137eb458b1e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellClear".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-clear
 * Usage guidance:
 * Reserved for clearing the contents of table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6773137eb458b1e1$var$TableCellClearIcon = (props)=>/*#__PURE__*/ $6773137eb458b1e1$var$_react.default.createElement($6773137eb458b1e1$var$_iconNew.default, Object.assign({
        name: "TableCellClearIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.94 4L5.22 6.28l1.06-1.06L8 6.94l1.72-1.72 1.06 1.06L9.06 8l1.72 1.72-1.06 1.06L8 9.06l-1.72 1.72-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$6773137eb458b1e1$var$TableCellClearIcon.displayName = 'TableCellClearIcon';
var $6773137eb458b1e1$var$_default = module.exports.default = $6773137eb458b1e1$var$TableCellClearIcon;

});

parcelRegister("cfqPz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd158ed63accbc15b06434c09d1e7688>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8eabb2c4c3397d1e$var$_react = $8eabb2c4c3397d1e$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $8eabb2c4c3397d1e$var$_iconNew = $8eabb2c4c3397d1e$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $8eabb2c4c3397d1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellMerge".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-merge
 * Usage guidance:
 * Reserved for merging table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8eabb2c4c3397d1e$var$TableCellMergeIcon = (props)=>/*#__PURE__*/ $8eabb2c4c3397d1e$var$_react.default.createElement($8eabb2c4c3397d1e$var$_iconNew.default, Object.assign({
        name: "TableCellMergeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zm12 0H9V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M5.19 8 3.47 6.28l1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06zm4.03-.53 2.25-2.25 1.06 1.06L10.81 8l1.72 1.72-1.06 1.06-2.25-2.25a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$8eabb2c4c3397d1e$var$TableCellMergeIcon.displayName = 'TableCellMergeIcon';
var $8eabb2c4c3397d1e$var$_default = module.exports.default = $8eabb2c4c3397d1e$var$TableCellMergeIcon;

});

parcelRegister("ekgS0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6901c67cca80c8242be2d93fe8d4eb3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6e004fa032ba606$var$_react = $a6e004fa032ba606$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a6e004fa032ba606$var$_iconNew = $a6e004fa032ba606$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a6e004fa032ba606$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-cell-split
 * Usage guidance:
 * Reserved for splitting joined table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6e004fa032ba606$var$TableCellSplitIcon = (props)=>/*#__PURE__*/ $a6e004fa032ba606$var$_react.default.createElement($a6e004fa032ba606$var$_iconNew.default, Object.assign({
        name: "TableCellSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 3.5H0V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5m6 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zM.22 7.47l2.25-2.25 1.06 1.06L1.81 8l1.72 1.72-1.06 1.06L.22 8.53a.75.75 0 0 1 0-1.06M14.19 8l-1.72-1.72 1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$a6e004fa032ba606$var$TableCellSplitIcon.displayName = 'TableCellSplitIcon';
var $a6e004fa032ba606$var$_default = module.exports.default = $a6e004fa032ba606$var$TableCellSplitIcon;

});

parcelRegister("3foDq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e99802f2e737020f4d265f3fccc6feba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25d5e1cd8c658b20$var$_react = $25d5e1cd8c658b20$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $25d5e1cd8c658b20$var$_iconNew = $25d5e1cd8c658b20$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $25d5e1cd8c658b20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-add-left
 * Usage guidance:
 * Reserved for adding a table column to the left of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25d5e1cd8c658b20$var$TableColumnAddLeftIcon = (props)=>/*#__PURE__*/ $25d5e1cd8c658b20$var$_react.default.createElement($25d5e1cd8c658b20$var$_iconNew.default, Object.assign({
        name: "TableColumnAddLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.75 8.75V11h-1.5V8.75H0v-1.5h2.25V5h1.5v2.25H6v1.5z" clip-rule="evenodd"/>`
    }, props));
$25d5e1cd8c658b20$var$TableColumnAddLeftIcon.displayName = 'TableColumnAddLeftIcon';
var $25d5e1cd8c658b20$var$_default = module.exports.default = $25d5e1cd8c658b20$var$TableColumnAddLeftIcon;

});

parcelRegister("hWLCD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d25eddbd59369a4dc35dfe0ed526458c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d10ccb329e5ef0ca$var$_react = $d10ccb329e5ef0ca$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $d10ccb329e5ef0ca$var$_iconNew = $d10ccb329e5ef0ca$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $d10ccb329e5ef0ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-add-right
 * Usage guidance:
 * Reserved for adding a table column to the right of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d10ccb329e5ef0ca$var$TableColumnAddRightIcon = (props)=>/*#__PURE__*/ $d10ccb329e5ef0ca$var$_react.default.createElement($d10ccb329e5ef0ca$var$_iconNew.default, Object.assign({
        name: "TableColumnAddRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.25 6.25V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5z" clip-rule="evenodd"/>`
    }, props));
$d10ccb329e5ef0ca$var$TableColumnAddRightIcon.displayName = 'TableColumnAddRightIcon';
var $d10ccb329e5ef0ca$var$_default = module.exports.default = $d10ccb329e5ef0ca$var$TableColumnAddRightIcon;

});

parcelRegister("iGIja", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d83f078545a7bbec3d743a76d746955>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9ae84e9cc622f9b$var$_react = $d9ae84e9cc622f9b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $d9ae84e9cc622f9b$var$_iconNew = $d9ae84e9cc622f9b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $d9ae84e9cc622f9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-delete
 * Usage guidance:
 * Reserved for deleting a table column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9ae84e9cc622f9b$var$TableColumnDeleteIcon = (props)=>/*#__PURE__*/ $d9ae84e9cc622f9b$var$_react.default.createElement($d9ae84e9cc622f9b$var$_iconNew.default, Object.assign({
        name: "TableColumnDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm11 6.25h-6v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$d9ae84e9cc622f9b$var$TableColumnDeleteIcon.displayName = 'TableColumnDeleteIcon';
var $d9ae84e9cc622f9b$var$_default = module.exports.default = $d9ae84e9cc622f9b$var$TableColumnDeleteIcon;

});

parcelRegister("7T6wF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f88c9202ad41652af953a050b1c0148>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5be2bb6016acc774$var$_react = $5be2bb6016acc774$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $5be2bb6016acc774$var$_iconNew = $5be2bb6016acc774$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $5be2bb6016acc774$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-move-left
 * Usage guidance:
 * Reserved for moving a table column to the left of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5be2bb6016acc774$var$TableColumnMoveLeftIcon = (props)=>/*#__PURE__*/ $5be2bb6016acc774$var$_react.default.createElement($5be2bb6016acc774$var$_iconNew.default, Object.assign({
        name: "TableColumnMoveLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.22 4.47l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72H6v-1.5H2.56l1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$5be2bb6016acc774$var$TableColumnMoveLeftIcon.displayName = 'TableColumnMoveLeftIcon';
var $5be2bb6016acc774$var$_default = module.exports.default = $5be2bb6016acc774$var$TableColumnMoveLeftIcon;

});

parcelRegister("cZ3rn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a13e9eb392e23a5cb46d94f5457326ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $973dd9bda8d2dcc3$var$_react = $973dd9bda8d2dcc3$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $973dd9bda8d2dcc3$var$_iconNew = $973dd9bda8d2dcc3$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $973dd9bda8d2dcc3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveRight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-column-move-right
 * Usage guidance:
 * Reserved for moving a table column to the right of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $973dd9bda8d2dcc3$var$TableColumnMoveRightIcon = (props)=>/*#__PURE__*/ $973dd9bda8d2dcc3$var$_react.default.createElement($973dd9bda8d2dcc3$var$_iconNew.default, Object.assign({
        name: "TableColumnMoveRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.78 1.97 3 3a.75.75 0 0 1 0 1.06l-3 3-1.06-1.06 1.72-1.72H10v-1.5h3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$973dd9bda8d2dcc3$var$TableColumnMoveRightIcon.displayName = 'TableColumnMoveRightIcon';
var $973dd9bda8d2dcc3$var$_default = module.exports.default = $973dd9bda8d2dcc3$var$TableColumnMoveRightIcon;

});

parcelRegister("9czSm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd7ac2615482fa596dfe409d6ad2a75c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b31103ec0df19d1$var$_react = $6b31103ec0df19d1$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $6b31103ec0df19d1$var$_iconNew = $6b31103ec0df19d1$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $6b31103ec0df19d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddAbove".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-add-above
 * Usage guidance:
 * Reserved for adding a table row above the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b31103ec0df19d1$var$TableRowAddAboveIcon = (props)=>/*#__PURE__*/ $6b31103ec0df19d1$var$_react.default.createElement($6b31103ec0df19d1$var$_iconNew.default, Object.assign({
        name: "TableRowAddAboveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm6.25-7.25H11v-1.5H8.75V0h-1.5v2.25H5v1.5h2.25V6h1.5z" clip-rule="evenodd"/>`
    }, props));
$6b31103ec0df19d1$var$TableRowAddAboveIcon.displayName = 'TableRowAddAboveIcon';
var $6b31103ec0df19d1$var$_default = module.exports.default = $6b31103ec0df19d1$var$TableRowAddAboveIcon;

});

parcelRegister("1YIVu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::088f872458a9690a9677799fea659be0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $170e3e71541121ed$var$_react = $170e3e71541121ed$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $170e3e71541121ed$var$_iconNew = $170e3e71541121ed$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $170e3e71541121ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddBelow".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-add-below
 * Usage guidance:
 * Reserved for adding a table row below the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $170e3e71541121ed$var$TableRowAddBelowIcon = (props)=>/*#__PURE__*/ $170e3e71541121ed$var$_react.default.createElement($170e3e71541121ed$var$_iconNew.default, Object.assign({
        name: "TableRowAddBelowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm6.25 7.25H11v1.5H8.75V16h-1.5v-2.25H5v-1.5h2.25V10h1.5z" clip-rule="evenodd"/>`
    }, props));
$170e3e71541121ed$var$TableRowAddBelowIcon.displayName = 'TableRowAddBelowIcon';
var $170e3e71541121ed$var$_default = module.exports.default = $170e3e71541121ed$var$TableRowAddBelowIcon;

});

parcelRegister("emJZF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0fcf16ec81cff8b9c1d330cfed0d8da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a756cc2965a78a43$var$_react = $a756cc2965a78a43$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $a756cc2965a78a43$var$_iconNew = $a756cc2965a78a43$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $a756cc2965a78a43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-delete
 * Usage guidance:
 * Reserved for deleting a table row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a756cc2965a78a43$var$TableRowDeleteIcon = (props)=>/*#__PURE__*/ $a756cc2965a78a43$var$_react.default.createElement($a756cc2965a78a43$var$_iconNew.default, Object.assign({
        name: "TableRowDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm8.5 7.25H5v1.5h6z" clip-rule="evenodd"/>`
    }, props));
$a756cc2965a78a43$var$TableRowDeleteIcon.displayName = 'TableRowDeleteIcon';
var $a756cc2965a78a43$var$_default = module.exports.default = $a756cc2965a78a43$var$TableRowDeleteIcon;

});

parcelRegister("2dUrS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bd0fd11ae86554914d37c1f7853fb66>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19e895305f66f6f7$var$_react = $19e895305f66f6f7$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $19e895305f66f6f7$var$_iconNew = $19e895305f66f6f7$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $19e895305f66f6f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveDown".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-move-down
 * Usage guidance:
 * Reserved for moving a table row below its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $19e895305f66f6f7$var$TableRowMoveDownIcon = (props)=>/*#__PURE__*/ $19e895305f66f6f7$var$_react.default.createElement($19e895305f66f6f7$var$_iconNew.default, Object.assign({
        name: "TableRowMoveDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm1.97 7.78 3 3a.75.75 0 0 0 1.06 0l3-3-1.06-1.06-1.72 1.72V10h-1.5v3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$19e895305f66f6f7$var$TableRowMoveDownIcon.displayName = 'TableRowMoveDownIcon';
var $19e895305f66f6f7$var$_default = module.exports.default = $19e895305f66f6f7$var$TableRowMoveDownIcon;

});

parcelRegister("dGstS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6658efa410614a3df4d5545c16ea7387>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f654a569cfa0282$var$_react = $9f654a569cfa0282$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9f654a569cfa0282$var$_iconNew = $9f654a569cfa0282$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9f654a569cfa0282$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveUp".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/table-row-move-up
 * Usage guidance:
 * Reserved for moving a table row above its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f654a569cfa0282$var$TableRowMoveUpIcon = (props)=>/*#__PURE__*/ $9f654a569cfa0282$var$_react.default.createElement($9f654a569cfa0282$var$_iconNew.default, Object.assign({
        name: "TableRowMoveUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm1.97-7.78 3-3a.75.75 0 0 1 1.06 0l3 3-1.06 1.06-1.72-1.72V6h-1.5V2.56L5.53 4.28z" clip-rule="evenodd"/>`
    }, props));
$9f654a569cfa0282$var$TableRowMoveUpIcon.displayName = 'TableRowMoveUpIcon';
var $9f654a569cfa0282$var$_default = module.exports.default = $9f654a569cfa0282$var$TableRowMoveUpIcon;

});

parcelRegister("6UJhm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::078cb0504cec10813042110e5e382485>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $508b187c2e0b25fa$var$_react = $508b187c2e0b25fa$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $508b187c2e0b25fa$var$_iconNew = $508b187c2e0b25fa$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $508b187c2e0b25fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStrikethrough".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-strikethrough
 * Usage guidance:
 * Reserved for strikethrough text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $508b187c2e0b25fa$var$TextStrikethroughIcon = (props)=>/*#__PURE__*/ $508b187c2e0b25fa$var$_react.default.createElement($508b187c2e0b25fa$var$_iconNew.default, Object.assign({
        name: "TextStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.47 2.5a2.12 2.12 0 0 0-1.79 3.25H4.03a3.59 3.59 0 0 1 .5-3.25A3.62 3.62 0 0 1 7.47 1h.93a4.08 4.08 0 0 1 3.19 1.53l-1.17.94A2.58 2.58 0 0 0 8.4 2.5zm3.51 7.75h1.58A3.82 3.82 0 0 1 8.86 15h-.67a4.5 4.5 0 0 1-4.11-2.67l-.01-.02 1.37-.61.01.02a3 3 0 0 0 2.74 1.78h.67a2.32 2.32 0 0 0 2.12-3.25m4.02-3H1v1.5h14z"/>`
    }, props));
$508b187c2e0b25fa$var$TextStrikethroughIcon.displayName = 'TextStrikethroughIcon';
var $508b187c2e0b25fa$var$_default = module.exports.default = $508b187c2e0b25fa$var$TextStrikethroughIcon;

});

parcelRegister("1TYzd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8428ad3e966f216a91f320cc6db50f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1629e8d2e6b8ef9b$var$_react = $1629e8d2e6b8ef9b$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $1629e8d2e6b8ef9b$var$_iconNew = $1629e8d2e6b8ef9b$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $1629e8d2e6b8ef9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextUnderline".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/text-underline
 * Usage guidance:
 * Reserved for underlined text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1629e8d2e6b8ef9b$var$TextUnderlineIcon = (props)=>/*#__PURE__*/ $1629e8d2e6b8ef9b$var$_react.default.createElement($1629e8d2e6b8ef9b$var$_iconNew.default, Object.assign({
        name: "TextUnderlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 8V1H5v7a3 3 0 0 0 6 0V1h1.5v7a4.5 4.5 0 1 1-9 0M0 16v-1.5h16V16z" clip-rule="evenodd"/>`
    }, props));
$1629e8d2e6b8ef9b$var$TextUnderlineIcon.displayName = 'TextUnderlineIcon';
var $1629e8d2e6b8ef9b$var$_default = module.exports.default = $1629e8d2e6b8ef9b$var$TextUnderlineIcon;

});

parcelRegister("hb5Zv", function(module, exports) {
$parcel$export(module.exports, "Bleed", () => $58ad56a8bbff8a2d$export$a8307195dd50fcbf);
/* bleed.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $58ad56a8bbff8a2d$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g4pxn",
    'inline.space.050': "_195ggp71",
    'inline.space.100': "_195gtdkl",
    'inline.space.150': "_195gkqjj",
    'inline.space.200': "_195g1e8l",
    'block.space.025': "_1mou4pxn",
    'block.space.050': "_1mougp71",
    'block.space.100': "_1moutdkl",
    'block.space.150': "_1moukqjj",
    'block.space.200': "_1mou1e8l"
};
const $58ad56a8bbff8a2d$export$a8307195dd50fcbf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: (0, $2R2iS.default)([
            $58ad56a8bbff8a2d$var$styles.root,
            all && $58ad56a8bbff8a2d$var$styles[`inline.${all}`],
            inline && $58ad56a8bbff8a2d$var$styles[`inline.${inline}`],
            all && $58ad56a8bbff8a2d$var$styles[`block.${all}`],
            block && $58ad56a8bbff8a2d$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$58ad56a8bbff8a2d$export$a8307195dd50fcbf.displayName = 'Bleed';

});

parcelRegister("6wtC0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6af9babf2be44dee$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $8bFXp = parcelRequire("8bFXp");
function $6af9babf2be44dee$export$2e2bcd8739ae039() {
    const tabPanelData = (0, $fc4bM.useContext)((0, $8bFXp.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
}

});

parcelRegister("h1Iql", function(module, exports) {
$parcel$export(module.exports, "isValidEmail", () => $6b290d2d04885184$export$371e338370561054);
const $6b290d2d04885184$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $6b290d2d04885184$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $6b290d2d04885184$export$371e338370561054 = (inputText)=>{
    if (inputText.match($6b290d2d04885184$var$validRegex)) return 'VALID';
    if (inputText.match($6b290d2d04885184$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});

parcelRegister("2vbgR", function(module, exports) {
$parcel$export(module.exports, "NodeDataProvider", () => $9ec34ada3aba645b$export$1185db7a00c13eed);

var $eVKpX = parcelRequire("eVKpX");
class $9ec34ada3aba645b$export$1185db7a00c13eed {
    constructor(){
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eVKpX.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if ((dataFromCache === null || dataFromCache === void 0 ? void 0 : dataFromCache.source) !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = (options === null || options === void 0 ? void 0 : options.strategy) ?? 'merge';
        const source = (options === null || options === void 0 ? void 0 : options.source) ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
}

});

parcelRegister("482EN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3019f864dd1cb608$export$2e2bcd8739ae039);

var $9IWSx = parcelRequire("9IWSx");

var $dJOwr = parcelRequire("dJOwr");

var $3mokv = parcelRequire("3mokv");
function $3019f864dd1cb608$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3mokv.default)(1, arguments);
    return (0, $9IWSx.default)(dirtyDate, (0, $dJOwr.default)(Date.now(), 1));
}

});
parcelRegister("dJOwr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a006aafd06a2b2c0$export$2e2bcd8739ae039);

var $l9NHW = parcelRequire("l9NHW");

var $3mokv = parcelRequire("3mokv");

var $1Cu8A = parcelRequire("1Cu8A");
function $a006aafd06a2b2c0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3mokv.default)(2, arguments);
    var amount = (0, $1Cu8A.default)(dirtyAmount);
    return (0, $l9NHW.default)(dirtyDate, -amount);
}

});
parcelRegister("l9NHW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f670ff2b89ca31c4$export$2e2bcd8739ae039);

var $1Cu8A = parcelRequire("1Cu8A");

var $a3cTc = parcelRequire("a3cTc");

var $3mokv = parcelRequire("3mokv");
function $f670ff2b89ca31c4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3mokv.default)(2, arguments);
    var date = (0, $a3cTc.default)(dirtyDate);
    var amount = (0, $1Cu8A.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});



parcelRegister("24ud9", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb4b0c8929e41e4f$export$2e2bcd8739ae039);
function $fb4b0c8929e41e4f$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Text color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happen when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("1i5T8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20ca6fda7b1aa7cbbe1381bbd0504e95>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f0c0a2af493cd41$var$_react = $0f0c0a2af493cd41$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $0f0c0a2af493cd41$var$_iconNew = $0f0c0a2af493cd41$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $0f0c0a2af493cd41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionCenterVertical".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-position-center-vertical
 * Usage guidance:
 * Center-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f0c0a2af493cd41$var$AlignPositionCenterVerticalIcon = (props)=>/*#__PURE__*/ $0f0c0a2af493cd41$var$_react.default.createElement($0f0c0a2af493cd41$var$_iconNew.default, Object.assign({
        name: "AlignPositionCenterVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-7 12.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M0 7.25h16v1.5H0z" clip-rule="evenodd"/>`
    }, props));
$0f0c0a2af493cd41$var$AlignPositionCenterVerticalIcon.displayName = 'AlignPositionCenterVerticalIcon';
var $0f0c0a2af493cd41$var$_default = module.exports.default = $0f0c0a2af493cd41$var$AlignPositionCenterVerticalIcon;

});

parcelRegister("9rkMP", function(module, exports) {
$parcel$export(module.exports, "mergeRefs", () => $6df6c2724dc39445$export$c9058316764c140e);

var $eHXaD = parcelRequire("eHXaD");

var $b61Ft = parcelRequire("b61Ft");
function $6df6c2724dc39445$export$c9058316764c140e(refs) {
    return (0, $b61Ft.createCallbackRef)(function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $eHXaD.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("b61Ft", function(module, exports) {
$parcel$export(module.exports, "createCallbackRef", () => $81418c77937d4da0$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $81418c77937d4da0$export$35a19128eb4acba4(callback) {
    var current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            var last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("2K9tn", function(module, exports) {
$parcel$export(module.exports, "isImagePreview", () => $bb9f74dacee4c7dc$export$5fe5572478566289);
const $bb9f74dacee4c7dc$export$5fe5572478566289 = (preview)=>!!preview.dimensions;

});

parcelRegister("7VjhB", function(module, exports) {
$parcel$export(module.exports, "BrowserLoader", () => $8e0703b8af77eaf1$export$3ce634ac4a869e2c);

var $fc4bM = parcelRequire("fc4bM");


class $8e0703b8af77eaf1$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    static #_ = this.displayName = 'AsyncBrowser';
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            Promise.resolve((parcelRequire("22fJ4"))),
            (parcelRequire("epAIk"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $8e0703b8af77eaf1$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $8e0703b8af77eaf1$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $8e0703b8af77eaf1$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("epAIk", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bmRRl"),
    $9dnsd("iGk5F")
]).then(()=>parcelRequire('bZtft'));

});


parcelRegister("2xqwi", function(module, exports) {
$parcel$export(module.exports, "ClipboardLoader", () => $ea2cb06543af4048$export$d7936799bf32b554);

var $fc4bM = parcelRequire("fc4bM");


class $ea2cb06543af4048$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    static #_ = this.displayName = 'AsyncClipboard';
    componentDidMount() {
        if (!this.state.Clipboard) Promise.all([
            Promise.resolve((parcelRequire("22fJ4"))),
            (parcelRequire("746SF"))
        ]).then(([mediaClient, clipboardModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $ea2cb06543af4048$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $ea2cb06543af4048$export$d7936799bf32b554.Clipboard
            });
        });
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args), this.state = {
            Clipboard: $ea2cb06543af4048$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("746SF", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bmRRl"),
    $9dnsd("hjMJC")
]).then(()=>parcelRequire('cLi7b'));

});


parcelRegister("29gdY", function(module, exports) {
$parcel$export(module.exports, "DropzoneLoader", () => $eaf6e9b79a004c3f$export$66201d263cd6342);

var $fc4bM = parcelRequire("fc4bM");



class $eaf6e9b79a004c3f$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    static #_ = this.displayName = 'AsyncDropzone';
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            Promise.resolve((parcelRequire("22fJ4"))),
            (parcelRequire("5IJl5")),
            (parcelRequire("6dE3n"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $eaf6e9b79a004c3f$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $eaf6e9b79a004c3f$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $eaf6e9b79a004c3f$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $eaf6e9b79a004c3f$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $eaf6e9b79a004c3f$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $eaf6e9b79a004c3f$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("5IJl5", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("bmRRl"),
    $9dnsd("aPldi")
]).then(()=>parcelRequire('2ocLw'));

});

parcelRegister("6dE3n", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("lVk50").then(()=>parcelRequire('69iqD'));

});


parcelRegister("iMGC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $51dcb38855eed1b7$export$2e2bcd8739ae039);

var $8p5Cv = parcelRequire("8p5Cv");
const $51dcb38855eed1b7$var$_default_1 = (0, $8p5Cv.defineMessages)({
    white: {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'Tooltip label for the white color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-blue': {
        id: 'fabric.theme.light-blue',
        defaultMessage: 'Light blue',
        description: 'Tooltip label for the light blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-teal': {
        id: 'fabric.theme.light-teal',
        defaultMessage: 'Light teal',
        description: 'Tooltip label for the light teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-green': {
        id: 'fabric.theme.light-green',
        defaultMessage: 'Light green',
        description: 'Tooltip label for the light green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-lime': {
        id: 'fabric.theme.light-lime',
        defaultMessage: 'Light lime',
        description: 'Tooltip label for the light lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-yellow': {
        id: 'fabric.theme.light-yellow',
        defaultMessage: 'Light yellow',
        description: 'Tooltip label for the light yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-orange': {
        id: 'fabric.theme.light-orange',
        defaultMessage: 'Light orange',
        description: 'Tooltip label for the light orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-red': {
        id: 'fabric.theme.light-red',
        defaultMessage: 'Light red',
        description: 'Tooltip label for the light red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-magenta': {
        id: 'fabric.theme.light-magenta',
        defaultMessage: 'Light magenta',
        description: 'Tooltip label for the light magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-purple': {
        id: 'fabric.theme.light-purple',
        defaultMessage: 'Light purple',
        description: 'Tooltip label for the light purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'light-gray': {
        id: 'fabric.theme.light-gray',
        defaultMessage: 'Light gray',
        description: 'Tooltip label for the light gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    blue: {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'Tooltip label for the blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    teal: {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'Tooltip label for the teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    green: {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'Tooltip label for the green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    yellow: {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'Tooltip label for the yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    red: {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'Tooltip label for the red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    orange: {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'Tooltip label for the orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    purple: {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'Tooltip label for the purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    gray: {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'Tooltip label for the gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-blue': {
        id: 'fabric.theme.dark-blue',
        defaultMessage: 'Dark blue',
        description: 'Tooltip label for the dark blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-teal': {
        id: 'fabric.theme.dark-teal',
        defaultMessage: 'Dark teal',
        description: 'Tooltip label for the dark teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-green': {
        id: 'fabric.theme.dark-green',
        defaultMessage: 'Dark green',
        description: 'Tooltip label for the dark green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-lime': {
        id: 'fabric.theme.dark-lime',
        defaultMessage: 'Dark lime',
        description: 'Tooltip label for the dark lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-yellow': {
        id: 'fabric.theme.dark-yellow',
        defaultMessage: 'Dark yellow',
        description: 'Tooltip label for the dark yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-orange': {
        id: 'fabric.theme.dark-orange',
        defaultMessage: 'Dark orange',
        description: 'Tooltip label for the dark orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-red': {
        id: 'fabric.theme.dark-red',
        defaultMessage: 'Dark red',
        description: 'Tooltip label for the dark red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-magenta': {
        id: 'fabric.theme.dark-magenta',
        defaultMessage: 'Dark magenta',
        description: 'Tooltip label for the dark magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'dark-purple': {
        id: 'fabric.theme.dark-purple',
        defaultMessage: 'Dark purple',
        description: 'Tooltip label for the dark purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-gray': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'Tooltip label for the subtle gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-gray': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'Tooltip label for the bold gray color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-lime': {
        id: 'fabric.theme.subtle-lime',
        defaultMessage: 'Subtle lime',
        description: 'Tooltip label for the subtle lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-lime': {
        id: 'fabric.theme.bold-lime',
        defaultMessage: 'Bold lime',
        description: 'Tooltip label for the bold lime color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-orange': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'Tooltip label for the subtle orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-orange': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'Tooltip label for the bold orange color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'subtle-magenta': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'Tooltip label for the subtle magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-magenta': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'Tooltip label for the bold magenta color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-blue': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'Tooltip label for the bold blue color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-teal': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'Tooltip label for the bold teal color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-green': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'Tooltip label for the bold green color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-yellow': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'Tooltip label for the bold yellow color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-red': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'Tooltip label for the bold red color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    'bold-purple': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'Tooltip label for the bold purple color swatch displayed in the editor toolbar color palette when users select text or highlight colors.'
    },
    // Colors only used in highlight palette
    'no-color': {
        id: 'fabric.theme.no-color',
        defaultMessage: 'No highlight',
        description: 'Tooltip for the no color option in the highlight color palette in the main editor toolbar'
    },
    lime: {
        id: 'fabric.theme.lime',
        defaultMessage: 'Lime',
        description: "Tooltip for the lime color used in the main toolbar's highlight color palette"
    },
    magenta: {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: "Tooltip for the magenta color used in the main toolbar's highlight color palette"
    }
});
var $51dcb38855eed1b7$export$2e2bcd8739ae039 = $51dcb38855eed1b7$var$_default_1;

});

parcelRegister("kF3dk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0aa213c3355572e$var$_react = $f0aa213c3355572e$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $f0aa213c3355572e$var$_iconNew = $f0aa213c3355572e$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $f0aa213c3355572e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0aa213c3355572e$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $f0aa213c3355572e$var$_react.default.createElement($f0aa213c3355572e$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f0aa213c3355572e$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $f0aa213c3355572e$var$_default = module.exports.default = $f0aa213c3355572e$var$WarningOutlineIcon;

});

parcelRegister("lwjfY", function(module, exports) {
$parcel$export(module.exports, "mapPaletteColor", () => $92a734661ec5d158$export$cf81161afbd9f18c);

var $24ud9 = parcelRequire("24ud9");

var $iMGC6 = parcelRequire("iMGC6");
const $92a734661ec5d158$export$cf81161afbd9f18c = (label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $24ud9.default)((0, $iMGC6.default), key);
    return {
        value: color,
        label: label,
        border: "var(--ds-border, #0B120E24)",
        message: message
    };
};

});

parcelRegister("4oU9q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f4a4c8e06306add$export$2e2bcd8739ae039);

var $63Q5S = parcelRequire("63Q5S");

var $24ud9 = parcelRequire("24ud9");

var $iMGC6 = parcelRequire("iMGC6");
const $1f4a4c8e06306add$var$cellBackgroundColorPalette = [];
(0, $63Q5S.tableBackgroundColorPalette).forEach((label, color)=>{
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $24ud9.default)((0, $iMGC6.default), key);
    $1f4a4c8e06306add$var$cellBackgroundColorPalette.push({
        value: color,
        label: label,
        border: (0, $63Q5S.tableBackgroundBorderColor),
        message: message
    });
});
var $1f4a4c8e06306add$export$2e2bcd8739ae039 = $1f4a4c8e06306add$var$cellBackgroundColorPalette;

});

parcelRegister("d8Zat", function(module, exports) {
$parcel$export(module.exports, "textColorPalette", () => $3ac73ff3dca5c450$export$25c6a5f643998d29);

var $7pWsE = parcelRequire("7pWsE");

var $lwjfY = parcelRequire("lwjfY");

const $3ac73ff3dca5c450$export$25c6a5f643998d29 = [];
(0, $7pWsE.colorPalette).forEach((label, color)=>{
    $3ac73ff3dca5c450$export$25c6a5f643998d29.push((0, $lwjfY.mapPaletteColor)(label, color));
});

});


//# sourceMappingURL=rich-text-editor-v2.921cdee5.js.map
